
export const communes = [
    {
        commune_name: "تيمقتن",
        commune_name_ascii: "Timekten",
        daira_name: "أولف",
        daira_name_ascii: "Aoulef",
        wilaya_code: 1,
        wilaya_name: "أدرار",
        wilaya_name_ascii: "Adrar"
    },
    {
        commune_name: "بودة",
        commune_name_ascii: "Bouda",
        daira_name: "أدرار",
        daira_name_ascii: "Adrar",
        wilaya_code: 1,
        wilaya_name: "أدرار",
        wilaya_name_ascii: "Adrar"
    },
    {
        commune_name: "أولاد أحمد تيمي",
        commune_name_ascii: "Ouled Ahmed Timmi",
        daira_name: "أدرار",
        daira_name_ascii: "Adrar",
        wilaya_code: 1,
        wilaya_name: "أدرار",
        wilaya_name_ascii: "Adrar"
    },
    {
        commune_name: "أدرار",
        commune_name_ascii: "Adrar",
        daira_name: "أدرار",
        daira_name_ascii: "Adrar",
        wilaya_code: 1,
        wilaya_name: "أدرار",
        wilaya_name_ascii: "Adrar"
    },
    {
        commune_name: "فنوغيل",
        commune_name_ascii: "Fenoughil",
        daira_name: "فنوغيل",
        daira_name_ascii: "Fenoughil",
        wilaya_code: 1,
        wilaya_name: "أدرار",
        wilaya_name_ascii: "Adrar"
    },
    {
        commune_name: "إن زغمير",
        commune_name_ascii: "In Zghmir",
        daira_name: "زاوية كنتة",
        daira_name_ascii: "Zaouiat Kounta",
        wilaya_code: 1,
        wilaya_name: "أدرار",
        wilaya_name_ascii: "Adrar"
    },
    {
        commune_name: "رقان",
        commune_name_ascii: "Reggane",
        daira_name: "رقان",
        daira_name_ascii: "Reggane",
        wilaya_code: 1,
        wilaya_name: "أدرار",
        wilaya_name_ascii: "Adrar"
    },
    {
        commune_name: "سالي",
        commune_name_ascii: "Sali",
        daira_name: "رقان",
        daira_name_ascii: "Reggane",
        wilaya_code: 1,
        wilaya_name: "أدرار",
        wilaya_name_ascii: "Adrar"
    },
    {
        commune_name: "السبع",
        commune_name_ascii: "Sebaa",
        daira_name: "تسابيت",
        daira_name_ascii: "Tsabit",
        wilaya_code: 1,
        wilaya_name: "أدرار",
        wilaya_name_ascii: "Adrar"
    },
    {
        commune_name: "تسابيت",
        commune_name_ascii: "Tsabit",
        daira_name: "تسابيت",
        daira_name_ascii: "Tsabit",
        wilaya_code: 1,
        wilaya_name: "أدرار",
        wilaya_name_ascii: "Adrar"
    },
    {
        commune_name: "تامست",
        commune_name_ascii: "Tamest",
        daira_name: "فنوغيل",
        daira_name_ascii: "Fenoughil",
        wilaya_code: 1,
        wilaya_name: "أدرار",
        wilaya_name_ascii: "Adrar"
    },
    {
        commune_name: "تامنطيط",
        commune_name_ascii: "Tamantit",
        daira_name: "فنوغيل",
        daira_name_ascii: "Fenoughil",
        wilaya_code: 1,
        wilaya_name: "أدرار",
        wilaya_name_ascii: "Adrar"
    },
    {
        commune_name: "تيت",
        commune_name_ascii: "Tit",
        daira_name: "أولف",
        daira_name_ascii: "Aoulef",
        wilaya_code: 1,
        wilaya_name: "أدرار",
        wilaya_name_ascii: "Adrar"
    },
    {
        commune_name: "زاوية كنتة",
        commune_name_ascii: "Zaouiet Kounta",
        daira_name: "زاوية كنتة",
        daira_name_ascii: "Zaouiat Kounta",
        wilaya_code: 1,
        wilaya_name: "أدرار",
        wilaya_name_ascii: "Adrar"
    },
    {
        commune_name: "اقبلي",
        commune_name_ascii: "Akabli",
        daira_name: "أولف",
        daira_name_ascii: "Aoulef",
        wilaya_code: 1,
        wilaya_name: "أدرار",
        wilaya_name_ascii: "Adrar"
    },
    {
        commune_name: "أولف",
        commune_name_ascii: "Aoulef",
        daira_name: "أولف",
        daira_name_ascii: "Aoulef",
        wilaya_code: 1,
        wilaya_name: "أدرار",
        wilaya_name_ascii: "Adrar"
    },
    {
        commune_name: "تلعصة",
        commune_name_ascii: "Talassa",
        daira_name: "أبو الحسن",
        daira_name_ascii: "Abou El Hassane",
        wilaya_code: 2,
        wilaya_name: " الشلف",
        wilaya_name_ascii: "Chlef"
    },
    {
        commune_name: "الزبوجة",
        commune_name_ascii: "Zeboudja",
        daira_name: "الزبوجة",
        daira_name_ascii: "Zeboudja",
        wilaya_code: 2,
        wilaya_name: " الشلف",
        wilaya_name_ascii: "Chlef"
    },
    {
        commune_name: "الحجاج",
        commune_name_ascii: "El Hadjadj",
        daira_name: "أولاد بن عبد القادر",
        daira_name_ascii: "Ouled Ben Abdelkader",
        wilaya_code: 2,
        wilaya_name: " الشلف",
        wilaya_name_ascii: "Chlef"
    },
    {
        commune_name: "أولاد بن عبد القادر",
        commune_name_ascii: "Ouled Ben Abdelkader",
        daira_name: "أولاد بن عبد القادر",
        daira_name_ascii: "Ouled Ben Abdelkader",
        wilaya_code: 2,
        wilaya_name: " الشلف",
        wilaya_name_ascii: "Chlef"
    },
    {
        commune_name: "عين مران",
        commune_name_ascii: "Ain Merane",
        daira_name: "عين مران",
        daira_name_ascii: "Ain Merane",
        wilaya_code: 2,
        wilaya_name: " الشلف",
        wilaya_name_ascii: "Chlef"
    },
    {
        commune_name: "بريرة",
        commune_name_ascii: "Breira",
        daira_name: "بني حواء",
        daira_name_ascii: "Beni Haoua",
        wilaya_code: 2,
        wilaya_name: " الشلف",
        wilaya_name_ascii: "Chlef"
    },
    {
        commune_name: "أولاد عباس",
        commune_name_ascii: "Ouled Abbes",
        daira_name: "وادي الفضة",
        daira_name_ascii: "Oued Fodda",
        wilaya_code: 2,
        wilaya_name: " الشلف",
        wilaya_name_ascii: "Chlef"
    },
    {
        commune_name: "وادي الفضة",
        commune_name_ascii: "Oued Fodda",
        daira_name: "وادي الفضة",
        daira_name_ascii: "Oued Fodda",
        wilaya_code: 2,
        wilaya_name: " الشلف",
        wilaya_name_ascii: "Chlef"
    },
    {
        commune_name: "بني راشد",
        commune_name_ascii: "Beni Rached",
        daira_name: "وادي الفضة",
        daira_name_ascii: "Oued Fodda",
        wilaya_code: 2,
        wilaya_name: " الشلف",
        wilaya_name_ascii: "Chlef"
    },
    {
        commune_name: "الهرانفة",
        commune_name_ascii: "Herenfa",
        daira_name: "عين مران",
        daira_name_ascii: "Ain Merane",
        wilaya_code: 2,
        wilaya_name: " الشلف",
        wilaya_name_ascii: "Chlef"
    },
    {
        commune_name: "تاجنة",
        commune_name_ascii: "Tadjena",
        daira_name: "أبو الحسن",
        daira_name_ascii: "Abou El Hassane",
        wilaya_code: 2,
        wilaya_name: " الشلف",
        wilaya_name_ascii: "Chlef"
    },
    {
        commune_name: "المرسى",
        commune_name_ascii: "El Marsa",
        daira_name: "المرسى",
        daira_name_ascii: "El Marsa",
        wilaya_code: 2,
        wilaya_name: " الشلف",
        wilaya_name_ascii: "Chlef"
    },
    {
        commune_name: "الشلف",
        commune_name_ascii: "Chlef",
        daira_name: "الشلف",
        daira_name_ascii: "Chlef",
        wilaya_code: 2,
        wilaya_name: " الشلف",
        wilaya_name_ascii: "Chlef"
    },
    {
        commune_name: "أم الدروع",
        commune_name_ascii: "Oum Drou",
        daira_name: "الشلف",
        daira_name_ascii: "Chlef",
        wilaya_code: 2,
        wilaya_name: " الشلف",
        wilaya_name_ascii: "Chlef"
    },
    {
        commune_name: "سنجاس",
        commune_name_ascii: "Sendjas",
        daira_name: "الشلف",
        daira_name_ascii: "Chlef",
        wilaya_code: 2,
        wilaya_name: " الشلف",
        wilaya_name_ascii: "Chlef"
    },
    {
        commune_name: "سيدي عبد الرحمن",
        commune_name_ascii: "Sidi Abderrahmane",
        daira_name: "تنس",
        daira_name_ascii: "Tenes",
        wilaya_code: 2,
        wilaya_name: " الشلف",
        wilaya_name_ascii: "Chlef"
    },
    {
        commune_name: "سيدي عكاشة",
        commune_name_ascii: "Sidi Akkacha",
        daira_name: "تنس",
        daira_name_ascii: "Tenes",
        wilaya_code: 2,
        wilaya_name: " الشلف",
        wilaya_name_ascii: "Chlef"
    },
    {
        commune_name: "تنس",
        commune_name_ascii: "Tenes",
        daira_name: "تنس",
        daira_name_ascii: "Tenes",
        wilaya_code: 2,
        wilaya_name: " الشلف",
        wilaya_name_ascii: "Chlef"
    },
    {
        commune_name: "بني بوعتاب",
        commune_name_ascii: "Beni  Bouattab",
        daira_name: "الكريمية",
        daira_name_ascii: "El Karimia",
        wilaya_code: 2,
        wilaya_name: " الشلف",
        wilaya_name_ascii: "Chlef"
    },
    {
        commune_name: "الكريمية",
        commune_name_ascii: "El Karimia",
        daira_name: "الكريمية",
        daira_name_ascii: "El Karimia",
        wilaya_code: 2,
        wilaya_name: " الشلف",
        wilaya_name_ascii: "Chlef"
    },
    {
        commune_name: "حرشون",
        commune_name_ascii: "Harchoun",
        daira_name: "الكريمية",
        daira_name_ascii: "El Karimia",
        wilaya_code: 2,
        wilaya_name: " الشلف",
        wilaya_name_ascii: "Chlef"
    },
    {
        commune_name: "بوزغاية",
        commune_name_ascii: "Bouzeghaia",
        daira_name: "الزبوجة",
        daira_name_ascii: "Zeboudja",
        wilaya_code: 2,
        wilaya_name: " الشلف",
        wilaya_name_ascii: "Chlef"
    },
    {
        commune_name: "تاوقريت",
        commune_name_ascii: "Taougrit",
        daira_name: "تاوقريت",
        daira_name_ascii: "Taougrit",
        wilaya_code: 2,
        wilaya_name: " الشلف",
        wilaya_name_ascii: "Chlef"
    },
    {
        commune_name: "بني حواء",
        commune_name_ascii: "Beni Haoua",
        daira_name: "بني حواء",
        daira_name_ascii: "Beni Haoua",
        wilaya_code: 2,
        wilaya_name: " الشلف",
        wilaya_name_ascii: "Chlef"
    },
    {
        commune_name: "أبو الحسن",
        commune_name_ascii: "Abou El Hassane",
        daira_name: "أبو الحسن",
        daira_name_ascii: "Abou El Hassane",
        wilaya_code: 2,
        wilaya_name: " الشلف",
        wilaya_name_ascii: "Chlef"
    },
    {
        commune_name: "وادي قوسين",
        commune_name_ascii: "Oued Goussine",
        daira_name: "بني حواء",
        daira_name_ascii: "Beni Haoua",
        wilaya_code: 2,
        wilaya_name: " الشلف",
        wilaya_name_ascii: "Chlef"
    },
    {
        commune_name: "الشطية",
        commune_name_ascii: "Chettia",
        daira_name: "أولاد فارس",
        daira_name_ascii: "Ouled Fares",
        wilaya_code: 2,
        wilaya_name: " الشلف",
        wilaya_name_ascii: "Chlef"
    },
    {
        commune_name: "مصدق",
        commune_name_ascii: "Moussadek",
        daira_name: "المرسى",
        daira_name_ascii: "El Marsa",
        wilaya_code: 2,
        wilaya_name: " الشلف",
        wilaya_name_ascii: "Chlef"
    },
    {
        commune_name: "أولاد فارس",
        commune_name_ascii: "Ouled Fares",
        daira_name: "أولاد فارس",
        daira_name_ascii: "Ouled Fares",
        wilaya_code: 2,
        wilaya_name: " الشلف",
        wilaya_name_ascii: "Chlef"
    },
    {
        commune_name: "بوقادير",
        commune_name_ascii: "Boukadir",
        daira_name: "بوقادير",
        daira_name_ascii: "Boukadir",
        wilaya_code: 2,
        wilaya_name: " الشلف",
        wilaya_name_ascii: "Chlef"
    },
    {
        commune_name: "وادي سلي",
        commune_name_ascii: "Oued Sly",
        daira_name: "بوقادير",
        daira_name_ascii: "Boukadir",
        wilaya_code: 2,
        wilaya_name: " الشلف",
        wilaya_name_ascii: "Chlef"
    },
    {
        commune_name: "الصبحة",
        commune_name_ascii: "Sobha",
        daira_name: "بوقادير",
        daira_name_ascii: "Boukadir",
        wilaya_code: 2,
        wilaya_name: " الشلف",
        wilaya_name_ascii: "Chlef"
    },
    {
        commune_name: "بنايرية",
        commune_name_ascii: "Benairia",
        daira_name: "الزبوجة",
        daira_name_ascii: "Zeboudja",
        wilaya_code: 2,
        wilaya_name: " الشلف",
        wilaya_name_ascii: "Chlef"
    },
    {
        commune_name: "الأبيض مجاجة",
        commune_name_ascii: "Labiod Medjadja",
        daira_name: "أولاد فارس",
        daira_name_ascii: "Ouled Fares",
        wilaya_code: 2,
        wilaya_name: " الشلف",
        wilaya_name_ascii: "Chlef"
    },
    {
        commune_name: "الظهرة",
        commune_name_ascii: "Dahra",
        daira_name: "تاوقريت",
        daira_name_ascii: "Taougrit",
        wilaya_code: 2,
        wilaya_name: " الشلف",
        wilaya_name_ascii: "Chlef"
    },
    {
        commune_name: "البيضاء",
        commune_name_ascii: "El Beidha",
        daira_name: "قتلة سيدي سعيد",
        daira_name_ascii: "Gueltat Sidi Saad",
        wilaya_code: 3,
        wilaya_name: "الأغواط",
        wilaya_name_ascii: "Laghouat"
    },
    {
        commune_name: "قلتة سيدي سعد",
        commune_name_ascii: "Gueltat Sidi Saad",
        daira_name: "قتلة سيدي سعيد",
        daira_name_ascii: "Gueltat Sidi Saad",
        wilaya_code: 3,
        wilaya_name: "الأغواط",
        wilaya_name_ascii: "Laghouat"
    },
    {
        commune_name: "بريدة",
        commune_name_ascii: "Brida",
        daira_name: "بريدة",
        daira_name_ascii: "Brida",
        wilaya_code: 3,
        wilaya_name: "الأغواط",
        wilaya_name_ascii: "Laghouat"
    },
    {
        commune_name: "عين سيدي علي",
        commune_name_ascii: "Ain Sidi Ali",
        daira_name: "قتلة سيدي سعيد",
        daira_name_ascii: "Gueltat Sidi Saad",
        wilaya_code: 3,
        wilaya_name: "الأغواط",
        wilaya_name_ascii: "Laghouat"
    },
    {
        commune_name: "تاجموت",
        commune_name_ascii: "Tadjemout",
        daira_name: "عين ماضي",
        daira_name_ascii: "Ain Madhi",
        wilaya_code: 3,
        wilaya_name: "الأغواط",
        wilaya_name_ascii: "Laghouat"
    },
    {
        commune_name: "الحاج مشري",
        commune_name_ascii: "Hadj Mechri",
        daira_name: "بريدة",
        daira_name_ascii: "Brida",
        wilaya_code: 3,
        wilaya_name: "الأغواط",
        wilaya_name_ascii: "Laghouat"
    },
    {
        commune_name: "تاويالة",
        commune_name_ascii: "Taouiala",
        daira_name: "بريدة",
        daira_name_ascii: "Brida",
        wilaya_code: 3,
        wilaya_name: "الأغواط",
        wilaya_name_ascii: "Laghouat"
    },
    {
        commune_name: "الغيشة",
        commune_name_ascii: "El Ghicha",
        daira_name: "الغيشة",
        daira_name_ascii: "El Ghicha",
        wilaya_code: 3,
        wilaya_name: "الأغواط",
        wilaya_name_ascii: "Laghouat"
    },
    {
        commune_name: "تاجرونة",
        commune_name_ascii: "Tadjrouna",
        daira_name: "عين ماضي",
        daira_name_ascii: "Ain Madhi",
        wilaya_code: 3,
        wilaya_name: "الأغواط",
        wilaya_name_ascii: "Laghouat"
    },
    {
        commune_name: "سبقاق",
        commune_name_ascii: "Sebgag",
        daira_name: "أفلو",
        daira_name_ascii: "Aflou",
        wilaya_code: 3,
        wilaya_name: "الأغواط",
        wilaya_name_ascii: "Laghouat"
    },
    {
        commune_name: "سيدي بوزيد",
        commune_name_ascii: "Sidi Bouzid",
        daira_name: "أفلو",
        daira_name_ascii: "Aflou",
        wilaya_code: 3,
        wilaya_name: "الأغواط",
        wilaya_name_ascii: "Laghouat"
    },
    {
        commune_name: "وادي مرة",
        commune_name_ascii: "Oued Morra",
        daira_name: "وادي مرة",
        daira_name_ascii: "Oued Morra",
        wilaya_code: 3,
        wilaya_name: "الأغواط",
        wilaya_name_ascii: "Laghouat"
    },
    {
        commune_name: "الأغواط",
        commune_name_ascii: "Laghouat",
        daira_name: "الأغواط",
        daira_name_ascii: "Laghouat",
        wilaya_code: 3,
        wilaya_name: "الأغواط",
        wilaya_name_ascii: "Laghouat"
    },
    {
        commune_name: "وادي مزي",
        commune_name_ascii: "Oued M'zi",
        daira_name: "وادي مرة",
        daira_name_ascii: "Oued Morra",
        wilaya_code: 3,
        wilaya_name: "الأغواط",
        wilaya_name_ascii: "Laghouat"
    },
    {
        commune_name: "قصر الحيران",
        commune_name_ascii: "Ksar El Hirane",
        daira_name: "قصر الحيران",
        daira_name_ascii: "Ksar El Hirane",
        wilaya_code: 3,
        wilaya_name: "الأغواط",
        wilaya_name_ascii: "Laghouat"
    },
    {
        commune_name: "العسافية",
        commune_name_ascii: "El Assafia",
        daira_name: "سيدي مخلوف",
        daira_name_ascii: "Sidi Makhlouf",
        wilaya_code: 3,
        wilaya_name: "الأغواط",
        wilaya_name_ascii: "Laghouat"
    },
    {
        commune_name: "سيدي مخلوف",
        commune_name_ascii: "Sidi Makhlouf",
        daira_name: "سيدي مخلوف",
        daira_name_ascii: "Sidi Makhlouf",
        wilaya_code: 3,
        wilaya_name: "الأغواط",
        wilaya_name_ascii: "Laghouat"
    },
    {
        commune_name: "حاسي الدلاعة",
        commune_name_ascii: "Hassi Delaa",
        daira_name: "حاسي الرمل",
        daira_name_ascii: "Hassi R'mel",
        wilaya_code: 3,
        wilaya_name: "الأغواط",
        wilaya_name_ascii: "Laghouat"
    },
    {
        commune_name: "حاسي الرمل",
        commune_name_ascii: "Hassi R'mel",
        daira_name: "حاسي الرمل",
        daira_name_ascii: "Hassi R'mel",
        wilaya_code: 3,
        wilaya_name: "الأغواط",
        wilaya_name_ascii: "Laghouat"
    },
    {
        commune_name: "عين ماضي",
        commune_name_ascii: "Ain Madhi",
        daira_name: "عين ماضي",
        daira_name_ascii: "Ain Madhi",
        wilaya_code: 3,
        wilaya_name: "الأغواط",
        wilaya_name_ascii: "Laghouat"
    },
    {
        commune_name: "الحويطة",
        commune_name_ascii: "El Haouaita",
        daira_name: "عين ماضي",
        daira_name_ascii: "Ain Madhi",
        wilaya_code: 3,
        wilaya_name: "الأغواط",
        wilaya_name_ascii: "Laghouat"
    },
    {
        commune_name: "الخنق",
        commune_name_ascii: "Kheneg",
        daira_name: "عين ماضي",
        daira_name_ascii: "Ain Madhi",
        wilaya_code: 3,
        wilaya_name: "الأغواط",
        wilaya_name_ascii: "Laghouat"
    },
    {
        commune_name: "بن ناصر بن شهرة",
        commune_name_ascii: "Benacer Benchohra",
        daira_name: "قصر الحيران",
        daira_name_ascii: "Ksar El Hirane",
        wilaya_code: 3,
        wilaya_name: "الأغواط",
        wilaya_name_ascii: "Laghouat"
    },
    {
        commune_name: "أفلو",
        commune_name_ascii: "Aflou",
        daira_name: "أفلو",
        daira_name_ascii: "Aflou",
        wilaya_code: 3,
        wilaya_name: "الأغواط",
        wilaya_name_ascii: "Laghouat"
    },
    {
        commune_name: "فكيرينة",
        commune_name_ascii: "Fkirina",
        daira_name: "فكيرينة",
        daira_name_ascii: "F'kirina",
        wilaya_code: 4,
        wilaya_name: "أم البواقي",
        wilaya_name_ascii: "Oum El Bouaghi"
    },
    {
        commune_name: "الفجوج بوغرارة سعودي",
        commune_name_ascii: "El Fedjoudj Boughrara Sa",
        daira_name: "عين فكرون",
        daira_name_ascii: "Ain Fekroun",
        wilaya_code: 4,
        wilaya_name: "أم البواقي",
        wilaya_name_ascii: "Oum El Bouaghi"
    },
    {
        commune_name: "عين فكرون",
        commune_name_ascii: "Ain Fekroun",
        daira_name: "عين فكرون",
        daira_name_ascii: "Ain Fekroun",
        wilaya_code: 4,
        wilaya_name: "أم البواقي",
        wilaya_name_ascii: "Oum El Bouaghi"
    },
    {
        commune_name: "الرحية",
        commune_name_ascii: "Rahia",
        daira_name: "مسكيانة",
        daira_name_ascii: "Meskiana",
        wilaya_code: 4,
        wilaya_name: "أم البواقي",
        wilaya_name_ascii: "Oum El Bouaghi"
    },
    {
        commune_name: "مسكيانة",
        commune_name_ascii: "Meskiana",
        daira_name: "مسكيانة",
        daira_name_ascii: "Meskiana",
        wilaya_code: 4,
        wilaya_name: "أم البواقي",
        wilaya_name_ascii: "Oum El Bouaghi"
    },
    {
        commune_name: "البلالة",
        commune_name_ascii: "El Belala",
        daira_name: "مسكيانة",
        daira_name_ascii: "Meskiana",
        wilaya_code: 4,
        wilaya_name: "أم البواقي",
        wilaya_name_ascii: "Oum El Bouaghi"
    },
    {
        commune_name: "بحير الشرقي",
        commune_name_ascii: "Behir Chergui",
        daira_name: "مسكيانة",
        daira_name_ascii: "Meskiana",
        wilaya_code: 4,
        wilaya_name: "أم البواقي",
        wilaya_name_ascii: "Oum El Bouaghi"
    },
    {
        commune_name: "قصر الصباحي",
        commune_name_ascii: "Ksar Sbahi",
        daira_name: "قصر الصباحي",
        daira_name_ascii: "Ksar Sbahi",
        wilaya_code: 4,
        wilaya_name: "أم البواقي",
        wilaya_name_ascii: "Oum El Bouaghi"
    },
    {
        commune_name: "سوق نعمان",
        commune_name_ascii: "Souk Naamane",
        daira_name: "سوق نعمان",
        daira_name_ascii: "Souk Naamane",
        wilaya_code: 4,
        wilaya_name: "أم البواقي",
        wilaya_name_ascii: "Oum El Bouaghi"
    },
    {
        commune_name: "أولاد زواي",
        commune_name_ascii: "Ouled Zouai",
        daira_name: "سوق نعمان",
        daira_name_ascii: "Souk Naamane",
        wilaya_code: 4,
        wilaya_name: "أم البواقي",
        wilaya_name_ascii: "Oum El Bouaghi"
    },
    {
        commune_name: "أم البواقي",
        commune_name_ascii: "Oum El Bouaghi",
        daira_name: "أم البواقي",
        daira_name_ascii: "Oum El Bouaghi",
        wilaya_code: 4,
        wilaya_name: "أم البواقي",
        wilaya_name_ascii: "Oum El Bouaghi"
    },
    {
        commune_name: "عين ببوش",
        commune_name_ascii: "Ain Babouche",
        daira_name: "عين ببوش",
        daira_name_ascii: "Ain Babouche",
        wilaya_code: 4,
        wilaya_name: "أم البواقي",
        wilaya_name_ascii: "Oum El Bouaghi"
    },
    {
        commune_name: "عين الزيتون",
        commune_name_ascii: "Ain Zitoun",
        daira_name: "أم البواقي",
        daira_name_ascii: "Oum El Bouaghi",
        wilaya_code: 4,
        wilaya_name: "أم البواقي",
        wilaya_name_ascii: "Oum El Bouaghi"
    },
    {
        commune_name: "بئر الشهداء",
        commune_name_ascii: "Bir Chouhada",
        daira_name: "سوق نعمان",
        daira_name_ascii: "Souk Naamane",
        wilaya_code: 4,
        wilaya_name: "أم البواقي",
        wilaya_name_ascii: "Oum El Bouaghi"
    },
    {
        commune_name: "عين البيضاء",
        commune_name_ascii: "Ain Beida",
        daira_name: "عين البيضاء",
        daira_name_ascii: "Ain Beida",
        wilaya_code: 4,
        wilaya_name: "أم البواقي",
        wilaya_name_ascii: "Oum El Bouaghi"
    },
    {
        commune_name: "بريش",
        commune_name_ascii: "Berriche",
        daira_name: "عين البيضاء",
        daira_name_ascii: "Ain Beida",
        wilaya_code: 4,
        wilaya_name: "أم البواقي",
        wilaya_name_ascii: "Oum El Bouaghi"
    },
    {
        commune_name: "الزرق",
        commune_name_ascii: "Zorg",
        daira_name: "عين البيضاء",
        daira_name_ascii: "Ain Beida",
        wilaya_code: 4,
        wilaya_name: "أم البواقي",
        wilaya_name_ascii: "Oum El Bouaghi"
    },
    {
        commune_name: "عين مليلة",
        commune_name_ascii: "Ain M'lila",
        daira_name: "عين مليلة",
        daira_name_ascii: "Ain M'lila",
        wilaya_code: 4,
        wilaya_name: "أم البواقي",
        wilaya_name_ascii: "Oum El Bouaghi"
    },
    {
        commune_name: "أولاد قاسم",
        commune_name_ascii: "Ouled Gacem",
        daira_name: "عين مليلة",
        daira_name_ascii: "Ain M'lila",
        wilaya_code: 4,
        wilaya_name: "أم البواقي",
        wilaya_name_ascii: "Oum El Bouaghi"
    },
    {
        commune_name: "أولاد حملة",
        commune_name_ascii: "Ouled Hamla",
        daira_name: "عين مليلة",
        daira_name_ascii: "Ain M'lila",
        wilaya_code: 4,
        wilaya_name: "أم البواقي",
        wilaya_name_ascii: "Oum El Bouaghi"
    },
    {
        commune_name: "العامرية",
        commune_name_ascii: "El Amiria",
        daira_name: "سيقوس",
        daira_name_ascii: "Sigus",
        wilaya_code: 4,
        wilaya_name: "أم البواقي",
        wilaya_name_ascii: "Oum El Bouaghi"
    },
    {
        commune_name: "سيقوس",
        commune_name_ascii: "Sigus",
        daira_name: "سيقوس",
        daira_name_ascii: "Sigus",
        wilaya_code: 4,
        wilaya_name: "أم البواقي",
        wilaya_name_ascii: "Oum El Bouaghi"
    },
    {
        commune_name: "وادي نيني",
        commune_name_ascii: "Oued Nini",
        daira_name: "فكيرينة",
        daira_name_ascii: "F'kirina",
        wilaya_code: 4,
        wilaya_name: "أم البواقي",
        wilaya_name_ascii: "Oum El Bouaghi"
    },
    {
        commune_name: "عين الديس",
        commune_name_ascii: "Ain Diss",
        daira_name: "عين ببوش",
        daira_name_ascii: "Ain Babouche",
        wilaya_code: 4,
        wilaya_name: "أم البواقي",
        wilaya_name_ascii: "Oum El Bouaghi"
    },
    {
        commune_name: "الضلعة",
        commune_name_ascii: "Dhalaa",
        daira_name: "الضلعة",
        daira_name_ascii: "Dhalaa",
        wilaya_code: 4,
        wilaya_name: "أم البواقي",
        wilaya_name_ascii: "Oum El Bouaghi"
    },
    {
        commune_name: "الجازية",
        commune_name_ascii: "El Djazia",
        daira_name: "الضلعة",
        daira_name_ascii: "Dhalaa",
        wilaya_code: 4,
        wilaya_name: "أم البواقي",
        wilaya_name_ascii: "Oum El Bouaghi"
    },
    {
        commune_name: "عين كرشة",
        commune_name_ascii: "Ain Kercha",
        daira_name: "عين كرشة",
        daira_name_ascii: "Ain Kercha",
        wilaya_code: 4,
        wilaya_name: "أم البواقي",
        wilaya_name_ascii: "Oum El Bouaghi"
    },
    {
        commune_name: "الحرملية",
        commune_name_ascii: "El Harmilia",
        daira_name: "عين كرشة",
        daira_name_ascii: "Ain Kercha",
        wilaya_code: 4,
        wilaya_name: "أم البواقي",
        wilaya_name_ascii: "Oum El Bouaghi"
    },
    {
        commune_name: "هنشير تومغني",
        commune_name_ascii: "Hanchir Toumghani",
        daira_name: "عين كرشة",
        daira_name_ascii: "Ain Kercha",
        wilaya_code: 4,
        wilaya_name: "أم البواقي",
        wilaya_name_ascii: "Oum El Bouaghi"
    },
    {
        commune_name: "معافة",
        commune_name_ascii: "Maafa",
        daira_name: "عين التوتة",
        daira_name_ascii: "Ain Touta",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "القصبات",
        commune_name_ascii: "Gosbat",
        daira_name: "رأس العيون",
        daira_name_ascii: "Ras El Aioun",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "تيمقاد",
        commune_name_ascii: "Timgad",
        daira_name: "تيمقاد",
        daira_name_ascii: "Timgad",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "تاكسلانت",
        commune_name_ascii: "Taxlent",
        daira_name: "أولاد سي سليمان",
        daira_name_ascii: "Ouled Si Slimane",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "أولاد سي سليمان",
        commune_name_ascii: "Ouled Si Slimane",
        daira_name: "أولاد سي سليمان",
        daira_name_ascii: "Ouled Si Slimane",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "لمسان",
        commune_name_ascii: "Lemcene",
        daira_name: "أولاد سي سليمان",
        daira_name_ascii: "Ouled Si Slimane",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "تالخمت",
        commune_name_ascii: "Talkhamt",
        daira_name: "رأس العيون",
        daira_name_ascii: "Ras El Aioun",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "رأس العيون",
        commune_name_ascii: "Ras El Aioun",
        daira_name: "رأس العيون",
        daira_name_ascii: "Ras El Aioun",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "الرحبات",
        commune_name_ascii: "Rahbat",
        daira_name: "رأس العيون",
        daira_name_ascii: "Ras El Aioun",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "أولاد سلام",
        commune_name_ascii: "Ouled Sellem",
        daira_name: "رأس العيون",
        daira_name_ascii: "Ras El Aioun",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "القيقبة",
        commune_name_ascii: "Guigba",
        daira_name: "رأس العيون",
        daira_name_ascii: "Ras El Aioun",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "ثنية العابد",
        commune_name_ascii: "Teniet El Abed",
        daira_name: "ثنية العابد",
        daira_name_ascii: "Theniet El Abed",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "باتنة",
        commune_name_ascii: "Batna",
        daira_name: "باتنة",
        daira_name_ascii: "Batna",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "فسديس",
        commune_name_ascii: "Fesdis",
        daira_name: "باتنة",
        daira_name_ascii: "Batna",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "وادي الشعبة",
        commune_name_ascii: "Oued Chaaba",
        daira_name: "باتنة",
        daira_name_ascii: "Batna",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "حيدوسة",
        commune_name_ascii: "Hidoussa",
        daira_name: "مروانة",
        daira_name_ascii: "Merouana",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "قصر بلزمة",
        commune_name_ascii: "Ksar Bellezma",
        daira_name: "مروانة",
        daira_name_ascii: "Merouana",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "مروانة",
        commune_name_ascii: "Merouana",
        daira_name: "مروانة",
        daira_name_ascii: "Merouana",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "وادي الماء",
        commune_name_ascii: "Oued El Ma",
        daira_name: "مروانة",
        daira_name_ascii: "Merouana",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "لازرو",
        commune_name_ascii: "Lazrou",
        daira_name: "سريانة",
        daira_name_ascii: "Seriana",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "سريانة",
        commune_name_ascii: "Seriana",
        daira_name: "سريانة",
        daira_name_ascii: "Seriana",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "زانة البيضاء",
        commune_name_ascii: "Zanet El Beida",
        daira_name: "سريانة",
        daira_name_ascii: "Seriana",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "منعة",
        commune_name_ascii: "Menaa",
        daira_name: "منعة",
        daira_name_ascii: "Menaa",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "تغرغار",
        commune_name_ascii: "Tigharghar",
        daira_name: "منعة",
        daira_name_ascii: "Menaa",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "عين ياقوت",
        commune_name_ascii: "Ain Yagout",
        daira_name: "المعذر",
        daira_name_ascii: "El Madher",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "بومية",
        commune_name_ascii: "Boumia",
        daira_name: "المعذر",
        daira_name_ascii: "El Madher",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "جرمة",
        commune_name_ascii: "Djerma",
        daira_name: "المعذر",
        daira_name_ascii: "El Madher",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "المعذر",
        commune_name_ascii: "El Madher",
        daira_name: "المعذر",
        daira_name_ascii: "El Madher",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "عيون العصافير",
        commune_name_ascii: "Ouyoun El Assafir",
        daira_name: "تازولت",
        daira_name_ascii: "Tazoult",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "تازولت",
        commune_name_ascii: "Tazoult",
        daira_name: "تازولت",
        daira_name_ascii: "Tazoult",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "بومقر",
        commune_name_ascii: "Boumagueur",
        daira_name: "نقاوس",
        daira_name_ascii: "N'gaous",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "نقاوس",
        commune_name_ascii: "N Gaous",
        daira_name: "نقاوس",
        daira_name_ascii: "N'gaous",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "سفيان",
        commune_name_ascii: "Sefiane",
        daira_name: "نقاوس",
        daira_name_ascii: "N'gaous",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "أريس",
        commune_name_ascii: "Arris",
        daira_name: "أريس",
        daira_name_ascii: "Arris",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "تيغانمين",
        commune_name_ascii: "Tighanimine",
        daira_name: "أريس",
        daira_name_ascii: "Arris",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "عين جاسر",
        commune_name_ascii: "Ain Djasser",
        daira_name: "عين جاسر",
        daira_name_ascii: "Ain Djasser",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "الحاسي",
        commune_name_ascii: "El Hassi",
        daira_name: "عين جاسر",
        daira_name_ascii: "Ain Djasser",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "سقانة",
        commune_name_ascii: "Seggana",
        daira_name: "سقانة",
        daira_name_ascii: "Seggana",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "تيلاطو",
        commune_name_ascii: "Tilatou",
        daira_name: "سقانة",
        daira_name_ascii: "Seggana",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "فم الطوب",
        commune_name_ascii: "Foum Toub",
        daira_name: "إشمول",
        daira_name_ascii: "Ichemoul",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "إشمول",
        commune_name_ascii: "Ichemoul",
        daira_name: "إشمول",
        daira_name_ascii: "Ichemoul",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "إينوغيسن",
        commune_name_ascii: "Inoughissen",
        daira_name: "إشمول",
        daira_name_ascii: "Ichemoul",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "بوزينة",
        commune_name_ascii: "Bouzina",
        daira_name: "بوزينة",
        daira_name_ascii: "Bouzina",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "لارباع",
        commune_name_ascii: "Larbaa",
        daira_name: "بوزينة",
        daira_name_ascii: "Bouzina",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "بولهيلات",
        commune_name_ascii: "Boulhilat",
        daira_name: "الشمرة",
        daira_name_ascii: "Chemora",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "الشمرة",
        commune_name_ascii: "Chemora",
        daira_name: "الشمرة",
        daira_name_ascii: "Chemora",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "بريكة",
        commune_name_ascii: "Barika",
        daira_name: "بريكة",
        daira_name_ascii: "Barika",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "بيطام",
        commune_name_ascii: "Bitam",
        daira_name: "بريكة",
        daira_name_ascii: "Barika",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "إمدوكل",
        commune_name_ascii: "M Doukal",
        daira_name: "بريكة",
        daira_name_ascii: "Barika",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "عزيل عبد القادر",
        commune_name_ascii: "Azil Abedelkader",
        daira_name: "الجزار",
        daira_name_ascii: "Djezzar",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "الجزار",
        commune_name_ascii: "Djezzar",
        daira_name: "الجزار",
        daira_name_ascii: "Djezzar",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "أولاد عمار",
        commune_name_ascii: "Ouled Ammar",
        daira_name: "الجزار",
        daira_name_ascii: "Djezzar",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "غسيرة",
        commune_name_ascii: "Ghassira",
        daira_name: "تكوت",
        daira_name_ascii: "Tkout",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "كيمل",
        commune_name_ascii: "Kimmel",
        daira_name: "تكوت",
        daira_name_ascii: "Tkout",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "تكوت",
        commune_name_ascii: "T Kout",
        daira_name: "تكوت",
        daira_name_ascii: "Tkout",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "عين التوتة",
        commune_name_ascii: "Ain Touta",
        daira_name: "عين التوتة",
        daira_name_ascii: "Ain Touta",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "بني فضالة الحقانية",
        commune_name_ascii: "Beni Foudhala El Hakania",
        daira_name: "عين التوتة",
        daira_name_ascii: "Ain Touta",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "أولاد فاضل",
        commune_name_ascii: "Ouled Fadel",
        daira_name: "تيمقاد",
        daira_name_ascii: "Timgad",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "أولاد عوف",
        commune_name_ascii: "Ouled Aouf",
        daira_name: "عين التوتة",
        daira_name_ascii: "Ain Touta",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "شير",
        commune_name_ascii: "Chir",
        daira_name: "ثنية العابد",
        daira_name_ascii: "Theniet El Abed",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "وادي الطاقة",
        commune_name_ascii: "Oued Taga",
        daira_name: "ثنية العابد",
        daira_name_ascii: "Theniet El Abed",
        wilaya_code: 5,
        wilaya_name: "باتنة",
        wilaya_name_ascii: "Batna"
    },
    {
        commune_name: "سيدي عياد",
        commune_name_ascii: "Sidi Ayad",
        daira_name: "سيدي عيش",
        daira_name_ascii: "Sidi Aich",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "برباشة",
        commune_name_ascii: "Barbacha",
        daira_name: "برباشة",
        daira_name_ascii: "Barbacha",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "الفلاي",
        commune_name_ascii: "Leflaye",
        daira_name: "سيدي عيش",
        daira_name_ascii: "Sidi Aich",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "كنديرة",
        commune_name_ascii: "Kendira",
        daira_name: "برباشة",
        daira_name_ascii: "Barbacha",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "سيدي عيش",
        commune_name_ascii: "Sidi-Aich",
        daira_name: "سيدي عيش",
        daira_name_ascii: "Sidi Aich",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "تيفرة",
        commune_name_ascii: "Tifra",
        daira_name: "سيدي عيش",
        daira_name_ascii: "Sidi Aich",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "تينبدار",
        commune_name_ascii: "Tinebdar",
        daira_name: "سيدي عيش",
        daira_name_ascii: "Sidi Aich",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "القصر",
        commune_name_ascii: "El Kseur",
        daira_name: "القصر",
        daira_name_ascii: "El Kseur",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "فناية الماثن",
        commune_name_ascii: "Fenaia Il Maten",
        daira_name: "القصر",
        daira_name_ascii: "El Kseur",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "توجة",
        commune_name_ascii: "Toudja",
        daira_name: "القصر",
        daira_name_ascii: "El Kseur",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "ذراع القايد",
        commune_name_ascii: "Dra El Caid",
        daira_name: "خراطة",
        daira_name_ascii: "Kherrata",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "خراطة",
        commune_name_ascii: "Kherrata",
        daira_name: "خراطة",
        daira_name_ascii: "Kherrata",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "بجاية",
        commune_name_ascii: "Bejaia",
        daira_name: "بجاية",
        daira_name_ascii: "Bejaia",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "وادي غير",
        commune_name_ascii: "Oued Ghir",
        daira_name: "بجاية",
        daira_name_ascii: "Bejaia",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "بني معوش",
        commune_name_ascii: "Benimaouche",
        daira_name: "بني معوش",
        daira_name_ascii: "Beni Maouche",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "بني جليل",
        commune_name_ascii: "Beni Djellil",
        daira_name: "أميزور",
        daira_name_ascii: "Amizour",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "فرعون",
        commune_name_ascii: "Feraoun",
        daira_name: "أميزور",
        daira_name_ascii: "Amizour",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "سمعون",
        commune_name_ascii: "Smaoun",
        daira_name: "أميزور",
        daira_name_ascii: "Amizour",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "تيمزريت",
        commune_name_ascii: "Timezrit",
        daira_name: "تيمزريت",
        daira_name_ascii: "Timezrit",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "مالبو",
        commune_name_ascii: "Melbou",
        daira_name: "سوق الإثنين",
        daira_name_ascii: "Souk El Tenine",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "سوق لإثنين",
        commune_name_ascii: "Souk El Tenine",
        daira_name: "سوق الإثنين",
        daira_name_ascii: "Souk El Tenine",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "تامريجت",
        commune_name_ascii: "Tamridjet",
        daira_name: "سوق الإثنين",
        daira_name_ascii: "Souk El Tenine",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "بوخليفة",
        commune_name_ascii: "Boukhelifa",
        daira_name: "تيشي",
        daira_name_ascii: "Tichy",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "تالة حمزة",
        commune_name_ascii: "Tala Hamza",
        daira_name: "تيشي",
        daira_name_ascii: "Tichy",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "تيشي",
        commune_name_ascii: "Tichy",
        daira_name: "تيشي",
        daira_name_ascii: "Tichy",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "أيت رزين",
        commune_name_ascii: "Ait R'zine",
        daira_name: "إغيل علي",
        daira_name_ascii: "Ighil Ali",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "إغيل علي",
        commune_name_ascii: "Ighil-Ali",
        daira_name: "إغيل علي",
        daira_name_ascii: "Ighil Ali",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "أيت إسماعيل",
        commune_name_ascii: "Ait-Smail",
        daira_name: "درقينة",
        daira_name_ascii: "Darguina",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "درقينة",
        commune_name_ascii: "Darguina",
        daira_name: "درقينة",
        daira_name_ascii: "Darguina",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "تاسكريوت",
        commune_name_ascii: "Taskriout",
        daira_name: "درقينة",
        daira_name_ascii: "Darguina",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "أوقاس",
        commune_name_ascii: "Aokas",
        daira_name: "أوقاس",
        daira_name_ascii: "Aokas",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "تيزي نبربر",
        commune_name_ascii: "Tizi-N'berber",
        daira_name: "أوقاس",
        daira_name_ascii: "Aokas",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "أدكار",
        commune_name_ascii: "Adekar",
        daira_name: "أدكار",
        daira_name_ascii: "Adekar",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "بني كسيلة",
        commune_name_ascii: "Beni K'sila",
        daira_name: "أدكار",
        daira_name_ascii: "Adekar",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "تاوريرت إغيل",
        commune_name_ascii: "Taourit Ighil",
        daira_name: "أدكار",
        daira_name_ascii: "Adekar",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "أقبو",
        commune_name_ascii: "Akbou",
        daira_name: "أقبو",
        daira_name_ascii: "Akbou",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "شلاطة",
        commune_name_ascii: "Chellata",
        daira_name: "أقبو",
        daira_name_ascii: "Akbou",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "اغرم",
        commune_name_ascii: "Ighram",
        daira_name: "أقبو",
        daira_name_ascii: "Akbou",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "تامقرة",
        commune_name_ascii: "Tamokra",
        daira_name: "أقبو",
        daira_name_ascii: "Akbou",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "أمالو",
        commune_name_ascii: "Amalou",
        daira_name: "صدوق",
        daira_name_ascii: "Seddouk",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "بوحمزة",
        commune_name_ascii: "Bouhamza",
        daira_name: "صدوق",
        daira_name_ascii: "Seddouk",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "مسيسنة",
        commune_name_ascii: "M'cisna",
        daira_name: "صدوق",
        daira_name_ascii: "Seddouk",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "صدوق",
        commune_name_ascii: "Seddouk",
        daira_name: "صدوق",
        daira_name_ascii: "Seddouk",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "بني مليكش",
        commune_name_ascii: "Beni-Mallikeche",
        daira_name: "تازملت",
        daira_name_ascii: "Tazmalt",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "بو جليل",
        commune_name_ascii: "Boudjellil",
        daira_name: "تازملت",
        daira_name_ascii: "Tazmalt",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "تازمالت",
        commune_name_ascii: "Tazmalt",
        daira_name: "تازملت",
        daira_name_ascii: "Tazmalt",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "أكفادو",
        commune_name_ascii: "Akfadou",
        daira_name: "شميني",
        daira_name_ascii: "Chemini",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "شميني",
        commune_name_ascii: "Chemini",
        daira_name: "شميني",
        daira_name_ascii: "Chemini",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "سوق اوفلا",
        commune_name_ascii: "Souk Oufella",
        daira_name: "شميني",
        daira_name_ascii: "Chemini",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "طيبان",
        commune_name_ascii: "Tibane",
        daira_name: "شميني",
        daira_name_ascii: "Chemini",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "أوزلاقن",
        commune_name_ascii: "Ouzellaguen",
        daira_name: "إفري أوزلاقن",
        daira_name_ascii: "Ifri Ouzellaguene",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "أميزور",
        commune_name_ascii: "Amizour",
        daira_name: "أميزور",
        daira_name_ascii: "Amizour",
        wilaya_code: 6,
        wilaya_name: " بجاية",
        wilaya_name_ascii: "Béjaïa"
    },
    {
        commune_name: "الفيض",
        commune_name_ascii: "El Feidh",
        daira_name: "زريبة الوادي",
        daira_name_ascii: "Zeribet El Oued",
        wilaya_code: 7,
        wilaya_name: "بسكرة",
        wilaya_name_ascii: "Biskra"
    },
    {
        commune_name: "ليشانة",
        commune_name_ascii: "Lichana",
        daira_name: "طولقة",
        daira_name_ascii: "Tolga",
        wilaya_code: 7,
        wilaya_name: "بسكرة",
        wilaya_name_ascii: "Biskra"
    },
    {
        commune_name: "بوشقرون",
        commune_name_ascii: "Bouchakroun",
        daira_name: "طولقة",
        daira_name_ascii: "Tolga",
        wilaya_code: 7,
        wilaya_name: "بسكرة",
        wilaya_name_ascii: "Biskra"
    },
    {
        commune_name: "مخادمة",
        commune_name_ascii: "Mekhadma",
        daira_name: "أورلال",
        daira_name_ascii: "Ourlal",
        wilaya_code: 7,
        wilaya_name: "بسكرة",
        wilaya_name_ascii: "Biskra"
    },
    {
        commune_name: "جمورة",
        commune_name_ascii: "Djemorah",
        daira_name: "جمورة",
        daira_name_ascii: "Djemorah",
        wilaya_code: 7,
        wilaya_name: "بسكرة",
        wilaya_name_ascii: "Biskra"
    },
    {
        commune_name: "برانيس",
        commune_name_ascii: "Branis",
        daira_name: "جمورة",
        daira_name_ascii: "Djemorah",
        wilaya_code: 7,
        wilaya_name: "بسكرة",
        wilaya_name_ascii: "Biskra"
    },
    {
        commune_name: "الوطاية",
        commune_name_ascii: "El Outaya",
        daira_name: "الوطاية",
        daira_name_ascii: "El Outaya",
        wilaya_code: 7,
        wilaya_name: "بسكرة",
        wilaya_name_ascii: "Biskra"
    },
    {
        commune_name: "القنطرة",
        commune_name_ascii: "El Kantara",
        daira_name: "القنطرة",
        daira_name_ascii: "El Kantara",
        wilaya_code: 7,
        wilaya_name: "بسكرة",
        wilaya_name_ascii: "Biskra"
    },
    {
        commune_name: "خنقة سيدي ناجي",
        commune_name_ascii: "Khenguet Sidi Nadji",
        daira_name: "زريبة الوادي",
        daira_name_ascii: "Zeribet El Oued",
        wilaya_code: 7,
        wilaya_name: "بسكرة",
        wilaya_name_ascii: "Biskra"
    },
    {
        commune_name: "عين زعطوط",
        commune_name_ascii: "Ain Zaatout",
        daira_name: "القنطرة",
        daira_name_ascii: "El Kantara",
        wilaya_code: 7,
        wilaya_name: "بسكرة",
        wilaya_name_ascii: "Biskra"
    },
    {
        commune_name: "زريبة الوادي",
        commune_name_ascii: "Zeribet El Oued",
        daira_name: "زريبة الوادي",
        daira_name_ascii: "Zeribet El Oued",
        wilaya_code: 7,
        wilaya_name: "بسكرة",
        wilaya_name_ascii: "Biskra"
    },
    {
        commune_name: "المزيرعة",
        commune_name_ascii: "Meziraa",
        daira_name: "زريبة الوادي",
        daira_name_ascii: "Zeribet El Oued",
        wilaya_code: 7,
        wilaya_name: "بسكرة",
        wilaya_name_ascii: "Biskra"
    },
    {
        commune_name: "بسكرة",
        commune_name_ascii: "Biskra",
        daira_name: "بسكرة",
        daira_name_ascii: "Biskra",
        wilaya_code: 7,
        wilaya_name: "بسكرة",
        wilaya_name_ascii: "Biskra"
    },
    {
        commune_name: "الحاجب",
        commune_name_ascii: "El Hadjab",
        daira_name: "بسكرة",
        daira_name_ascii: "Biskra",
        wilaya_code: 7,
        wilaya_name: "بسكرة",
        wilaya_name_ascii: "Biskra"
    },
    {
        commune_name: "مليلي",
        commune_name_ascii: "M'lili",
        daira_name: "أورلال",
        daira_name_ascii: "Ourlal",
        wilaya_code: 7,
        wilaya_name: "بسكرة",
        wilaya_name_ascii: "Biskra"
    },
    {
        commune_name: "فوغالة",
        commune_name_ascii: "Foughala",
        daira_name: "فوغالة",
        daira_name_ascii: "Foughala",
        wilaya_code: 7,
        wilaya_name: "بسكرة",
        wilaya_name_ascii: "Biskra"
    },
    {
        commune_name: "الغروس",
        commune_name_ascii: "El Ghrous",
        daira_name: "فوغالة",
        daira_name_ascii: "Foughala",
        wilaya_code: 7,
        wilaya_name: "بسكرة",
        wilaya_name_ascii: "Biskra"
    },
    {
        commune_name: "برج بن عزوز",
        commune_name_ascii: "Bordj Ben Azzouz",
        daira_name: "طولقة",
        daira_name_ascii: "Tolga",
        wilaya_code: 7,
        wilaya_name: "بسكرة",
        wilaya_name_ascii: "Biskra"
    },
    {
        commune_name: "أورلال",
        commune_name_ascii: "Ourlal",
        daira_name: "أورلال",
        daira_name_ascii: "Ourlal",
        wilaya_code: 7,
        wilaya_name: "بسكرة",
        wilaya_name_ascii: "Biskra"
    },
    {
        commune_name: "أوماش",
        commune_name_ascii: "Oumache",
        daira_name: "أورلال",
        daira_name_ascii: "Ourlal",
        wilaya_code: 7,
        wilaya_name: "بسكرة",
        wilaya_name_ascii: "Biskra"
    },
    {
        commune_name: "عين الناقة",
        commune_name_ascii: "Ain Naga",
        daira_name: "سيدي عقبة",
        daira_name_ascii: "Sidi Okba",
        wilaya_code: 7,
        wilaya_name: "بسكرة",
        wilaya_name_ascii: "Biskra"
    },
    {
        commune_name: "شتمة",
        commune_name_ascii: "Chetma",
        daira_name: "سيدي عقبة",
        daira_name_ascii: "Sidi Okba",
        wilaya_code: 7,
        wilaya_name: "بسكرة",
        wilaya_name_ascii: "Biskra"
    },
    {
        commune_name: "الحوش",
        commune_name_ascii: "El Haouch",
        daira_name: "سيدي عقبة",
        daira_name_ascii: "Sidi Okba",
        wilaya_code: 7,
        wilaya_name: "بسكرة",
        wilaya_name_ascii: "Biskra"
    },
    {
        commune_name: "سيدي عقبة",
        commune_name_ascii: "Sidi Okba",
        daira_name: "سيدي عقبة",
        daira_name_ascii: "Sidi Okba",
        wilaya_code: 7,
        wilaya_name: "بسكرة",
        wilaya_name_ascii: "Biskra"
    },
    {
        commune_name: "مشونش",
        commune_name_ascii: "M'chouneche",
        daira_name: "مشونش",
        daira_name_ascii: "Mechouneche",
        wilaya_code: 7,
        wilaya_name: "بسكرة",
        wilaya_name_ascii: "Biskra"
    },
    {
        commune_name: "ليوة",
        commune_name_ascii: "Lioua",
        daira_name: "أورلال",
        daira_name_ascii: "Ourlal",
        wilaya_code: 7,
        wilaya_name: "بسكرة",
        wilaya_name_ascii: "Biskra"
    },
    {
        commune_name: "طولقة",
        commune_name_ascii: "Tolga",
        daira_name: "طولقة",
        daira_name_ascii: "Tolga",
        wilaya_code: 7,
        wilaya_name: "بسكرة",
        wilaya_name_ascii: "Biskra"
    },
    {
        commune_name: "بشار",
        commune_name_ascii: "Bechar",
        daira_name: "بشار",
        daira_name_ascii: "Bechar",
        wilaya_code: 8,
        wilaya_name: "بشار",
        wilaya_name_ascii: "Béchar"
    },
    {
        commune_name: "بوكايس",
        commune_name_ascii: "Boukais",
        daira_name: "لحمر",
        daira_name_ascii: "Lahmar",
        wilaya_code: 8,
        wilaya_name: "بشار",
        wilaya_name_ascii: "Béchar"
    },
    {
        commune_name: "لحمر",
        commune_name_ascii: "Lahmar",
        daira_name: "لحمر",
        daira_name_ascii: "Lahmar",
        wilaya_code: 8,
        wilaya_name: "بشار",
        wilaya_name_ascii: "Béchar"
    },
    {
        commune_name: "موغل",
        commune_name_ascii: "Mogheul",
        daira_name: "لحمر",
        daira_name_ascii: "Lahmar",
        wilaya_code: 8,
        wilaya_name: "بشار",
        wilaya_name_ascii: "Béchar"
    },
    {
        commune_name: "المريجة",
        commune_name_ascii: "Meridja",
        daira_name: "القنادسة",
        daira_name_ascii: "Kenadsa",
        wilaya_code: 8,
        wilaya_name: "بشار",
        wilaya_name_ascii: "Béchar"
    },
    {
        commune_name: "تاغيت",
        commune_name_ascii: "Taghit",
        daira_name: "تاغيت",
        daira_name_ascii: "Taghit",
        wilaya_code: 8,
        wilaya_name: "بشار",
        wilaya_name_ascii: "Béchar"
    },
    {
        commune_name: "العبادلة",
        commune_name_ascii: "Abadla",
        daira_name: "العبادلة",
        daira_name_ascii: "Abadla",
        wilaya_code: 8,
        wilaya_name: "بشار",
        wilaya_name_ascii: "Béchar"
    },
    {
        commune_name: "عرق فراج",
        commune_name_ascii: "Erg-Ferradj",
        daira_name: "العبادلة",
        daira_name_ascii: "Abadla",
        wilaya_code: 8,
        wilaya_name: "بشار",
        wilaya_name_ascii: "Béchar"
    },
    {
        commune_name: "مشرع هواري بومدين",
        commune_name_ascii: "Machraa-Houari-Boumediene",
        daira_name: "العبادلة",
        daira_name_ascii: "Abadla",
        wilaya_code: 8,
        wilaya_name: "بشار",
        wilaya_name_ascii: "Béchar"
    },
    {
        commune_name: "بني ونيف",
        commune_name_ascii: "Beni-Ounif",
        daira_name: "بني ونيف",
        daira_name_ascii: "Beni Ounif",
        wilaya_code: 8,
        wilaya_name: "بشار",
        wilaya_name_ascii: "Béchar"
    },
    {
        commune_name: "تبلبالة",
        commune_name_ascii: "Tabelbala",
        daira_name: "تبلبالة",
        daira_name_ascii: "Tabelbala",
        wilaya_code: 8,
        wilaya_name: "بشار",
        wilaya_name_ascii: "Béchar"
    },
    {
        commune_name: "القنادسة",
        commune_name_ascii: "Kenadsa",
        daira_name: "القنادسة",
        daira_name_ascii: "Kenadsa",
        wilaya_code: 8,
        wilaya_name: "بشار",
        wilaya_name_ascii: "Béchar"
    },
    {
        commune_name: "بني مراد",
        commune_name_ascii: "Beni Mered",
        daira_name: "أولاد يعيش",
        daira_name_ascii: "Ouled Yaich",
        wilaya_code: 9,
        wilaya_name: "البليدة",
        wilaya_name_ascii: "Blida"
    },
    {
        commune_name: "اولاد سلامة",
        commune_name_ascii: "Ouled Slama",
        daira_name: "بوقرة",
        daira_name_ascii: "Bougara",
        wilaya_code: 9,
        wilaya_name: "البليدة",
        wilaya_name_ascii: "Blida"
    },
    {
        commune_name: "موزاية",
        commune_name_ascii: "Mouzaia",
        daira_name: "موزاية",
        daira_name_ascii: "Mouzaia",
        wilaya_code: 9,
        wilaya_name: "البليدة",
        wilaya_name_ascii: "Blida"
    },
    {
        commune_name: "حمام ملوان",
        commune_name_ascii: "Hammam Elouane",
        daira_name: "بوقرة",
        daira_name_ascii: "Bougara",
        wilaya_code: 9,
        wilaya_name: "البليدة",
        wilaya_name_ascii: "Blida"
    },
    {
        commune_name: "بوقرة",
        commune_name_ascii: "Bougara",
        daira_name: "بوقرة",
        daira_name_ascii: "Bougara",
        wilaya_code: 9,
        wilaya_name: "البليدة",
        wilaya_name_ascii: "Blida"
    },
    {
        commune_name: "صوحان",
        commune_name_ascii: "Souhane",
        daira_name: "الأربعاء",
        daira_name_ascii: "Larbaa",
        wilaya_code: 9,
        wilaya_name: "البليدة",
        wilaya_name_ascii: "Blida"
    },
    {
        commune_name: "الأربعاء",
        commune_name_ascii: "Larbaa",
        daira_name: "الأربعاء",
        daira_name_ascii: "Larbaa",
        wilaya_code: 9,
        wilaya_name: "البليدة",
        wilaya_name_ascii: "Blida"
    },
    {
        commune_name: "الصومعة",
        commune_name_ascii: "Soumaa",
        daira_name: "بوفاريك",
        daira_name_ascii: "Boufarik",
        wilaya_code: 9,
        wilaya_name: "البليدة",
        wilaya_name_ascii: "Blida"
    },
    {
        commune_name: "قرواو",
        commune_name_ascii: "Guerrouaou",
        daira_name: "بوفاريك",
        daira_name_ascii: "Boufarik",
        wilaya_code: 9,
        wilaya_name: "البليدة",
        wilaya_name_ascii: "Blida"
    },
    {
        commune_name: "بوفاريك",
        commune_name_ascii: "Boufarik",
        daira_name: "بوفاريك",
        daira_name_ascii: "Boufarik",
        wilaya_code: 9,
        wilaya_name: "البليدة",
        wilaya_name_ascii: "Blida"
    },
    {
        commune_name: "مفتاح",
        commune_name_ascii: "Meftah",
        daira_name: "مفتاح",
        daira_name_ascii: "Meftah",
        wilaya_code: 9,
        wilaya_name: "البليدة",
        wilaya_name_ascii: "Blida"
    },
    {
        commune_name: "الشفة",
        commune_name_ascii: "Chiffa",
        daira_name: "موزاية",
        daira_name_ascii: "Mouzaia",
        wilaya_code: 9,
        wilaya_name: "البليدة",
        wilaya_name_ascii: "Blida"
    },
    {
        commune_name: "عين الرمانة",
        commune_name_ascii: "Ain Romana",
        daira_name: "موزاية",
        daira_name_ascii: "Mouzaia",
        wilaya_code: 9,
        wilaya_name: "البليدة",
        wilaya_name_ascii: "Blida"
    },
    {
        commune_name: "وادي جر",
        commune_name_ascii: "Oued  Djer",
        daira_name: "العفرون",
        daira_name_ascii: "El Affroun",
        wilaya_code: 9,
        wilaya_name: "البليدة",
        wilaya_name_ascii: "Blida"
    },
    {
        commune_name: "العفرون",
        commune_name_ascii: "El-Affroun",
        daira_name: "العفرون",
        daira_name_ascii: "El Affroun",
        wilaya_code: 9,
        wilaya_name: "البليدة",
        wilaya_name_ascii: "Blida"
    },
    {
        commune_name: "أولاد يعيش",
        commune_name_ascii: "Ouled Yaich",
        daira_name: "أولاد يعيش",
        daira_name_ascii: "Ouled Yaich",
        wilaya_code: 9,
        wilaya_name: "البليدة",
        wilaya_name_ascii: "Blida"
    },
    {
        commune_name: "الشريعة",
        commune_name_ascii: "Chrea",
        daira_name: "أولاد يعيش",
        daira_name_ascii: "Ouled Yaich",
        wilaya_code: 9,
        wilaya_name: "البليدة",
        wilaya_name_ascii: "Blida"
    },
    {
        commune_name: "جبابرة",
        commune_name_ascii: "Djebabra",
        daira_name: "مفتاح",
        daira_name_ascii: "Meftah",
        wilaya_code: 9,
        wilaya_name: "البليدة",
        wilaya_name_ascii: "Blida"
    },
    {
        commune_name: "وادي العلايق",
        commune_name_ascii: "Oued El Alleug",
        daira_name: "وادي العلايق",
        daira_name_ascii: "Oued El Alleug",
        wilaya_code: 9,
        wilaya_name: "البليدة",
        wilaya_name_ascii: "Blida"
    },
    {
        commune_name: "بن خليل",
        commune_name_ascii: "Benkhelil",
        daira_name: "وادي العلايق",
        daira_name_ascii: "Oued El Alleug",
        wilaya_code: 9,
        wilaya_name: "البليدة",
        wilaya_name_ascii: "Blida"
    },
    {
        commune_name: "بني تامو",
        commune_name_ascii: "Beni-Tamou",
        daira_name: "وادي العلايق",
        daira_name_ascii: "Oued El Alleug",
        wilaya_code: 9,
        wilaya_name: "البليدة",
        wilaya_name_ascii: "Blida"
    },
    {
        commune_name: "الشبلي",
        commune_name_ascii: "Chebli",
        daira_name: "بوعينان",
        daira_name_ascii: "Bouinan",
        wilaya_code: 9,
        wilaya_name: "البليدة",
        wilaya_name_ascii: "Blida"
    },
    {
        commune_name: "بوعينان",
        commune_name_ascii: "Bouinan",
        daira_name: "بوعينان",
        daira_name_ascii: "Bouinan",
        wilaya_code: 9,
        wilaya_name: "البليدة",
        wilaya_name_ascii: "Blida"
    },
    {
        commune_name: "بوعرفة",
        commune_name_ascii: "Bouarfa",
        daira_name: "البليدة",
        daira_name_ascii: "Blida",
        wilaya_code: 9,
        wilaya_name: "البليدة",
        wilaya_name_ascii: "Blida"
    },
    {
        commune_name: "البليدة",
        commune_name_ascii: "Blida",
        daira_name: "البليدة",
        daira_name_ascii: "Blida",
        wilaya_code: 9,
        wilaya_name: "البليدة",
        wilaya_name_ascii: "Blida"
    },
    {
        commune_name: "عين العلوي",
        commune_name_ascii: "Ain Laloui",
        daira_name: "عين بسام",
        daira_name_ascii: "Ain Bessem",
        wilaya_code: 10,
        wilaya_name: "البويرة",
        wilaya_name_ascii: "Bouira"
    },
    {
        commune_name: "الحجرة الزرقاء",
        commune_name_ascii: "Hadjera Zerga",
        daira_name: "برج أوخريص",
        daira_name_ascii: "Bordj Okhriss",
        wilaya_code: 10,
        wilaya_name: "البويرة",
        wilaya_name_ascii: "Bouira"
    },
    {
        commune_name: "مزدور",
        commune_name_ascii: "Mezdour",
        daira_name: "برج أوخريص",
        daira_name_ascii: "Bordj Okhriss",
        wilaya_code: 10,
        wilaya_name: "البويرة",
        wilaya_name_ascii: "Bouira"
    },
    {
        commune_name: "تاقديت",
        commune_name_ascii: "Taguedite",
        daira_name: "برج أوخريص",
        daira_name_ascii: "Bordj Okhriss",
        wilaya_code: 10,
        wilaya_name: "البويرة",
        wilaya_name_ascii: "Bouira"
    },
    {
        commune_name: "ريدان",
        commune_name_ascii: "Ridane",
        daira_name: "سور الغزلان",
        daira_name_ascii: "Sour El Ghozlane",
        wilaya_code: 10,
        wilaya_name: "البويرة",
        wilaya_name_ascii: "Bouira"
    },
    {
        commune_name: "المعمورة",
        commune_name_ascii: "Maamora",
        daira_name: "سور الغزلان",
        daira_name_ascii: "Sour El Ghozlane",
        wilaya_code: 10,
        wilaya_name: "البويرة",
        wilaya_name_ascii: "Bouira"
    },
    {
        commune_name: "الحاكمية",
        commune_name_ascii: "El-Hakimia",
        daira_name: "سور الغزلان",
        daira_name_ascii: "Sour El Ghozlane",
        wilaya_code: 10,
        wilaya_name: "البويرة",
        wilaya_name_ascii: "Bouira"
    },
    {
        commune_name: "أهل القصر",
        commune_name_ascii: "Ahl El Ksar",
        daira_name: "بشلول",
        daira_name_ascii: "Bechloul",
        wilaya_code: 10,
        wilaya_name: "البويرة",
        wilaya_name_ascii: "Bouira"
    },
    {
        commune_name: "ديرة",
        commune_name_ascii: "Dirah",
        daira_name: "سور الغزلان",
        daira_name_ascii: "Sour El Ghozlane",
        wilaya_code: 10,
        wilaya_name: "البويرة",
        wilaya_name_ascii: "Bouira"
    },
    {
        commune_name: "الدشمية",
        commune_name_ascii: "Dechmia",
        daira_name: "سور الغزلان",
        daira_name_ascii: "Sour El Ghozlane",
        wilaya_code: 10,
        wilaya_name: "البويرة",
        wilaya_name_ascii: "Bouira"
    },
    {
        commune_name: "بشلول",
        commune_name_ascii: "Bechloul",
        daira_name: "بشلول",
        daira_name_ascii: "Bechloul",
        wilaya_code: 10,
        wilaya_name: "البويرة",
        wilaya_name_ascii: "Bouira"
    },
    {
        commune_name: "آث  منصور",
        commune_name_ascii: "Ath Mansour",
        daira_name: "مشد الله",
        daira_name_ascii: "M'chedallah",
        wilaya_code: 10,
        wilaya_name: "البويرة",
        wilaya_name_ascii: "Bouira"
    },
    {
        commune_name: "سحاريج",
        commune_name_ascii: "Saharidj",
        daira_name: "مشد الله",
        daira_name_ascii: "M'chedallah",
        wilaya_code: 10,
        wilaya_name: "البويرة",
        wilaya_name_ascii: "Bouira"
    },
    {
        commune_name: "العجيبة",
        commune_name_ascii: "El Adjiba",
        daira_name: "بشلول",
        daira_name_ascii: "Bechloul",
        wilaya_code: 10,
        wilaya_name: "البويرة",
        wilaya_name_ascii: "Bouira"
    },
    {
        commune_name: "الأسنام",
        commune_name_ascii: "El Asnam",
        daira_name: "بشلول",
        daira_name_ascii: "Bechloul",
        wilaya_code: 10,
        wilaya_name: "البويرة",
        wilaya_name_ascii: "Bouira"
    },
    {
        commune_name: "أمشدالة",
        commune_name_ascii: "M Chedallah",
        daira_name: "مشد الله",
        daira_name_ascii: "M'chedallah",
        wilaya_code: 10,
        wilaya_name: "البويرة",
        wilaya_name_ascii: "Bouira"
    },
    {
        commune_name: "برج أوخريص",
        commune_name_ascii: "Bordj Okhriss",
        daira_name: "برج أوخريص",
        daira_name_ascii: "Bordj Okhriss",
        wilaya_code: 10,
        wilaya_name: "البويرة",
        wilaya_name_ascii: "Bouira"
    },
    {
        commune_name: "سور الغزلان",
        commune_name_ascii: "Sour El Ghozlane",
        daira_name: "سور الغزلان",
        daira_name_ascii: "Sour El Ghozlane",
        wilaya_code: 10,
        wilaya_name: "البويرة",
        wilaya_name_ascii: "Bouira"
    },
    {
        commune_name: "حنيف",
        commune_name_ascii: "Hanif",
        daira_name: "مشد الله",
        daira_name_ascii: "M'chedallah",
        wilaya_code: 10,
        wilaya_name: "البويرة",
        wilaya_name_ascii: "Bouira"
    },
    {
        commune_name: "شرفة",
        commune_name_ascii: "Chorfa",
        daira_name: "مشد الله",
        daira_name_ascii: "M'chedallah",
        wilaya_code: 10,
        wilaya_name: "البويرة",
        wilaya_name_ascii: "Bouira"
    },
    {
        commune_name: "أولاد راشد",
        commune_name_ascii: "Ouled Rached",
        daira_name: "بشلول",
        daira_name_ascii: "Bechloul",
        wilaya_code: 10,
        wilaya_name: "البويرة",
        wilaya_name_ascii: "Bouira"
    },
    {
        commune_name: "عين الحجر",
        commune_name_ascii: "Ain El Hadjar",
        daira_name: "عين بسام",
        daira_name_ascii: "Ain Bessem",
        wilaya_code: 10,
        wilaya_name: "البويرة",
        wilaya_name_ascii: "Bouira"
    },
    {
        commune_name: "أغبالو",
        commune_name_ascii: "Aghbalou",
        daira_name: "مشد الله",
        daira_name_ascii: "M'chedallah",
        wilaya_code: 10,
        wilaya_name: "البويرة",
        wilaya_name_ascii: "Bouira"
    },
    {
        commune_name: "روراوة",
        commune_name_ascii: "Raouraoua",
        daira_name: "بئر غبالو",
        daira_name_ascii: "Bir Ghbalou",
        wilaya_code: 10,
        wilaya_name: "البويرة",
        wilaya_name_ascii: "Bouira"
    },
    {
        commune_name: "الخبوزية",
        commune_name_ascii: "El Khabouzia",
        daira_name: "بئر غبالو",
        daira_name_ascii: "Bir Ghbalou",
        wilaya_code: 10,
        wilaya_name: "البويرة",
        wilaya_name_ascii: "Bouira"
    },
    {
        commune_name: "بئر غبالو",
        commune_name_ascii: "Bir Ghbalou",
        daira_name: "بئر غبالو",
        daira_name_ascii: "Bir Ghbalou",
        wilaya_code: 10,
        wilaya_name: "البويرة",
        wilaya_name_ascii: "Bouira"
    },
    {
        commune_name: "البويرة",
        commune_name_ascii: "Bouira",
        daira_name: "البويرة",
        daira_name_ascii: "Bouira",
        wilaya_code: 10,
        wilaya_name: "البويرة",
        wilaya_name_ascii: "Bouira"
    },
    {
        commune_name: "عين الترك",
        commune_name_ascii: "Ain Turk",
        daira_name: "البويرة",
        daira_name_ascii: "Bouira",
        wilaya_code: 10,
        wilaya_name: "البويرة",
        wilaya_name_ascii: "Bouira"
    },
    {
        commune_name: "أيت لعزيز",
        commune_name_ascii: "Ait Laaziz",
        daira_name: "البويرة",
        daira_name_ascii: "Bouira",
        wilaya_code: 10,
        wilaya_name: "البويرة",
        wilaya_name_ascii: "Bouira"
    },
    {
        commune_name: "عين بسام",
        commune_name_ascii: "Ain-Bessem",
        daira_name: "عين بسام",
        daira_name_ascii: "Ain Bessem",
        wilaya_code: 10,
        wilaya_name: "البويرة",
        wilaya_name_ascii: "Bouira"
    },
    {
        commune_name: "المقراني",
        commune_name_ascii: "El-Mokrani",
        daira_name: "سوق الخميس",
        daira_name_ascii: "Souk El Khemis",
        wilaya_code: 10,
        wilaya_name: "البويرة",
        wilaya_name_ascii: "Bouira"
    },
    {
        commune_name: "سوق الخميس",
        commune_name_ascii: "Souk El Khemis",
        daira_name: "سوق الخميس",
        daira_name_ascii: "Souk El Khemis",
        wilaya_code: 10,
        wilaya_name: "البويرة",
        wilaya_name_ascii: "Bouira"
    },
    {
        commune_name: "أعمر",
        commune_name_ascii: "Aomar",
        daira_name: "القادرية",
        daira_name_ascii: "Kadiria",
        wilaya_code: 10,
        wilaya_name: "البويرة",
        wilaya_name_ascii: "Bouira"
    },
    {
        commune_name: "جباحية",
        commune_name_ascii: "Djebahia",
        daira_name: "القادرية",
        daira_name_ascii: "Kadiria",
        wilaya_code: 10,
        wilaya_name: "البويرة",
        wilaya_name_ascii: "Bouira"
    },
    {
        commune_name: "الهاشمية",
        commune_name_ascii: "El Hachimia",
        daira_name: "الهاشمية",
        daira_name_ascii: "El Hachimia",
        wilaya_code: 10,
        wilaya_name: "البويرة",
        wilaya_name_ascii: "Bouira"
    },
    {
        commune_name: "حيزر",
        commune_name_ascii: "Haizer",
        daira_name: "الحيزر",
        daira_name_ascii: "Haizer",
        wilaya_code: 10,
        wilaya_name: "البويرة",
        wilaya_name_ascii: "Bouira"
    },
    {
        commune_name: "تاغزوت",
        commune_name_ascii: "Taghzout",
        daira_name: "الحيزر",
        daira_name_ascii: "Haizer",
        wilaya_code: 10,
        wilaya_name: "البويرة",
        wilaya_name_ascii: "Bouira"
    },
    {
        commune_name: "بودربالة",
        commune_name_ascii: "Bouderbala",
        daira_name: "الأخضرية",
        daira_name_ascii: "Lakhdaria",
        wilaya_code: 10,
        wilaya_name: "البويرة",
        wilaya_name_ascii: "Bouira"
    },
    {
        commune_name: "بوكرم",
        commune_name_ascii: "Boukram",
        daira_name: "الأخضرية",
        daira_name_ascii: "Lakhdaria",
        wilaya_code: 10,
        wilaya_name: "البويرة",
        wilaya_name_ascii: "Bouira"
    },
    {
        commune_name: "قرومة",
        commune_name_ascii: "Guerrouma",
        daira_name: "الأخضرية",
        daira_name_ascii: "Lakhdaria",
        wilaya_code: 10,
        wilaya_name: "البويرة",
        wilaya_name_ascii: "Bouira"
    },
    {
        commune_name: "الأخضرية",
        commune_name_ascii: "Lakhdaria",
        daira_name: "الأخضرية",
        daira_name_ascii: "Lakhdaria",
        wilaya_code: 10,
        wilaya_name: "البويرة",
        wilaya_name_ascii: "Bouira"
    },
    {
        commune_name: "معلة",
        commune_name_ascii: "Maala",
        daira_name: "الأخضرية",
        daira_name_ascii: "Lakhdaria",
        wilaya_code: 10,
        wilaya_name: "البويرة",
        wilaya_name_ascii: "Bouira"
    },
    {
        commune_name: "قادرية",
        commune_name_ascii: "Kadiria",
        daira_name: "القادرية",
        daira_name_ascii: "Kadiria",
        wilaya_code: 10,
        wilaya_name: "البويرة",
        wilaya_name_ascii: "Bouira"
    },
    {
        commune_name: "زبربر",
        commune_name_ascii: "Z'barbar (El Isseri )",
        daira_name: "الأخضرية",
        daira_name_ascii: "Lakhdaria",
        wilaya_code: 10,
        wilaya_name: "البويرة",
        wilaya_name_ascii: "Bouira"
    },
    {
        commune_name: "وادي البردي",
        commune_name_ascii: "Oued El Berdi",
        daira_name: "الهاشمية",
        daira_name_ascii: "El Hachimia",
        wilaya_code: 10,
        wilaya_name: "البويرة",
        wilaya_name_ascii: "Bouira"
    },
    {
        commune_name: "تاظروك",
        commune_name_ascii: "Tazrouk",
        daira_name: "تاظروك",
        daira_name_ascii: "Tazrouk",
        wilaya_code: 11,
        wilaya_name: "تمنراست",
        wilaya_name_ascii: "Tamanrasset"
    },
    {
        commune_name: "ابلسة",
        commune_name_ascii: "Abelsa",
        daira_name: "سيلت",
        daira_name_ascii: "Silet",
        wilaya_code: 11,
        wilaya_name: "تمنراست",
        wilaya_name_ascii: "Tamanrasset"
    },
    {
        commune_name: "تمنراست",
        commune_name_ascii: "Tamanrasset",
        daira_name: "تمنراست",
        daira_name_ascii: "Tamanrasset",
        wilaya_code: 11,
        wilaya_name: "تمنراست",
        wilaya_name_ascii: "Tamanrasset"
    },
    {
        commune_name: "عين امقل",
        commune_name_ascii: "Ain Amguel",
        daira_name: "تمنراست",
        daira_name_ascii: "Tamanrasset",
        wilaya_code: 11,
        wilaya_name: "تمنراست",
        wilaya_name_ascii: "Tamanrasset"
    },
    {
        commune_name: "أدلس",
        commune_name_ascii: "Idles",
        daira_name: "تاظروك",
        daira_name_ascii: "Tazrouk",
        wilaya_code: 11,
        wilaya_name: "تمنراست",
        wilaya_name_ascii: "Tamanrasset"
    },
    {
        commune_name: "الحويجبات",
        commune_name_ascii: "El-Houidjbet",
        daira_name: "الماء الابيض",
        daira_name_ascii: "El Malabiod",
        wilaya_code: 12,
        wilaya_name: "تبسة",
        wilaya_name_ascii: "Tébessa"
    },
    {
        commune_name: "العوينات",
        commune_name_ascii: "El-Aouinet",
        daira_name: "العوينات",
        daira_name_ascii: "El Aouinet",
        wilaya_code: 12,
        wilaya_name: "تبسة",
        wilaya_name_ascii: "Tébessa"
    },
    {
        commune_name: "فركان",
        commune_name_ascii: "Ferkane",
        daira_name: "نقرين",
        daira_name_ascii: "Negrine",
        wilaya_code: 12,
        wilaya_name: "تبسة",
        wilaya_name_ascii: "Tébessa"
    },
    {
        commune_name: "نقرين",
        commune_name_ascii: "Negrine",
        daira_name: "نقرين",
        daira_name_ascii: "Negrine",
        wilaya_code: 12,
        wilaya_name: "تبسة",
        wilaya_name_ascii: "Tébessa"
    },
    {
        commune_name: "بئر مقدم",
        commune_name_ascii: "Bir Mokkadem",
        daira_name: "بئر مقدم",
        daira_name_ascii: "Bir Mokadem",
        wilaya_code: 12,
        wilaya_name: "تبسة",
        wilaya_name_ascii: "Tébessa"
    },
    {
        commune_name: "بئر الذهب",
        commune_name_ascii: "Bir Dheheb",
        daira_name: "مرسط",
        daira_name_ascii: "Morsott",
        wilaya_code: 12,
        wilaya_name: "تبسة",
        wilaya_name_ascii: "Tébessa"
    },
    {
        commune_name: "صفصاف الوسرى",
        commune_name_ascii: "Saf Saf El Ouesra",
        daira_name: "أم علي",
        daira_name_ascii: "Oum Ali",
        wilaya_code: 12,
        wilaya_name: "تبسة",
        wilaya_name_ascii: "Tébessa"
    },
    {
        commune_name: "قريقر",
        commune_name_ascii: "Guorriguer",
        daira_name: "بئر مقدم",
        daira_name_ascii: "Bir Mokadem",
        wilaya_code: 12,
        wilaya_name: "تبسة",
        wilaya_name_ascii: "Tébessa"
    },
    {
        commune_name: "بكارية",
        commune_name_ascii: "Bekkaria",
        daira_name: "الكويف",
        daira_name_ascii: "El Kouif",
        wilaya_code: 12,
        wilaya_name: "تبسة",
        wilaya_name_ascii: "Tébessa"
    },
    {
        commune_name: "بولحاف الدير",
        commune_name_ascii: "Boulhaf Dyr",
        daira_name: "الكويف",
        daira_name_ascii: "El Kouif",
        wilaya_code: 12,
        wilaya_name: "تبسة",
        wilaya_name_ascii: "Tébessa"
    },
    {
        commune_name: "أم علي",
        commune_name_ascii: "Oum Ali",
        daira_name: "أم علي",
        daira_name_ascii: "Oum Ali",
        wilaya_code: 12,
        wilaya_name: "تبسة",
        wilaya_name_ascii: "Tébessa"
    },
    {
        commune_name: "بوخضرة",
        commune_name_ascii: "Boukhadra",
        daira_name: "العوينات",
        daira_name_ascii: "El Aouinet",
        wilaya_code: 12,
        wilaya_name: "تبسة",
        wilaya_name_ascii: "Tébessa"
    },
    {
        commune_name: "الماء الابيض",
        commune_name_ascii: "El Malabiod",
        daira_name: "الماء الابيض",
        daira_name_ascii: "El Malabiod",
        wilaya_code: 12,
        wilaya_name: "تبسة",
        wilaya_name_ascii: "Tébessa"
    },
    {
        commune_name: "الونزة",
        commune_name_ascii: "Ouenza",
        daira_name: "الونزة",
        daira_name_ascii: "Ouenza",
        wilaya_code: 12,
        wilaya_name: "تبسة",
        wilaya_name_ascii: "Tébessa"
    },
    {
        commune_name: "المريج",
        commune_name_ascii: "El Meridj",
        daira_name: "الونزة",
        daira_name_ascii: "Ouenza",
        wilaya_code: 12,
        wilaya_name: "تبسة",
        wilaya_name_ascii: "Tébessa"
    },
    {
        commune_name: "عين الزرقاء",
        commune_name_ascii: "Ain Zerga",
        daira_name: "الونزة",
        daira_name_ascii: "Ouenza",
        wilaya_code: 12,
        wilaya_name: "تبسة",
        wilaya_name_ascii: "Tébessa"
    },
    {
        commune_name: "سطح قنطيس",
        commune_name_ascii: "Stah Guentis",
        daira_name: "العقلة",
        daira_name_ascii: "El Ogla",
        wilaya_code: 12,
        wilaya_name: "تبسة",
        wilaya_name_ascii: "Tébessa"
    },
    {
        commune_name: "العقلة",
        commune_name_ascii: "El Ogla",
        daira_name: "العقلة",
        daira_name_ascii: "El Ogla",
        wilaya_code: 12,
        wilaya_name: "تبسة",
        wilaya_name_ascii: "Tébessa"
    },
    {
        commune_name: "المزرعة",
        commune_name_ascii: "El Mezeraa",
        daira_name: "العقلة",
        daira_name_ascii: "El Ogla",
        wilaya_code: 12,
        wilaya_name: "تبسة",
        wilaya_name_ascii: "Tébessa"
    },
    {
        commune_name: "بجن",
        commune_name_ascii: "Bedjene",
        daira_name: "العقلة",
        daira_name_ascii: "El Ogla",
        wilaya_code: 12,
        wilaya_name: "تبسة",
        wilaya_name_ascii: "Tébessa"
    },
    {
        commune_name: "مرسط",
        commune_name_ascii: "Morsott",
        daira_name: "مرسط",
        daira_name_ascii: "Morsott",
        wilaya_code: 12,
        wilaya_name: "تبسة",
        wilaya_name_ascii: "Tébessa"
    },
    {
        commune_name: "ثليجان",
        commune_name_ascii: "Telidjen",
        daira_name: "الشريعة",
        daira_name_ascii: "Cheria",
        wilaya_code: 12,
        wilaya_name: "تبسة",
        wilaya_name_ascii: "Tébessa"
    },
    {
        commune_name: "الشريعة",
        commune_name_ascii: "Cheria",
        daira_name: "الشريعة",
        daira_name_ascii: "Cheria",
        wilaya_code: 12,
        wilaya_name: "تبسة",
        wilaya_name_ascii: "Tébessa"
    },
    {
        commune_name: "العقلة المالحة",
        commune_name_ascii: "El Ogla El Malha",
        daira_name: "بئر العاتر",
        daira_name_ascii: "Bir El Ater",
        wilaya_code: 12,
        wilaya_name: "تبسة",
        wilaya_name_ascii: "Tébessa"
    },
    {
        commune_name: "بئر العاتر",
        commune_name_ascii: "Bir-El-Ater",
        daira_name: "بئر العاتر",
        daira_name_ascii: "Bir El Ater",
        wilaya_code: 12,
        wilaya_name: "تبسة",
        wilaya_name_ascii: "Tébessa"
    },
    {
        commune_name: "تبسة",
        commune_name_ascii: "Tebessa",
        daira_name: "تبسة",
        daira_name_ascii: "Tebessa",
        wilaya_code: 12,
        wilaya_name: "تبسة",
        wilaya_name_ascii: "Tébessa"
    },
    {
        commune_name: "الحمامات",
        commune_name_ascii: "Hammamet",
        daira_name: "بئر مقدم",
        daira_name_ascii: "Bir Mokadem",
        wilaya_code: 12,
        wilaya_name: "تبسة",
        wilaya_name_ascii: "Tébessa"
    },
    {
        commune_name: "الكويف",
        commune_name_ascii: "El Kouif",
        daira_name: "الكويف",
        daira_name_ascii: "El Kouif",
        wilaya_code: 12,
        wilaya_name: "تبسة",
        wilaya_name_ascii: "Tébessa"
    },
    {
        commune_name: "باب العسة",
        commune_name_ascii: "Bab El Assa",
        daira_name: "باب العسة",
        daira_name_ascii: "Bab El Assa",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "تيرني بني هديل",
        commune_name_ascii: "Terny Beni Hediel",
        daira_name: "منصورة",
        daira_name_ascii: "Mansourah",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "منصورة",
        commune_name_ascii: "Mansourah",
        daira_name: "منصورة",
        daira_name_ascii: "Mansourah",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "بني مستر",
        commune_name_ascii: "Beni Mester",
        daira_name: "منصورة",
        daira_name_ascii: "Mansourah",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "عين غرابة",
        commune_name_ascii: "Ain Ghoraba",
        daira_name: "منصورة",
        daira_name_ascii: "Mansourah",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "شتوان",
        commune_name_ascii: "Chetouane",
        daira_name: "شتوان",
        daira_name_ascii: "Chetouane",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "عمير",
        commune_name_ascii: "Amieur",
        daira_name: "شتوان",
        daira_name_ascii: "Chetouane",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "عين فزة",
        commune_name_ascii: "Ain Fezza",
        daira_name: "شتوان",
        daira_name_ascii: "Chetouane",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "هنين",
        commune_name_ascii: "Honnaine",
        daira_name: "هنين",
        daira_name_ascii: "Honnaine",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "بني خلاد",
        commune_name_ascii: "Beni Khellad",
        daira_name: "هنين",
        daira_name_ascii: "Honnaine",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "سيدي الجيلالي",
        commune_name_ascii: "Sidi Djillali",
        daira_name: "سيدي الجيلالي",
        daira_name_ascii: "Sidi Djillali",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "البويهي",
        commune_name_ascii: "Bouihi",
        daira_name: "سيدي الجيلالي",
        daira_name_ascii: "Sidi Djillali",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "ندرومة",
        commune_name_ascii: "Nedroma",
        daira_name: "ندرومة",
        daira_name_ascii: "Nedroma",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "مسيردة الفواقة",
        commune_name_ascii: "M'sirda Fouaga",
        daira_name: "مرسى بن مهيدي",
        daira_name_ascii: "Marsa Ben Mehdi",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "مرسى بن مهيدي",
        commune_name_ascii: "Marsa Ben M'hidi",
        daira_name: "مرسى بن مهيدي",
        daira_name_ascii: "Marsa Ben Mehdi",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "سيدي مجاهد",
        commune_name_ascii: "Sidi Medjahed",
        daira_name: "بني بوسعيد",
        daira_name_ascii: "Beni Boussaid",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "بني بوسعيد",
        commune_name_ascii: "Beni Boussaid",
        daira_name: "بني بوسعيد",
        daira_name_ascii: "Beni Boussaid",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "سبدو",
        commune_name_ascii: "Sebdou",
        daira_name: "سبدو",
        daira_name_ascii: "Sebdou",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "القور",
        commune_name_ascii: "El Gor",
        daira_name: "سبدو",
        daira_name_ascii: "Sebdou",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "العريشة",
        commune_name_ascii: "El Aricha",
        daira_name: "سبدو",
        daira_name_ascii: "Sebdou",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "بوحلو",
        commune_name_ascii: "Bouhlou",
        daira_name: "صبرة",
        daira_name_ascii: "Sabra",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "مغنية",
        commune_name_ascii: "Maghnia",
        daira_name: "مغنية",
        daira_name_ascii: "Maghnia",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "حمام بوغرارة",
        commune_name_ascii: "Hammam Boughrara",
        daira_name: "مغنية",
        daira_name_ascii: "Maghnia",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "زناتة",
        commune_name_ascii: "Zenata",
        daira_name: "الحناية",
        daira_name_ascii: "Hennaya",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "أولاد رياح",
        commune_name_ascii: "Ouled Riyah",
        daira_name: "الحناية",
        daira_name_ascii: "Hennaya",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "الحناية",
        commune_name_ascii: "Hennaya",
        daira_name: "الحناية",
        daira_name_ascii: "Hennaya",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "سيدي العبدلي",
        commune_name_ascii: "Sidi Abdelli",
        daira_name: "بن سكران",
        daira_name_ascii: "Bensekrane",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "سوق الثلاثاء",
        commune_name_ascii: "Souk Tleta",
        daira_name: "باب العسة",
        daira_name_ascii: "Bab El Assa",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "بن سكران",
        commune_name_ascii: "Bensekrane",
        daira_name: "بن سكران",
        daira_name_ascii: "Bensekrane",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "فلاوسن",
        commune_name_ascii: "Fellaoucene",
        daira_name: "فلاوسن",
        daira_name_ascii: "Fellaoucene",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "عين الكبيرة",
        commune_name_ascii: "Ain Kebira",
        daira_name: "فلاوسن",
        daira_name_ascii: "Fellaoucene",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "عين فتاح",
        commune_name_ascii: "Ain Fetah",
        daira_name: "فلاوسن",
        daira_name_ascii: "Fellaoucene",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "تلمسان",
        commune_name_ascii: "Tlemcen",
        daira_name: "تلمسان",
        daira_name_ascii: "Tlemcen",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "عين النحالة",
        commune_name_ascii: "Ain Nehala",
        daira_name: "عين تالوت",
        daira_name_ascii: "Ain Tellout",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "عين تالوت",
        commune_name_ascii: "Ain Tellout",
        daira_name: "عين تالوت",
        daira_name_ascii: "Ain Tellout",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "عين يوسف",
        commune_name_ascii: "Ain Youcef",
        daira_name: "الرمشي",
        daira_name_ascii: "Remchi",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "بني وارسوس",
        commune_name_ascii: "Beni Ouarsous",
        daira_name: "الرمشي",
        daira_name_ascii: "Remchi",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "الفحول",
        commune_name_ascii: "El Fehoul",
        daira_name: "الرمشي",
        daira_name_ascii: "Remchi",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "الرمشي",
        commune_name_ascii: "Remchi",
        daira_name: "الرمشي",
        daira_name_ascii: "Remchi",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "سبعة شيوخ",
        commune_name_ascii: "Sebbaa Chioukh",
        daira_name: "الرمشي",
        daira_name_ascii: "Remchi",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "السواني",
        commune_name_ascii: "Souani",
        daira_name: "باب العسة",
        daira_name_ascii: "Bab El Assa",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "صبرة",
        commune_name_ascii: "Sabra",
        daira_name: "صبرة",
        daira_name_ascii: "Sabra",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "دار يغمراسن",
        commune_name_ascii: "Dar Yaghmoracen",
        daira_name: "الغزوات",
        daira_name_ascii: "Ghazaouet",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "الغزوات",
        commune_name_ascii: "Ghazaouet",
        daira_name: "الغزوات",
        daira_name_ascii: "Ghazaouet",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "السواحلية",
        commune_name_ascii: "Souahlia",
        daira_name: "الغزوات",
        daira_name_ascii: "Ghazaouet",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "تيانت",
        commune_name_ascii: "Tianet",
        daira_name: "الغزوات",
        daira_name_ascii: "Ghazaouet",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "بني صميل",
        commune_name_ascii: "Beni Smiel",
        daira_name: "أولاد ميمون",
        daira_name_ascii: "Ouled Mimoun",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "وادي الخضر",
        commune_name_ascii: "Oued Lakhdar",
        daira_name: "أولاد ميمون",
        daira_name_ascii: "Ouled Mimoun",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "أولاد ميمون",
        commune_name_ascii: "Ouled Mimoun",
        daira_name: "أولاد ميمون",
        daira_name_ascii: "Ouled Mimoun",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "بني بهدل",
        commune_name_ascii: "Beni Bahdel",
        daira_name: "بني سنوس",
        daira_name_ascii: "Beni Snous",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "بني سنوس",
        commune_name_ascii: "Beni Snous",
        daira_name: "بني سنوس",
        daira_name_ascii: "Beni Snous",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "العزايل",
        commune_name_ascii: "Azail",
        daira_name: "بني سنوس",
        daira_name_ascii: "Beni Snous",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "جبالة",
        commune_name_ascii: "Djebala",
        daira_name: "ندرومة",
        daira_name_ascii: "Nedroma",
        wilaya_code: 13,
        wilaya_name: "تلمسان",
        wilaya_name_ascii: "Tlemcen"
    },
    {
        commune_name: "مهدية",
        commune_name_ascii: "Mahdia",
        daira_name: "مهدية",
        daira_name_ascii: "Mahdia",
        wilaya_code: 14,
        wilaya_name: "تيارت",
        wilaya_name_ascii: "Tiaret"
    },
    {
        commune_name: "عين دزاريت",
        commune_name_ascii: "Ain Dzarit",
        daira_name: "مهدية",
        daira_name_ascii: "Mahdia",
        wilaya_code: 14,
        wilaya_name: "تيارت",
        wilaya_name_ascii: "Tiaret"
    },
    {
        commune_name: "السبعين",
        commune_name_ascii: "Sebaine",
        daira_name: "مهدية",
        daira_name_ascii: "Mahdia",
        wilaya_code: 14,
        wilaya_name: "تيارت",
        wilaya_name_ascii: "Tiaret"
    },
    {
        commune_name: "الفايجة",
        commune_name_ascii: "Faidja",
        daira_name: "السوقر",
        daira_name_ascii: "Sougueur",
        wilaya_code: 14,
        wilaya_name: "تيارت",
        wilaya_name_ascii: "Tiaret"
    },
    {
        commune_name: "سي عبد الغني",
        commune_name_ascii: "Si Abdelghani",
        daira_name: "السوقر",
        daira_name_ascii: "Sougueur",
        wilaya_code: 14,
        wilaya_name: "تيارت",
        wilaya_name_ascii: "Tiaret"
    },
    {
        commune_name: "السوقر",
        commune_name_ascii: "Sougueur",
        daira_name: "السوقر",
        daira_name_ascii: "Sougueur",
        wilaya_code: 14,
        wilaya_name: "تيارت",
        wilaya_name_ascii: "Tiaret"
    },
    {
        commune_name: "توسنينة",
        commune_name_ascii: "Tousnina",
        daira_name: "السوقر",
        daira_name_ascii: "Sougueur",
        wilaya_code: 14,
        wilaya_name: "تيارت",
        wilaya_name_ascii: "Tiaret"
    },
    {
        commune_name: "مغيلة",
        commune_name_ascii: "Meghila",
        daira_name: "مغيلة",
        daira_name_ascii: "Meghila",
        wilaya_code: 14,
        wilaya_name: "تيارت",
        wilaya_name_ascii: "Tiaret"
    },
    {
        commune_name: "السبت",
        commune_name_ascii: "Sebt",
        daira_name: "مغيلة",
        daira_name_ascii: "Meghila",
        wilaya_code: 14,
        wilaya_name: "تيارت",
        wilaya_name_ascii: "Tiaret"
    },
    {
        commune_name: "سيدي حسني",
        commune_name_ascii: "Sidi Hosni",
        daira_name: "مغيلة",
        daira_name_ascii: "Meghila",
        wilaya_code: 14,
        wilaya_name: "تيارت",
        wilaya_name_ascii: "Tiaret"
    },
    {
        commune_name: "عين الحديد",
        commune_name_ascii: "Ain El Hadid",
        daira_name: "فرندة",
        daira_name_ascii: "Frenda",
        wilaya_code: 14,
        wilaya_name: "تيارت",
        wilaya_name_ascii: "Tiaret"
    },
    {
        commune_name: "فرندة",
        commune_name_ascii: "Frenda",
        daira_name: "فرندة",
        daira_name_ascii: "Frenda",
        wilaya_code: 14,
        wilaya_name: "تيارت",
        wilaya_name_ascii: "Tiaret"
    },
    {
        commune_name: "تخمرت",
        commune_name_ascii: "Takhemaret",
        daira_name: "فرندة",
        daira_name_ascii: "Frenda",
        wilaya_code: 14,
        wilaya_name: "تيارت",
        wilaya_name_ascii: "Tiaret"
    },
    {
        commune_name: "عين كرمس",
        commune_name_ascii: "Ain Kermes",
        daira_name: "عين كرمس",
        daira_name_ascii: "Ain Kermes",
        wilaya_code: 14,
        wilaya_name: "تيارت",
        wilaya_name_ascii: "Tiaret"
    },
    {
        commune_name: "جبيلات الرصفاء",
        commune_name_ascii: "Djebilet Rosfa",
        daira_name: "عين كرمس",
        daira_name_ascii: "Ain Kermes",
        wilaya_code: 14,
        wilaya_name: "تيارت",
        wilaya_name_ascii: "Tiaret"
    },
    {
        commune_name: "مادنة",
        commune_name_ascii: "Madna",
        daira_name: "عين كرمس",
        daira_name_ascii: "Ain Kermes",
        wilaya_code: 14,
        wilaya_name: "تيارت",
        wilaya_name_ascii: "Tiaret"
    },
    {
        commune_name: "مدريسة",
        commune_name_ascii: "Medrissa",
        daira_name: "عين كرمس",
        daira_name_ascii: "Ain Kermes",
        wilaya_code: 14,
        wilaya_name: "تيارت",
        wilaya_name_ascii: "Tiaret"
    },
    {
        commune_name: "سيدي عبد الرحمن",
        commune_name_ascii: "Sidi Abderrahmane",
        daira_name: "عين كرمس",
        daira_name_ascii: "Ain Kermes",
        wilaya_code: 14,
        wilaya_name: "تيارت",
        wilaya_name_ascii: "Tiaret"
    },
    {
        commune_name: "قصر الشلالة",
        commune_name_ascii: "Ksar Chellala",
        daira_name: "قصر الشلالة",
        daira_name_ascii: "Ksar Chellala",
        wilaya_code: 14,
        wilaya_name: "تيارت",
        wilaya_name_ascii: "Tiaret"
    },
    {
        commune_name: "قرطوفة",
        commune_name_ascii: "Guertoufa",
        daira_name: "رحوية",
        daira_name_ascii: "Rahouia",
        wilaya_code: 14,
        wilaya_name: "تيارت",
        wilaya_name_ascii: "Tiaret"
    },
    {
        commune_name: "سرغين",
        commune_name_ascii: "Serghine",
        daira_name: "قصر الشلالة",
        daira_name_ascii: "Ksar Chellala",
        wilaya_code: 14,
        wilaya_name: "تيارت",
        wilaya_name_ascii: "Tiaret"
    },
    {
        commune_name: "زمالة  الأمير عبد القادر",
        commune_name_ascii: "Zmalet El Emir Abdelkade",
        daira_name: "قصر الشلالة",
        daira_name_ascii: "Ksar Chellala",
        wilaya_code: 14,
        wilaya_name: "تيارت",
        wilaya_name_ascii: "Tiaret"
    },
    {
        commune_name: "وادي ليلي",
        commune_name_ascii: "Oued Lilli",
        daira_name: "وادي ليلي",
        daira_name_ascii: "Oued Lili",
        wilaya_code: 14,
        wilaya_name: "تيارت",
        wilaya_name_ascii: "Tiaret"
    },
    {
        commune_name: "سيدي علي ملال",
        commune_name_ascii: "Sidi Ali Mellal",
        daira_name: "وادي ليلي",
        daira_name_ascii: "Oued Lili",
        wilaya_code: 14,
        wilaya_name: "تيارت",
        wilaya_name_ascii: "Tiaret"
    },
    {
        commune_name: "جيلالي بن عمار",
        commune_name_ascii: "Djillali Ben Amar",
        daira_name: "مشرع الصفا",
        daira_name_ascii: "Mechraa Sfa",
        wilaya_code: 14,
        wilaya_name: "تيارت",
        wilaya_name_ascii: "Tiaret"
    },
    {
        commune_name: "مشرع الصفا",
        commune_name_ascii: "Mechraa Safa",
        daira_name: "مشرع الصفا",
        daira_name_ascii: "Mechraa Sfa",
        wilaya_code: 14,
        wilaya_name: "تيارت",
        wilaya_name_ascii: "Tiaret"
    },
    {
        commune_name: "تاقدمت",
        commune_name_ascii: "Tagdempt",
        daira_name: "مشرع الصفا",
        daira_name_ascii: "Mechraa Sfa",
        wilaya_code: 14,
        wilaya_name: "تيارت",
        wilaya_name_ascii: "Tiaret"
    },
    {
        commune_name: "بوقرة",
        commune_name_ascii: "Bougara",
        daira_name: "حمادية",
        daira_name_ascii: "Hamadia",
        wilaya_code: 14,
        wilaya_name: "تيارت",
        wilaya_name_ascii: "Tiaret"
    },
    {
        commune_name: "حمادية",
        commune_name_ascii: "Hamadia",
        daira_name: "حمادية",
        daira_name_ascii: "Hamadia",
        wilaya_code: 14,
        wilaya_name: "تيارت",
        wilaya_name_ascii: "Tiaret"
    },
    {
        commune_name: "الرشايقة",
        commune_name_ascii: "Rechaiga",
        daira_name: "حمادية",
        daira_name_ascii: "Hamadia",
        wilaya_code: 14,
        wilaya_name: "تيارت",
        wilaya_name_ascii: "Tiaret"
    },
    {
        commune_name: "تيدة",
        commune_name_ascii: "Tidda",
        daira_name: "وادي ليلي",
        daira_name_ascii: "Oued Lili",
        wilaya_code: 14,
        wilaya_name: "تيارت",
        wilaya_name_ascii: "Tiaret"
    },
    {
        commune_name: "الناظورة",
        commune_name_ascii: "Nadorah",
        daira_name: "مهدية",
        daira_name_ascii: "Mahdia",
        wilaya_code: 14,
        wilaya_name: "تيارت",
        wilaya_name_ascii: "Tiaret"
    },
    {
        commune_name: "تيارت",
        commune_name_ascii: "Tiaret",
        daira_name: "تيارت",
        daira_name_ascii: "Tiaret",
        wilaya_code: 14,
        wilaya_name: "تيارت",
        wilaya_name_ascii: "Tiaret"
    },
    {
        commune_name: "مدروسة",
        commune_name_ascii: "Medroussa",
        daira_name: "مدروسة",
        daira_name_ascii: "Medroussa",
        wilaya_code: 14,
        wilaya_name: "تيارت",
        wilaya_name_ascii: "Tiaret"
    },
    {
        commune_name: "ملاكو",
        commune_name_ascii: "Mellakou",
        daira_name: "مدروسة",
        daira_name_ascii: "Medroussa",
        wilaya_code: 14,
        wilaya_name: "تيارت",
        wilaya_name_ascii: "Tiaret"
    },
    {
        commune_name: "سيدي بختي",
        commune_name_ascii: "Sidi Bakhti",
        daira_name: "مدروسة",
        daira_name_ascii: "Medroussa",
        wilaya_code: 14,
        wilaya_name: "تيارت",
        wilaya_name_ascii: "Tiaret"
    },
    {
        commune_name: "عين الذهب",
        commune_name_ascii: "Ain Deheb",
        daira_name: "عين الذهب",
        daira_name_ascii: "Ain Deheb",
        wilaya_code: 14,
        wilaya_name: "تيارت",
        wilaya_name_ascii: "Tiaret"
    },
    {
        commune_name: "شحيمة",
        commune_name_ascii: "Chehaima",
        daira_name: "عين الذهب",
        daira_name_ascii: "Ain Deheb",
        wilaya_code: 14,
        wilaya_name: "تيارت",
        wilaya_name_ascii: "Tiaret"
    },
    {
        commune_name: "النعيمة",
        commune_name_ascii: "Naima",
        daira_name: "عين الذهب",
        daira_name_ascii: "Ain Deheb",
        wilaya_code: 14,
        wilaya_name: "تيارت",
        wilaya_name_ascii: "Tiaret"
    },
    {
        commune_name: "عين بوشقيف",
        commune_name_ascii: "Ain Bouchekif",
        daira_name: "دحموني",
        daira_name_ascii: "Dahmouni",
        wilaya_code: 14,
        wilaya_name: "تيارت",
        wilaya_name_ascii: "Tiaret"
    },
    {
        commune_name: "دحموني",
        commune_name_ascii: "Dahmouni",
        daira_name: "دحموني",
        daira_name_ascii: "Dahmouni",
        wilaya_code: 14,
        wilaya_name: "تيارت",
        wilaya_name_ascii: "Tiaret"
    },
    {
        commune_name: "الرحوية",
        commune_name_ascii: "Rahouia",
        daira_name: "رحوية",
        daira_name_ascii: "Rahouia",
        wilaya_code: 14,
        wilaya_name: "تيارت",
        wilaya_name_ascii: "Tiaret"
    },
    {
        commune_name: "ميزرانـــة",
        commune_name_ascii: "Mizrana",
        daira_name: "تيقزيرت",
        daira_name_ascii: "Tigzirt",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "إيجــار",
        commune_name_ascii: "Idjeur",
        daira_name: "بوزقن",
        daira_name_ascii: "Bouzeguene",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "بني دوالة",
        commune_name_ascii: "Beni-Douala",
        daira_name: "بني دوالة",
        daira_name_ascii: "Beni Douala",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "بني زيكــي",
        commune_name_ascii: "Beni-Zikki",
        daira_name: "بوزقن",
        daira_name_ascii: "Bouzeguene",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "إيلولة أومـــالو",
        commune_name_ascii: "Illoula Oumalou",
        daira_name: "بوزقن",
        daira_name_ascii: "Bouzeguene",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "أقني قغران",
        commune_name_ascii: "Agouni-Gueghrane",
        daira_name: "واضية",
        daira_name_ascii: "Ouadhias",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "أيت بــوادو",
        commune_name_ascii: "Ait Bouaddou",
        daira_name: "واضية",
        daira_name_ascii: "Ouadhias",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "واضية",
        commune_name_ascii: "Ouadhias",
        daira_name: "واضية",
        daira_name_ascii: "Ouadhias",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "تيزي نثلاثة",
        commune_name_ascii: "Tizi N'tleta",
        daira_name: "واضية",
        daira_name_ascii: "Ouadhias",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "أغريب",
        commune_name_ascii: "Aghribs",
        daira_name: "أزفون",
        daira_name_ascii: "Azeffoun",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "أيت شافع",
        commune_name_ascii: "Ait-Chafaa",
        daira_name: "أزفون",
        daira_name_ascii: "Azeffoun",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "أقرو",
        commune_name_ascii: "Akerrou",
        daira_name: "أزفون",
        daira_name_ascii: "Azeffoun",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "أزفون",
        commune_name_ascii: "Azeffoun",
        daira_name: "أزفون",
        daira_name_ascii: "Azeffoun",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "إفليـــسن",
        commune_name_ascii: "Iflissen",
        daira_name: "تيقزيرت",
        daira_name_ascii: "Tigzirt",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "تيقـزيرت",
        commune_name_ascii: "Tigzirt",
        daira_name: "تيقزيرت",
        daira_name_ascii: "Tigzirt",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "أسي يوسف",
        commune_name_ascii: "Assi-Youcef",
        daira_name: "بوغني",
        daira_name_ascii: "Boghni",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "بوغني",
        commune_name_ascii: "Boghni",
        daira_name: "بوغني",
        daira_name_ascii: "Boghni",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "بونوح",
        commune_name_ascii: "Bounouh",
        daira_name: "بوغني",
        daira_name_ascii: "Boghni",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "مشطراس",
        commune_name_ascii: "Mechtras",
        daira_name: "بوغني",
        daira_name_ascii: "Boghni",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "ذراع بن خدة",
        commune_name_ascii: "Draa-Ben-Khedda",
        daira_name: "ذراع بن خدة",
        daira_name_ascii: "Draa Ben Khedda",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "سيدي نعمان",
        commune_name_ascii: "Sidi Namane",
        daira_name: "ذراع بن خدة",
        daira_name_ascii: "Draa Ben Khedda",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "تادمايت",
        commune_name_ascii: "Tadmait",
        daira_name: "ذراع بن خدة",
        daira_name_ascii: "Draa Ben Khedda",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "تيرمتين",
        commune_name_ascii: "Tirmitine",
        daira_name: "ذراع بن خدة",
        daira_name_ascii: "Draa Ben Khedda",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "أيت بومهدي",
        commune_name_ascii: "Ait Boumahdi",
        daira_name: "واسيف",
        daira_name_ascii: "Ouacif",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "أيت تودرت",
        commune_name_ascii: "Ait-Toudert",
        daira_name: "واسيف",
        daira_name_ascii: "Ouacif",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "بني عيسي",
        commune_name_ascii: "Beni-Aissi",
        daira_name: "بني دوالة",
        daira_name_ascii: "Beni Douala",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "واسيف",
        commune_name_ascii: "Ouacif",
        daira_name: "واسيف",
        daira_name_ascii: "Ouacif",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "أيت خليلي",
        commune_name_ascii: "Ait Khellili",
        daira_name: "مقلع",
        daira_name_ascii: "Mekla",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "مقــلع",
        commune_name_ascii: "Mekla",
        daira_name: "مقلع",
        daira_name_ascii: "Mekla",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "صوامـــع",
        commune_name_ascii: "Souama",
        daira_name: "مقلع",
        daira_name_ascii: "Mekla",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "بني يني",
        commune_name_ascii: "Beni-Yenni",
        daira_name: "بني يني",
        daira_name_ascii: "Benni Yenni",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "إبودرارن",
        commune_name_ascii: "Iboudrarene",
        daira_name: "بني يني",
        daira_name_ascii: "Benni Yenni",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "تيزي وزو",
        commune_name_ascii: "Tizi-Ouzou",
        daira_name: "تيزي وزو",
        daira_name_ascii: "Tizi Ouzou",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "أبي يوسف",
        commune_name_ascii: "Abi-Youcef",
        daira_name: "عين الحمام",
        daira_name_ascii: "Ain El Hammam",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "عين الحمام",
        commune_name_ascii: "Ain-El-Hammam",
        daira_name: "عين الحمام",
        daira_name_ascii: "Ain El Hammam",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "أيت يحيى",
        commune_name_ascii: "Ait-Yahia",
        daira_name: "عين الحمام",
        daira_name_ascii: "Ain El Hammam",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "اقبيل",
        commune_name_ascii: "Akbil",
        daira_name: "عين الحمام",
        daira_name_ascii: "Ain El Hammam",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "بوجيمة",
        commune_name_ascii: "Boudjima",
        daira_name: "ماكودة",
        daira_name_ascii: "Makouda",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "ماكودة",
        commune_name_ascii: "Makouda",
        daira_name: "ماكودة",
        daira_name_ascii: "Makouda",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "عين الزاوية",
        commune_name_ascii: "Ain-Zaouia",
        daira_name: "ذراع الميزان",
        daira_name_ascii: "Draa El Mizan",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "أيت يحي موسى",
        commune_name_ascii: "Ait Yahia Moussa",
        daira_name: "ذراع الميزان",
        daira_name_ascii: "Draa El Mizan",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "ذراع الميزان",
        commune_name_ascii: "Draa-El-Mizan",
        daira_name: "ذراع الميزان",
        daira_name_ascii: "Draa El Mizan",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "فريقات",
        commune_name_ascii: "Frikat",
        daira_name: "ذراع الميزان",
        daira_name_ascii: "Draa El Mizan",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "مكيرة",
        commune_name_ascii: "M'kira",
        daira_name: "تيزي غنيف",
        daira_name_ascii: "Tizi-Ghenif",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "تيزي غنيف",
        commune_name_ascii: "Tizi-Gheniff",
        daira_name: "تيزي غنيف",
        daira_name_ascii: "Tizi-Ghenif",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "يطــافن",
        commune_name_ascii: "Yatafene",
        daira_name: "بني يني",
        daira_name_ascii: "Benni Yenni",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "إيلـيــلتـن",
        commune_name_ascii: "Illilten",
        daira_name: "إفرحونان",
        daira_name_ascii: "Iferhounene",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "إمســوحال",
        commune_name_ascii: "Imsouhal",
        daira_name: "إفرحونان",
        daira_name_ascii: "Iferhounene",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "عزازقة",
        commune_name_ascii: "Azazga",
        daira_name: "عزازقة",
        daira_name_ascii: "Azazga",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "فريحة",
        commune_name_ascii: "Freha",
        daira_name: "عزازقة",
        daira_name_ascii: "Azazga",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "إيفيغاء",
        commune_name_ascii: "Ifigha",
        daira_name: "عزازقة",
        daira_name_ascii: "Azazga",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "إعــكورن",
        commune_name_ascii: "Yakourene",
        daira_name: "عزازقة",
        daira_name_ascii: "Azazga",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "زكري",
        commune_name_ascii: "Zekri",
        daira_name: "عزازقة",
        daira_name_ascii: "Azazga",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "أيت عقـواشة",
        commune_name_ascii: "Ait Aggouacha",
        daira_name: "الأربعاء ناث إيراثن",
        daira_name_ascii: "Larbaa Nath Iraten",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "إيرجـــن",
        commune_name_ascii: "Irdjen",
        daira_name: "الأربعاء ناث إيراثن",
        daira_name_ascii: "Larbaa Nath Iraten",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "الأربعــاء ناث إيراثن",
        commune_name_ascii: "Larbaa Nath Irathen",
        daira_name: "الأربعاء ناث إيراثن",
        daira_name_ascii: "Larbaa Nath Iraten",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "أيت  أومالو",
        commune_name_ascii: "Ait-Oumalou",
        daira_name: "تيزي راشد",
        daira_name_ascii: "Tizi Rached",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "تيزي راشد",
        commune_name_ascii: "Tizi-Rached",
        daira_name: "تيزي راشد",
        daira_name_ascii: "Tizi Rached",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "أيت عيسى ميمون",
        commune_name_ascii: "Ait-Aissa-Mimoun",
        daira_name: "واقنون",
        daira_name_ascii: "Ouaguenoun",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "واقنون",
        commune_name_ascii: "Ouaguenoun",
        daira_name: "واقنون",
        daira_name_ascii: "Ouaguenoun",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "تيمـيزار",
        commune_name_ascii: "Timizart",
        daira_name: "واقنون",
        daira_name_ascii: "Ouaguenoun",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "معـــاتقة",
        commune_name_ascii: "Maatkas",
        daira_name: "معاتقة",
        daira_name_ascii: "Maatkas",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "سوق الإثنين",
        commune_name_ascii: "Souk-El-Tenine",
        daira_name: "معاتقة",
        daira_name_ascii: "Maatkas",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "أيت محمود",
        commune_name_ascii: "Ait-Mahmoud",
        daira_name: "بني دوالة",
        daira_name_ascii: "Beni Douala",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "بنــــي زمنزار",
        commune_name_ascii: "Beni Zmenzer",
        daira_name: "بني دوالة",
        daira_name_ascii: "Beni Douala",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "إفــرحــونان",
        commune_name_ascii: "Iferhounene",
        daira_name: "إفرحونان",
        daira_name_ascii: "Iferhounene",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "بوزقــن",
        commune_name_ascii: "Bouzeguene",
        daira_name: "بوزقن",
        daira_name_ascii: "Bouzeguene",
        wilaya_code: 15,
        wilaya_name: "تيزي وزو",
        wilaya_name_ascii: "Tizi Ouzou"
    },
    {
        commune_name: "حسين داي",
        commune_name_ascii: "Hussein Dey",
        daira_name: "حسين داي",
        daira_name_ascii: "Hussein Dey",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "الكاليتوس",
        commune_name_ascii: "Les Eucalyptus",
        daira_name: "براقي",
        daira_name_ascii: "Baraki",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "سيدي موسى",
        commune_name_ascii: "Sidi Moussa",
        daira_name: "براقي",
        daira_name_ascii: "Baraki",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "القبة",
        commune_name_ascii: "Kouba",
        daira_name: "حسين داي",
        daira_name_ascii: "Hussein Dey",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "محمد بلوزداد",
        commune_name_ascii: "Mohamed Belouzdad",
        daira_name: "حسين داي",
        daira_name_ascii: "Hussein Dey",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "عين طاية",
        commune_name_ascii: "Ain Taya",
        daira_name: "الدار البيضاء",
        daira_name_ascii: "Dar El Beida",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "باب الزوار",
        commune_name_ascii: "Bab Ezzouar",
        daira_name: "الدار البيضاء",
        daira_name_ascii: "Dar El Beida",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "برج الكيفان",
        commune_name_ascii: "Bordj El Kiffan",
        daira_name: "الدار البيضاء",
        daira_name_ascii: "Dar El Beida",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "الدار البيضاء",
        commune_name_ascii: "Dar El Beida",
        daira_name: "الدار البيضاء",
        daira_name_ascii: "Dar El Beida",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "المرسى",
        commune_name_ascii: "El Marsa",
        daira_name: "الدار البيضاء",
        daira_name_ascii: "Dar El Beida",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "المحمدية",
        commune_name_ascii: "Mohammadia",
        daira_name: "الدار البيضاء",
        daira_name_ascii: "Dar El Beida",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "بئر توتة",
        commune_name_ascii: "Bir Touta",
        daira_name: "بئر توتة",
        daira_name_ascii: "Birtouta",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "اولاد شبل",
        commune_name_ascii: "Ouled Chebel",
        daira_name: "بئر توتة",
        daira_name_ascii: "Birtouta",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "تسالة المرجة",
        commune_name_ascii: "Tessala El Merdja",
        daira_name: "بئر توتة",
        daira_name_ascii: "Birtouta",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "هراوة",
        commune_name_ascii: "Herraoua",
        daira_name: "الرويبة",
        daira_name_ascii: "Rouiba",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "رغاية",
        commune_name_ascii: "Reghaia",
        daira_name: "الرويبة",
        daira_name_ascii: "Rouiba",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "الرويبة",
        commune_name_ascii: "Rouiba",
        daira_name: "الرويبة",
        daira_name_ascii: "Rouiba",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "المعالمة",
        commune_name_ascii: "Maalma",
        daira_name: "زرالدة",
        daira_name_ascii: "Zeralda",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "الرحمانية",
        commune_name_ascii: "Rahmania",
        daira_name: "زرالدة",
        daira_name_ascii: "Zeralda",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "سويدانية",
        commune_name_ascii: "Souidania",
        daira_name: "زرالدة",
        daira_name_ascii: "Zeralda",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "سطاوالي",
        commune_name_ascii: "Staoueli",
        daira_name: "زرالدة",
        daira_name_ascii: "Zeralda",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "زرالدة",
        commune_name_ascii: "Zeralda",
        daira_name: "زرالدة",
        daira_name_ascii: "Zeralda",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "بابا حسن",
        commune_name_ascii: "Baba Hassen",
        daira_name: "الدرارية",
        daira_name_ascii: "Draria",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "الدويرة",
        commune_name_ascii: "Douira",
        daira_name: "الدرارية",
        daira_name_ascii: "Draria",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "الدرارية",
        commune_name_ascii: "Draria",
        daira_name: "الدرارية",
        daira_name_ascii: "Draria",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "العاشور",
        commune_name_ascii: "El Achour",
        daira_name: "الدرارية",
        daira_name_ascii: "Draria",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "الخرايسية",
        commune_name_ascii: "Khraissia",
        daira_name: "الدرارية",
        daira_name_ascii: "Draria",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "عين بنيان",
        commune_name_ascii: "Ain Benian",
        daira_name: "الشراقة",
        daira_name_ascii: "Cheraga",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "الشراقة",
        commune_name_ascii: "Cheraga",
        daira_name: "الشراقة",
        daira_name_ascii: "Cheraga",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "دالي ابراهيم",
        commune_name_ascii: "Dely Ibrahim",
        daira_name: "الشراقة",
        daira_name_ascii: "Cheraga",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "الحمامات",
        commune_name_ascii: "Hammamet",
        daira_name: "الشراقة",
        daira_name_ascii: "Cheraga",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "اولاد فايت",
        commune_name_ascii: "Ouled Fayet",
        daira_name: "الشراقة",
        daira_name_ascii: "Cheraga",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "الجزائر الوسطى",
        commune_name_ascii: "Alger Centre",
        daira_name: "سيدي امحمد",
        daira_name_ascii: "Sidi M'hamed",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "المدنية",
        commune_name_ascii: "El Madania",
        daira_name: "سيدي امحمد",
        daira_name_ascii: "Sidi M'hamed",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "المرادية",
        commune_name_ascii: "El Mouradia",
        daira_name: "سيدي امحمد",
        daira_name_ascii: "Sidi M'hamed",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "سيدي امحمد",
        commune_name_ascii: "Sidi M'hamed",
        daira_name: "سيدي امحمد",
        daira_name_ascii: "Sidi M'hamed",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "السحاولة",
        commune_name_ascii: "Sehaoula",
        daira_name: "بئر مراد رايس",
        daira_name_ascii: "Bir Mourad Rais",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "بولوغين بن زيري",
        commune_name_ascii: "Bologhine Ibnou Ziri",
        daira_name: "باب الوادي",
        daira_name_ascii: "Bab El Oued",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "القصبة",
        commune_name_ascii: "Casbah",
        daira_name: "باب الوادي",
        daira_name_ascii: "Bab El Oued",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "وادي قريش",
        commune_name_ascii: "Oued Koriche",
        daira_name: "باب الوادي",
        daira_name_ascii: "Bab El Oued",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "الرايس حميدو",
        commune_name_ascii: "Rais Hamidou",
        daira_name: "باب الوادي",
        daira_name_ascii: "Bab El Oued",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "بئر مراد رايس",
        commune_name_ascii: "Bir Mourad Rais",
        daira_name: "بئر مراد رايس",
        daira_name_ascii: "Bir Mourad Rais",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "بئر خادم",
        commune_name_ascii: "Birkhadem",
        daira_name: "بئر مراد رايس",
        daira_name_ascii: "Bir Mourad Rais",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "جسر قسنطينة",
        commune_name_ascii: "Djasr Kasentina",
        daira_name: "بئر مراد رايس",
        daira_name_ascii: "Bir Mourad Rais",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "حيدرة",
        commune_name_ascii: "Hydra",
        daira_name: "بئر مراد رايس",
        daira_name_ascii: "Bir Mourad Rais",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "المغارية",
        commune_name_ascii: "El Magharia",
        daira_name: "حسين داي",
        daira_name_ascii: "Hussein Dey",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "ابن عكنون",
        commune_name_ascii: "Ben Aknoun",
        daira_name: "بوزريعة",
        daira_name_ascii: "Bouzareah",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "بني مسوس",
        commune_name_ascii: "Beni Messous",
        daira_name: "بوزريعة",
        daira_name_ascii: "Bouzareah",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "بوزريعة",
        commune_name_ascii: "Bouzareah",
        daira_name: "بوزريعة",
        daira_name_ascii: "Bouzareah",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "الابيار",
        commune_name_ascii: "El Biar",
        daira_name: "بوزريعة",
        daira_name_ascii: "Bouzareah",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "باش جراح",
        commune_name_ascii: "Bachedjerah",
        daira_name: "الحراش",
        daira_name_ascii: "El Harrach",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "بوروبة",
        commune_name_ascii: "Bourouba",
        daira_name: "الحراش",
        daira_name_ascii: "El Harrach",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "الحراش",
        commune_name_ascii: "El Harrach",
        daira_name: "الحراش",
        daira_name_ascii: "El Harrach",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "وادي السمار",
        commune_name_ascii: "Oued Smar",
        daira_name: "الحراش",
        daira_name_ascii: "El Harrach",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "براقي",
        commune_name_ascii: "Baraki",
        daira_name: "براقي",
        daira_name_ascii: "Baraki",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "برج البحري",
        commune_name_ascii: "Bordj El Bahri",
        daira_name: "الدار البيضاء",
        daira_name_ascii: "Dar El Beida",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "باب الوادي",
        commune_name_ascii: "Bab El Oued",
        daira_name: "باب الوادي",
        daira_name_ascii: "Bab El Oued",
        wilaya_code: 16,
        wilaya_name: "الجزائر",
        wilaya_name_ascii: "Alger"
    },
    {
        commune_name: "حاسي العش",
        commune_name_ascii: "Hassi El Euch",
        daira_name: "حاسي بحبح",
        daira_name_ascii: "Hassi Bahbah",
        wilaya_code: 17,
        wilaya_name: "الجلفة",
        wilaya_name_ascii: "Djelfa"
    },
    {
        commune_name: "عين الإبل",
        commune_name_ascii: "Ain El Ibel",
        daira_name: "عين الإبل",
        daira_name_ascii: "Ain El Ibel",
        wilaya_code: 17,
        wilaya_name: "الجلفة",
        wilaya_name_ascii: "Djelfa"
    },
    {
        commune_name: "القديد",
        commune_name_ascii: "El Guedid",
        daira_name: "الشارف",
        daira_name_ascii: "Charef",
        wilaya_code: 17,
        wilaya_name: "الجلفة",
        wilaya_name_ascii: "Djelfa"
    },
    {
        commune_name: "الشارف",
        commune_name_ascii: "Charef",
        daira_name: "الشارف",
        daira_name_ascii: "Charef",
        wilaya_code: 17,
        wilaya_name: "الجلفة",
        wilaya_name_ascii: "Djelfa"
    },
    {
        commune_name: "بن يعقوب",
        commune_name_ascii: "Benyagoub",
        daira_name: "الشارف",
        daira_name_ascii: "Charef",
        wilaya_code: 17,
        wilaya_name: "الجلفة",
        wilaya_name_ascii: "Djelfa"
    },
    {
        commune_name: "سيدي بايزيد",
        commune_name_ascii: "Sidi Baizid",
        daira_name: "دار الشيوخ",
        daira_name_ascii: "Dar Chioukh",
        wilaya_code: 17,
        wilaya_name: "الجلفة",
        wilaya_name_ascii: "Djelfa"
    },
    {
        commune_name: "مليليحة",
        commune_name_ascii: "M'liliha",
        daira_name: "دار الشيوخ",
        daira_name_ascii: "Dar Chioukh",
        wilaya_code: 17,
        wilaya_name: "الجلفة",
        wilaya_name_ascii: "Djelfa"
    },
    {
        commune_name: "دار الشيوخ",
        commune_name_ascii: "Dar Chioukh",
        daira_name: "دار الشيوخ",
        daira_name_ascii: "Dar Chioukh",
        wilaya_code: 17,
        wilaya_name: "الجلفة",
        wilaya_name_ascii: "Djelfa"
    },
    {
        commune_name: "تعظميت",
        commune_name_ascii: "Taadmit",
        daira_name: "عين الإبل",
        daira_name_ascii: "Ain El Ibel",
        wilaya_code: 17,
        wilaya_name: "الجلفة",
        wilaya_name_ascii: "Djelfa"
    },
    {
        commune_name: "حد الصحاري",
        commune_name_ascii: "Had Sahary",
        daira_name: "حد الصحاري",
        daira_name_ascii: "Had Sahary",
        wilaya_code: 17,
        wilaya_name: "الجلفة",
        wilaya_name_ascii: "Djelfa"
    },
    {
        commune_name: "بويرة الأحداب",
        commune_name_ascii: "Bouira Lahdab",
        daira_name: "حد الصحاري",
        daira_name_ascii: "Had Sahary",
        wilaya_code: 17,
        wilaya_name: "الجلفة",
        wilaya_name_ascii: "Djelfa"
    },
    {
        commune_name: "عين فقه",
        commune_name_ascii: "Ain Fekka",
        daira_name: "حد الصحاري",
        daira_name_ascii: "Had Sahary",
        wilaya_code: 17,
        wilaya_name: "الجلفة",
        wilaya_name_ascii: "Djelfa"
    },
    {
        commune_name: "سيدي لعجال",
        commune_name_ascii: "Sidi Laadjel",
        daira_name: "سيدي لعجال",
        daira_name_ascii: "Sidi Laadjel",
        wilaya_code: 17,
        wilaya_name: "الجلفة",
        wilaya_name_ascii: "Djelfa"
    },
    {
        commune_name: "حاسي فدول",
        commune_name_ascii: "Hassi Fedoul",
        daira_name: "سيدي لعجال",
        daira_name_ascii: "Sidi Laadjel",
        wilaya_code: 17,
        wilaya_name: "الجلفة",
        wilaya_name_ascii: "Djelfa"
    },
    {
        commune_name: "الخميس",
        commune_name_ascii: "El Khemis",
        daira_name: "سيدي لعجال",
        daira_name_ascii: "Sidi Laadjel",
        wilaya_code: 17,
        wilaya_name: "الجلفة",
        wilaya_name_ascii: "Djelfa"
    },
    {
        commune_name: "سلمانة",
        commune_name_ascii: "Selmana",
        daira_name: "مسعد",
        daira_name_ascii: "Messaad",
        wilaya_code: 17,
        wilaya_name: "الجلفة",
        wilaya_name_ascii: "Djelfa"
    },
    {
        commune_name: "سد الرحال",
        commune_name_ascii: "Sed Rahal",
        daira_name: "مسعد",
        daira_name_ascii: "Messaad",
        wilaya_code: 17,
        wilaya_name: "الجلفة",
        wilaya_name_ascii: "Djelfa"
    },
    {
        commune_name: "مسعد",
        commune_name_ascii: "Messaad",
        daira_name: "مسعد",
        daira_name_ascii: "Messaad",
        wilaya_code: 17,
        wilaya_name: "الجلفة",
        wilaya_name_ascii: "Djelfa"
    },
    {
        commune_name: "قطارة",
        commune_name_ascii: "Guettara",
        daira_name: "مسعد",
        daira_name_ascii: "Messaad",
        wilaya_code: 17,
        wilaya_name: "الجلفة",
        wilaya_name_ascii: "Djelfa"
    },
    {
        commune_name: "دلدول",
        commune_name_ascii: "Deldoul",
        daira_name: "مسعد",
        daira_name_ascii: "Messaad",
        wilaya_code: 17,
        wilaya_name: "الجلفة",
        wilaya_name_ascii: "Djelfa"
    },
    {
        commune_name: "زكار",
        commune_name_ascii: "Zaccar",
        daira_name: "عين الإبل",
        daira_name_ascii: "Ain El Ibel",
        wilaya_code: 17,
        wilaya_name: "الجلفة",
        wilaya_name_ascii: "Djelfa"
    },
    {
        commune_name: "دويس",
        commune_name_ascii: "Douis",
        daira_name: "الادريسية",
        daira_name_ascii: "El Idrissia",
        wilaya_code: 17,
        wilaya_name: "الجلفة",
        wilaya_name_ascii: "Djelfa"
    },
    {
        commune_name: "الادريسية",
        commune_name_ascii: "El Idrissia",
        daira_name: "الادريسية",
        daira_name_ascii: "El Idrissia",
        wilaya_code: 17,
        wilaya_name: "الجلفة",
        wilaya_name_ascii: "Djelfa"
    },
    {
        commune_name: "عين الشهداء",
        commune_name_ascii: "Ain Chouhada",
        daira_name: "الادريسية",
        daira_name_ascii: "El Idrissia",
        wilaya_code: 17,
        wilaya_name: "الجلفة",
        wilaya_name_ascii: "Djelfa"
    },
    {
        commune_name: "الجلفة",
        commune_name_ascii: "Djelfa",
        daira_name: "الجلفة",
        daira_name_ascii: "Djelfa",
        wilaya_code: 17,
        wilaya_name: "الجلفة",
        wilaya_name_ascii: "Djelfa"
    },
    {
        commune_name: "بيرين",
        commune_name_ascii: "Birine",
        daira_name: "بيرين",
        daira_name_ascii: "Birine",
        wilaya_code: 17,
        wilaya_name: "الجلفة",
        wilaya_name_ascii: "Djelfa"
    },
    {
        commune_name: "أم العظام",
        commune_name_ascii: "Oum Laadham",
        daira_name: "فيض البطمة",
        daira_name_ascii: "Faidh El Botma",
        wilaya_code: 17,
        wilaya_name: "الجلفة",
        wilaya_name_ascii: "Djelfa"
    },
    {
        commune_name: "فيض البطمة",
        commune_name_ascii: "Faidh El Botma",
        daira_name: "فيض البطمة",
        daira_name_ascii: "Faidh El Botma",
        wilaya_code: 17,
        wilaya_name: "الجلفة",
        wilaya_name_ascii: "Djelfa"
    },
    {
        commune_name: "عمورة",
        commune_name_ascii: "Amourah",
        daira_name: "فيض البطمة",
        daira_name_ascii: "Faidh El Botma",
        wilaya_code: 17,
        wilaya_name: "الجلفة",
        wilaya_name_ascii: "Djelfa"
    },
    {
        commune_name: "زعفران",
        commune_name_ascii: "Zaafrane",
        daira_name: "حاسي بحبح",
        daira_name_ascii: "Hassi Bahbah",
        wilaya_code: 17,
        wilaya_name: "الجلفة",
        wilaya_name_ascii: "Djelfa"
    },
    {
        commune_name: "قرنيني",
        commune_name_ascii: "Guernini",
        daira_name: "عين وسارة",
        daira_name_ascii: "Ain Oussera",
        wilaya_code: 17,
        wilaya_name: "الجلفة",
        wilaya_name_ascii: "Djelfa"
    },
    {
        commune_name: "عين وسارة",
        commune_name_ascii: "Ain Oussera",
        daira_name: "عين وسارة",
        daira_name_ascii: "Ain Oussera",
        wilaya_code: 17,
        wilaya_name: "الجلفة",
        wilaya_name_ascii: "Djelfa"
    },
    {
        commune_name: "بنهار",
        commune_name_ascii: "Benhar",
        daira_name: "بيرين",
        daira_name_ascii: "Birine",
        wilaya_code: 17,
        wilaya_name: "الجلفة",
        wilaya_name_ascii: "Djelfa"
    },
    {
        commune_name: "عين معبد",
        commune_name_ascii: "Ain Maabed",
        daira_name: "حاسي بحبح",
        daira_name_ascii: "Hassi Bahbah",
        wilaya_code: 17,
        wilaya_name: "الجلفة",
        wilaya_name_ascii: "Djelfa"
    },
    {
        commune_name: "حاسي بحبح",
        commune_name_ascii: "Hassi Bahbah",
        daira_name: "حاسي بحبح",
        daira_name_ascii: "Hassi Bahbah",
        wilaya_code: 17,
        wilaya_name: "الجلفة",
        wilaya_name_ascii: "Djelfa"
    },
    {
        commune_name: "مجبارة",
        commune_name_ascii: "Moudjebara",
        daira_name: "عين الإبل",
        daira_name_ascii: "Ain El Ibel",
        wilaya_code: 17,
        wilaya_name: "الجلفة",
        wilaya_name_ascii: "Djelfa"
    },
    {
        commune_name: "جيجل",
        commune_name_ascii: "Jijel",
        daira_name: "جيجل",
        daira_name_ascii: "Jijel",
        wilaya_code: 18,
        wilaya_name: "جيجل",
        wilaya_name_ascii: "Jijel"
    },
    {
        commune_name: "العوانة",
        commune_name_ascii: "El Aouana",
        daira_name: "العوانة",
        daira_name_ascii: "El Aouana",
        wilaya_code: 18,
        wilaya_name: "جيجل",
        wilaya_name_ascii: "Jijel"
    },
    {
        commune_name: "سلمى بن زيادة",
        commune_name_ascii: "Selma Benziada",
        daira_name: "العوانة",
        daira_name_ascii: "El Aouana",
        wilaya_code: 18,
        wilaya_name: "جيجل",
        wilaya_name_ascii: "Jijel"
    },
    {
        commune_name: "أراقن سويسي",
        commune_name_ascii: "Erraguene Souissi",
        daira_name: "زيامة منصورية",
        daira_name_ascii: "Ziamah Mansouriah",
        wilaya_code: 18,
        wilaya_name: "جيجل",
        wilaya_name_ascii: "Jijel"
    },
    {
        commune_name: "بوسيف أولاد عسكر",
        commune_name_ascii: "Boussif Ouled Askeur",
        daira_name: "الطاهير",
        daira_name_ascii: "Taher",
        wilaya_code: 18,
        wilaya_name: "جيجل",
        wilaya_name_ascii: "Jijel"
    },
    {
        commune_name: "زيامة منصورية",
        commune_name_ascii: "Ziama Mansouriah",
        daira_name: "زيامة منصورية",
        daira_name_ascii: "Ziamah Mansouriah",
        wilaya_code: 18,
        wilaya_name: "جيجل",
        wilaya_name_ascii: "Jijel"
    },
    {
        commune_name: "الشحنة",
        commune_name_ascii: "Chahna",
        daira_name: "الطاهير",
        daira_name_ascii: "Taher",
        wilaya_code: 18,
        wilaya_name: "جيجل",
        wilaya_name_ascii: "Jijel"
    },
    {
        commune_name: "الامير عبد القادر",
        commune_name_ascii: "Emir Abdelkader",
        daira_name: "الطاهير",
        daira_name_ascii: "Taher",
        wilaya_code: 18,
        wilaya_name: "جيجل",
        wilaya_name_ascii: "Jijel"
    },
    {
        commune_name: "وجانة",
        commune_name_ascii: "Oudjana",
        daira_name: "الطاهير",
        daira_name_ascii: "Taher",
        wilaya_code: 18,
        wilaya_name: "جيجل",
        wilaya_name_ascii: "Jijel"
    },
    {
        commune_name: "الطاهير",
        commune_name_ascii: "Taher",
        daira_name: "الطاهير",
        daira_name_ascii: "Taher",
        wilaya_code: 18,
        wilaya_name: "جيجل",
        wilaya_name_ascii: "Jijel"
    },
    {
        commune_name: "الشقفة",
        commune_name_ascii: "Chekfa",
        daira_name: "الشقفة",
        daira_name_ascii: "Chekfa",
        wilaya_code: 18,
        wilaya_name: "جيجل",
        wilaya_name_ascii: "Jijel"
    },
    {
        commune_name: "القنار نشفي",
        commune_name_ascii: "El Kennar Nouchfi",
        daira_name: "الشقفة",
        daira_name_ascii: "Chekfa",
        wilaya_code: 18,
        wilaya_name: "جيجل",
        wilaya_name_ascii: "Jijel"
    },
    {
        commune_name: "سيدي عبد العزيز",
        commune_name_ascii: "Sidi Abdelaziz",
        daira_name: "الشقفة",
        daira_name_ascii: "Chekfa",
        wilaya_code: 18,
        wilaya_name: "جيجل",
        wilaya_name_ascii: "Jijel"
    },
    {
        commune_name: "الميلية",
        commune_name_ascii: "El Milia",
        daira_name: "الميلية",
        daira_name_ascii: "El Milia",
        wilaya_code: 18,
        wilaya_name: "جيجل",
        wilaya_name_ascii: "Jijel"
    },
    {
        commune_name: "أولاد يحيى خدروش",
        commune_name_ascii: "Ouled Yahia Khadrouch",
        daira_name: "الميلية",
        daira_name_ascii: "El Milia",
        wilaya_code: 18,
        wilaya_name: "جيجل",
        wilaya_name_ascii: "Jijel"
    },
    {
        commune_name: "أولاد رابح",
        commune_name_ascii: "Ouled Rabah",
        daira_name: "سيدي معروف",
        daira_name_ascii: "Sidi Marouf",
        wilaya_code: 18,
        wilaya_name: "جيجل",
        wilaya_name_ascii: "Jijel"
    },
    {
        commune_name: "سيدي معروف",
        commune_name_ascii: "Sidi Marouf",
        daira_name: "سيدي معروف",
        daira_name_ascii: "Sidi Marouf",
        wilaya_code: 18,
        wilaya_name: "جيجل",
        wilaya_name_ascii: "Jijel"
    },
    {
        commune_name: "غبالة",
        commune_name_ascii: "Ghebala",
        daira_name: "السطارة",
        daira_name_ascii: "Settara",
        wilaya_code: 18,
        wilaya_name: "جيجل",
        wilaya_name_ascii: "Jijel"
    },
    {
        commune_name: "السطارة",
        commune_name_ascii: "Settara",
        daira_name: "السطارة",
        daira_name_ascii: "Settara",
        wilaya_code: 18,
        wilaya_name: "جيجل",
        wilaya_name_ascii: "Jijel"
    },
    {
        commune_name: "بوراوي بلهادف",
        commune_name_ascii: "Bouraoui Belhadef",
        daira_name: "العنصر",
        daira_name_ascii: "El Ancer",
        wilaya_code: 18,
        wilaya_name: "جيجل",
        wilaya_name_ascii: "Jijel"
    },
    {
        commune_name: "العنصر",
        commune_name_ascii: "El Ancer",
        daira_name: "العنصر",
        daira_name_ascii: "El Ancer",
        wilaya_code: 18,
        wilaya_name: "جيجل",
        wilaya_name_ascii: "Jijel"
    },
    {
        commune_name: "خيري واد عجول",
        commune_name_ascii: "Khiri Oued Adjoul",
        daira_name: "العنصر",
        daira_name_ascii: "El Ancer",
        wilaya_code: 18,
        wilaya_name: "جيجل",
        wilaya_name_ascii: "Jijel"
    },
    {
        commune_name: "جيملة",
        commune_name_ascii: "Djimla",
        daira_name: "جيملة",
        daira_name_ascii: "Djimla",
        wilaya_code: 18,
        wilaya_name: "جيجل",
        wilaya_name_ascii: "Jijel"
    },
    {
        commune_name: "قاوس",
        commune_name_ascii: "Kaous",
        daira_name: "تاكسنة",
        daira_name_ascii: "Texenna",
        wilaya_code: 18,
        wilaya_name: "جيجل",
        wilaya_name_ascii: "Jijel"
    },
    {
        commune_name: "تاكسنة",
        commune_name_ascii: "Texenna",
        daira_name: "تاكسنة",
        daira_name_ascii: "Texenna",
        wilaya_code: 18,
        wilaya_name: "جيجل",
        wilaya_name_ascii: "Jijel"
    },
    {
        commune_name: "برج الطهر",
        commune_name_ascii: "Bordj T'har",
        daira_name: "الشقفة",
        daira_name_ascii: "Chekfa",
        wilaya_code: 18,
        wilaya_name: "جيجل",
        wilaya_name_ascii: "Jijel"
    },
    {
        commune_name: "بودريعة بني  ياجيس",
        commune_name_ascii: "Boudria Beniyadjis",
        daira_name: "جيملة",
        daira_name_ascii: "Djimla",
        wilaya_code: 18,
        wilaya_name: "جيجل",
        wilaya_name_ascii: "Jijel"
    },
    {
        commune_name: "الجمعة بني حبيبي",
        commune_name_ascii: "Djemaa Beni Habibi",
        daira_name: "العنصر",
        daira_name_ascii: "El Ancer",
        wilaya_code: 18,
        wilaya_name: "جيجل",
        wilaya_name_ascii: "Jijel"
    },
    {
        commune_name: "الرصفة",
        commune_name_ascii: "Rosfa",
        daira_name: "صالح باي",
        daira_name_ascii: "Salah Bey",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "واد البارد",
        commune_name_ascii: "Oued El Bared",
        daira_name: "عموشة",
        daira_name_ascii: "Amoucha",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "تيزي نبشار",
        commune_name_ascii: "Tizi N'bechar",
        daira_name: "عموشة",
        daira_name_ascii: "Amoucha",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "مزلوق",
        commune_name_ascii: "Mezloug",
        daira_name: "عين أرنات",
        daira_name_ascii: "Ain Arnat",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "قلال",
        commune_name_ascii: "Guellal",
        daira_name: "عين ولمان",
        daira_name_ascii: "Ain Oulmene",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "قصر الابطال",
        commune_name_ascii: "Kasr El Abtal",
        daira_name: "عين ولمان",
        daira_name_ascii: "Ain Oulmene",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "أولاد سي أحمد",
        commune_name_ascii: "Ouled Si Ahmed",
        daira_name: "عين ولمان",
        daira_name_ascii: "Ain Oulmene",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "أيت نوال مزادة",
        commune_name_ascii: "Ait Naoual Mezada",
        daira_name: "بوعنداس",
        daira_name_ascii: "Bouandas",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "ايت تيزي",
        commune_name_ascii: "Ait-Tizi",
        daira_name: "بوعنداس",
        daira_name_ascii: "Bouandas",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "بوعنداس",
        commune_name_ascii: "Bouandas",
        daira_name: "بوعنداس",
        daira_name_ascii: "Bouandas",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "بوسلام",
        commune_name_ascii: "Bousselam",
        daira_name: "بوعنداس",
        daira_name_ascii: "Bouandas",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "حمام السخنة",
        commune_name_ascii: "Hamam Soukhna",
        daira_name: "حمام السخنة",
        daira_name_ascii: "Hammam Sokhna",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "الطاية",
        commune_name_ascii: "Taya",
        daira_name: "حمام السخنة",
        daira_name_ascii: "Hammam Sokhna",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "التلة",
        commune_name_ascii: "Tella",
        daira_name: "حمام السخنة",
        daira_name_ascii: "Hammam Sokhna",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "عين ولمان",
        commune_name_ascii: "Ain Oulmene",
        daira_name: "عين ولمان",
        daira_name_ascii: "Ain Oulmene",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "بوطالب",
        commune_name_ascii: "Boutaleb",
        daira_name: "صالح باي",
        daira_name_ascii: "Salah Bey",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "الحامة",
        commune_name_ascii: "Hamma",
        daira_name: "صالح باي",
        daira_name_ascii: "Salah Bey",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "أولاد تبان",
        commune_name_ascii: "Ouled Tebben",
        daira_name: "صالح باي",
        daira_name_ascii: "Salah Bey",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "عموشة",
        commune_name_ascii: "Amoucha",
        daira_name: "عموشة",
        daira_name_ascii: "Amoucha",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "صالح باي",
        commune_name_ascii: "Salah Bey",
        daira_name: "صالح باي",
        daira_name_ascii: "Salah Bey",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "عين أزال",
        commune_name_ascii: "Ain Azel",
        daira_name: "عين أزال",
        daira_name_ascii: "Ain Azel",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "عين الحجر",
        commune_name_ascii: "Ain Lahdjar",
        daira_name: "عين أزال",
        daira_name_ascii: "Ain Azel",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "بيضاء برج",
        commune_name_ascii: "Beidha Bordj",
        daira_name: "عين أزال",
        daira_name_ascii: "Ain Azel",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "بئر حدادة",
        commune_name_ascii: "Bir Haddada",
        daira_name: "عين أزال",
        daira_name_ascii: "Ain Azel",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "قنزات",
        commune_name_ascii: "Guenzet",
        daira_name: "قنزات",
        daira_name_ascii: "Guenzet",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "حربيل",
        commune_name_ascii: "Harbil",
        daira_name: "قنزات",
        daira_name_ascii: "Guenzet",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "عين الروى",
        commune_name_ascii: "Ain-Roua",
        daira_name: "بوقاعة",
        daira_name_ascii: "Bougaa",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "بني وسين",
        commune_name_ascii: "Beni Oussine",
        daira_name: "بوقاعة",
        daira_name_ascii: "Bougaa",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "أوريسيا",
        commune_name_ascii: "El Ouricia",
        daira_name: "عين أرنات",
        daira_name_ascii: "Ain Arnat",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "بوقاعة",
        commune_name_ascii: "Bougaa",
        daira_name: "بوقاعة",
        daira_name_ascii: "Bougaa",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "ذراع قبيلة",
        commune_name_ascii: "Draa-Kebila",
        daira_name: "حمام قرقور",
        daira_name_ascii: "Hammam Guergour",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "حمام قرقور",
        commune_name_ascii: "Hammam Guergour",
        daira_name: "حمام قرقور",
        daira_name_ascii: "Hammam Guergour",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "سطيف",
        commune_name_ascii: "Setif",
        daira_name: "سطيف",
        daira_name_ascii: "Setif",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "عين الكبيرة",
        commune_name_ascii: "Ain El Kebira",
        daira_name: "عين الكبيرة",
        daira_name_ascii: "Ain El Kebira",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "الدهامشة",
        commune_name_ascii: "Dehamcha",
        daira_name: "عين الكبيرة",
        daira_name_ascii: "Ain El Kebira",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "أولاد عدوان",
        commune_name_ascii: "Ouled Addouane",
        daira_name: "عين الكبيرة",
        daira_name_ascii: "Ain El Kebira",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "عين السبت",
        commune_name_ascii: "Ain-Sebt",
        daira_name: "بني عزيز",
        daira_name_ascii: "Beni Aziz",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "بني عزيز",
        commune_name_ascii: "Beni-Aziz",
        daira_name: "بني عزيز",
        daira_name_ascii: "Beni Aziz",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "معاوية",
        commune_name_ascii: "Maaouia",
        daira_name: "بني عزيز",
        daira_name_ascii: "Beni Aziz",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "بلاعة",
        commune_name_ascii: "Bellaa",
        daira_name: "بئر العرش",
        daira_name_ascii: "Bir El Arch",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "بئر العرش",
        commune_name_ascii: "Bir-El-Arch",
        daira_name: "بئر العرش",
        daira_name_ascii: "Bir El Arch",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "الولجة",
        commune_name_ascii: "El-Ouldja",
        daira_name: "بئر العرش",
        daira_name_ascii: "Bir El Arch",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "تاشودة",
        commune_name_ascii: "Tachouda",
        daira_name: "بئر العرش",
        daira_name_ascii: "Bir El Arch",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "تالة إيفاسن",
        commune_name_ascii: "Tala-Ifacene",
        daira_name: "ماوكلان",
        daira_name_ascii: "Maoklane",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "سرج الغول",
        commune_name_ascii: "Serdj-El-Ghoul",
        daira_name: "بابور",
        daira_name_ascii: "Babor",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "قجال",
        commune_name_ascii: "Guidjel",
        daira_name: "قجال",
        daira_name_ascii: "Guidjel",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "أولاد صابر",
        commune_name_ascii: "Ouled Sabor",
        daira_name: "قجال",
        daira_name_ascii: "Guidjel",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "بازر سكرة",
        commune_name_ascii: "Bazer-Sakra",
        daira_name: "العلمة",
        daira_name_ascii: "El Eulma",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "العلمة",
        commune_name_ascii: "El Eulma",
        daira_name: "العلمة",
        daira_name_ascii: "El Eulma",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "قلتة زرقاء",
        commune_name_ascii: "Guelta Zerka",
        daira_name: "العلمة",
        daira_name_ascii: "El Eulma",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "بني فودة",
        commune_name_ascii: "Beni Fouda",
        daira_name: "جميلة",
        daira_name_ascii: "Djemila",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "جميلة",
        commune_name_ascii: "Djemila",
        daira_name: "جميلة",
        daira_name_ascii: "Djemila",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "عين لقراج",
        commune_name_ascii: "Ain-Legradj",
        daira_name: "بني ورتيلان",
        daira_name_ascii: "Beni Ourtilane",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "بني شبانة",
        commune_name_ascii: "Beni Chebana",
        daira_name: "بني ورتيلان",
        daira_name_ascii: "Beni Ourtilane",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "بني ورتيلان",
        commune_name_ascii: "Beni Ourtilane",
        daira_name: "بني ورتيلان",
        daira_name_ascii: "Beni Ourtilane",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "بني موحلي",
        commune_name_ascii: "Beni-Mouhli",
        daira_name: "بني ورتيلان",
        daira_name_ascii: "Beni Ourtilane",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "عين عباسة",
        commune_name_ascii: "Ain Abessa",
        daira_name: "عين أرنات",
        daira_name_ascii: "Ain Arnat",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "عين أرنات",
        commune_name_ascii: "Ain Arnat",
        daira_name: "عين أرنات",
        daira_name_ascii: "Ain Arnat",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "بابور",
        commune_name_ascii: "Babor",
        daira_name: "بابور",
        daira_name_ascii: "Babor",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "ماوكلان",
        commune_name_ascii: "Maouaklane",
        daira_name: "ماوكلان",
        daira_name_ascii: "Maoklane",
        wilaya_code: 19,
        wilaya_name: "سطيف",
        wilaya_name_ascii: "Sétif"
    },
    {
        commune_name: "سعيدة",
        commune_name_ascii: "Saida",
        daira_name: "سعيدة",
        daira_name_ascii: "Saida",
        wilaya_code: 20,
        wilaya_name: "سعيدة",
        wilaya_name_ascii: "Saïda"
    },
    {
        commune_name: "تيرسين",
        commune_name_ascii: "Tircine",
        daira_name: "أولاد ابراهيم",
        daira_name_ascii: "Ouled Brahim",
        wilaya_code: 20,
        wilaya_name: "سعيدة",
        wilaya_name_ascii: "Saïda"
    },
    {
        commune_name: "أولاد إبراهيم",
        commune_name_ascii: "Ouled Brahim",
        daira_name: "أولاد ابراهيم",
        daira_name_ascii: "Ouled Brahim",
        wilaya_code: 20,
        wilaya_name: "سعيدة",
        wilaya_name_ascii: "Saïda"
    },
    {
        commune_name: "عين السلطان",
        commune_name_ascii: "Ain Soltane",
        daira_name: "أولاد ابراهيم",
        daira_name_ascii: "Ouled Brahim",
        wilaya_code: 20,
        wilaya_name: "سعيدة",
        wilaya_name_ascii: "Saïda"
    },
    {
        commune_name: "المعمورة",
        commune_name_ascii: "Maamora",
        daira_name: "الحساسنة",
        daira_name_ascii: "El Hassasna",
        wilaya_code: 20,
        wilaya_name: "سعيدة",
        wilaya_name_ascii: "Saïda"
    },
    {
        commune_name: "الحساسنة",
        commune_name_ascii: "El Hassasna",
        daira_name: "الحساسنة",
        daira_name_ascii: "El Hassasna",
        wilaya_code: 20,
        wilaya_name: "سعيدة",
        wilaya_name_ascii: "Saïda"
    },
    {
        commune_name: "عين السخونة",
        commune_name_ascii: "Ain Sekhouna",
        daira_name: "الحساسنة",
        daira_name_ascii: "El Hassasna",
        wilaya_code: 20,
        wilaya_name: "سعيدة",
        wilaya_name_ascii: "Saïda"
    },
    {
        commune_name: "سيدي بوبكر",
        commune_name_ascii: "Sidi Boubekeur",
        daira_name: "سيدي بوبكر",
        daira_name_ascii: "Sidi Boubekeur",
        wilaya_code: 20,
        wilaya_name: "سعيدة",
        wilaya_name_ascii: "Saïda"
    },
    {
        commune_name: "أولاد خالد",
        commune_name_ascii: "Ouled Khaled",
        daira_name: "سيدي بوبكر",
        daira_name_ascii: "Sidi Boubekeur",
        wilaya_code: 20,
        wilaya_name: "سعيدة",
        wilaya_name_ascii: "Saïda"
    },
    {
        commune_name: "هونت",
        commune_name_ascii: "Hounet",
        daira_name: "سيدي بوبكر",
        daira_name_ascii: "Sidi Boubekeur",
        wilaya_code: 20,
        wilaya_name: "سعيدة",
        wilaya_name_ascii: "Saïda"
    },
    {
        commune_name: "يوب",
        commune_name_ascii: "Youb",
        daira_name: "يوب",
        daira_name_ascii: "Youb",
        wilaya_code: 20,
        wilaya_name: "سعيدة",
        wilaya_name_ascii: "Saïda"
    },
    {
        commune_name: "دوي ثابت",
        commune_name_ascii: "Doui Thabet",
        daira_name: "يوب",
        daira_name_ascii: "Youb",
        wilaya_code: 20,
        wilaya_name: "سعيدة",
        wilaya_name_ascii: "Saïda"
    },
    {
        commune_name: "سيدي احمد",
        commune_name_ascii: "Sidi Ahmed",
        daira_name: "عين الحجر",
        daira_name_ascii: "Ain El Hadjar",
        wilaya_code: 20,
        wilaya_name: "سعيدة",
        wilaya_name_ascii: "Saïda"
    },
    {
        commune_name: "مولاي العربي",
        commune_name_ascii: "Moulay Larbi",
        daira_name: "عين الحجر",
        daira_name_ascii: "Ain El Hadjar",
        wilaya_code: 20,
        wilaya_name: "سعيدة",
        wilaya_name_ascii: "Saïda"
    },
    {
        commune_name: "عين الحجر",
        commune_name_ascii: "Ain El Hadjar",
        daira_name: "عين الحجر",
        daira_name_ascii: "Ain El Hadjar",
        wilaya_code: 20,
        wilaya_name: "سعيدة",
        wilaya_name_ascii: "Saïda"
    },
    {
        commune_name: "سيدي عمر",
        commune_name_ascii: "Sidi Amar",
        daira_name: "سيدي بوبكر",
        daira_name_ascii: "Sidi Boubekeur",
        wilaya_code: 20,
        wilaya_name: "سعيدة",
        wilaya_name_ascii: "Saïda"
    },
    {
        commune_name: "عين بوزيان",
        commune_name_ascii: "Ain Bouziane",
        daira_name: "سيدي مزغيش",
        daira_name_ascii: "Sidi Mezghiche",
        wilaya_code: 21,
        wilaya_name: "سكيكدة",
        wilaya_name_ascii: "Skikda"
    },
    {
        commune_name: "صالح بو الشعور",
        commune_name_ascii: "Salah Bouchaour",
        daira_name: "الحروش",
        daira_name_ascii: "El Harrouch",
        wilaya_code: 21,
        wilaya_name: "سكيكدة",
        wilaya_name_ascii: "Skikda"
    },
    {
        commune_name: "الحدائق",
        commune_name_ascii: "El Hadaiek",
        daira_name: "الحدائق",
        daira_name_ascii: "El Hadaiek",
        wilaya_code: 21,
        wilaya_name: "سكيكدة",
        wilaya_name_ascii: "Skikda"
    },
    {
        commune_name: "زردازة",
        commune_name_ascii: "Zerdezas",
        daira_name: "الحروش",
        daira_name_ascii: "El Harrouch",
        wilaya_code: 21,
        wilaya_name: "سكيكدة",
        wilaya_name_ascii: "Skikda"
    },
    {
        commune_name: "أولاد حبابة",
        commune_name_ascii: "Ouled Habbaba",
        daira_name: "الحروش",
        daira_name_ascii: "El Harrouch",
        wilaya_code: 21,
        wilaya_name: "سكيكدة",
        wilaya_name_ascii: "Skikda"
    },
    {
        commune_name: "بني ولبان",
        commune_name_ascii: "Beni Oulbane",
        daira_name: "سيدي مزغيش",
        daira_name_ascii: "Sidi Mezghiche",
        wilaya_code: 21,
        wilaya_name: "سكيكدة",
        wilaya_name_ascii: "Skikda"
    },
    {
        commune_name: "سيدي مزغيش",
        commune_name_ascii: "Sidi Mezghiche",
        daira_name: "سيدي مزغيش",
        daira_name_ascii: "Sidi Mezghiche",
        wilaya_code: 21,
        wilaya_name: "سكيكدة",
        wilaya_name_ascii: "Skikda"
    },
    {
        commune_name: "بني بشير",
        commune_name_ascii: "Beni Bechir",
        daira_name: "رمضان جمال",
        daira_name_ascii: "Ramdane Djamel",
        wilaya_code: 21,
        wilaya_name: "سكيكدة",
        wilaya_name_ascii: "Skikda"
    },
    {
        commune_name: "رمضان جمال",
        commune_name_ascii: "Ramdane Djamel",
        daira_name: "رمضان جمال",
        daira_name_ascii: "Ramdane Djamel",
        wilaya_code: 21,
        wilaya_name: "سكيكدة",
        wilaya_name_ascii: "Skikda"
    },
    {
        commune_name: "بين الويدان",
        commune_name_ascii: "Bin El Ouiden",
        daira_name: "تمالوس",
        daira_name_ascii: "Tamalous",
        wilaya_code: 21,
        wilaya_name: "سكيكدة",
        wilaya_name_ascii: "Skikda"
    },
    {
        commune_name: "مجاز الدشيش",
        commune_name_ascii: "Emjez Edchich",
        daira_name: "الحروش",
        daira_name_ascii: "El Harrouch",
        wilaya_code: 21,
        wilaya_name: "سكيكدة",
        wilaya_name_ascii: "Skikda"
    },
    {
        commune_name: "تمالوس",
        commune_name_ascii: "Tamalous",
        daira_name: "تمالوس",
        daira_name_ascii: "Tamalous",
        wilaya_code: 21,
        wilaya_name: "سكيكدة",
        wilaya_name_ascii: "Skikda"
    },
    {
        commune_name: "عين قشرة",
        commune_name_ascii: "Ain Kechra",
        daira_name: "عين قشرة",
        daira_name_ascii: "Ain Kechra",
        wilaya_code: 21,
        wilaya_name: "سكيكدة",
        wilaya_name_ascii: "Skikda"
    },
    {
        commune_name: "الولجة بولبلوط",
        commune_name_ascii: "Ouldja Boulbalout",
        daira_name: "عين قشرة",
        daira_name_ascii: "Ain Kechra",
        wilaya_code: 21,
        wilaya_name: "سكيكدة",
        wilaya_name_ascii: "Skikda"
    },
    {
        commune_name: "أم الطوب",
        commune_name_ascii: "Oum Toub",
        daira_name: "أم الطوب",
        daira_name_ascii: "Oum Toub",
        wilaya_code: 21,
        wilaya_name: "سكيكدة",
        wilaya_name_ascii: "Skikda"
    },
    {
        commune_name: "الغدير",
        commune_name_ascii: "El Ghedir",
        daira_name: "عزابة",
        daira_name_ascii: "Azzaba",
        wilaya_code: 21,
        wilaya_name: "سكيكدة",
        wilaya_name_ascii: "Skikda"
    },
    {
        commune_name: "الكركرة",
        commune_name_ascii: "Kerkara",
        daira_name: "تمالوس",
        daira_name_ascii: "Tamalous",
        wilaya_code: 21,
        wilaya_name: "سكيكدة",
        wilaya_name_ascii: "Skikda"
    },
    {
        commune_name: "الحروش",
        commune_name_ascii: "El Arrouch",
        daira_name: "الحروش",
        daira_name_ascii: "El Harrouch",
        wilaya_code: 21,
        wilaya_name: "سكيكدة",
        wilaya_name_ascii: "Skikda"
    },
    {
        commune_name: "الزيتونة",
        commune_name_ascii: "Zitouna",
        daira_name: "الزيتونة",
        daira_name_ascii: "Zitouna",
        wilaya_code: 21,
        wilaya_name: "سكيكدة",
        wilaya_name_ascii: "Skikda"
    },
    {
        commune_name: "أولاد عطية",
        commune_name_ascii: "Ouled Attia",
        daira_name: "أولاد عطية",
        daira_name_ascii: "Ouled Attia",
        wilaya_code: 21,
        wilaya_name: "سكيكدة",
        wilaya_name_ascii: "Skikda"
    },
    {
        commune_name: "وادي الزهور",
        commune_name_ascii: "Oued Zhour",
        daira_name: "أولاد عطية",
        daira_name_ascii: "Ouled Attia",
        wilaya_code: 21,
        wilaya_name: "سكيكدة",
        wilaya_name_ascii: "Skikda"
    },
    {
        commune_name: "القل",
        commune_name_ascii: "Collo",
        daira_name: "القل",
        daira_name_ascii: "Collo",
        wilaya_code: 21,
        wilaya_name: "سكيكدة",
        wilaya_name_ascii: "Skikda"
    },
    {
        commune_name: "الشرايع",
        commune_name_ascii: "Cheraia",
        daira_name: "القل",
        daira_name_ascii: "Collo",
        wilaya_code: 21,
        wilaya_name: "سكيكدة",
        wilaya_name_ascii: "Skikda"
    },
    {
        commune_name: "بني زيد",
        commune_name_ascii: "Beni Zid",
        daira_name: "القل",
        daira_name_ascii: "Collo",
        wilaya_code: 21,
        wilaya_name: "سكيكدة",
        wilaya_name_ascii: "Skikda"
    },
    {
        commune_name: "خناق مايو",
        commune_name_ascii: "Khenag Maoune",
        daira_name: "أولاد عطية",
        daira_name_ascii: "Ouled Attia",
        wilaya_code: 21,
        wilaya_name: "سكيكدة",
        wilaya_name_ascii: "Skikda"
    },
    {
        commune_name: "المرسى",
        commune_name_ascii: "El Marsa",
        daira_name: "بن عزوز",
        daira_name_ascii: "Ben Azzouz",
        wilaya_code: 21,
        wilaya_name: "سكيكدة",
        wilaya_name_ascii: "Skikda"
    },
    {
        commune_name: "بن عزوز",
        commune_name_ascii: "Ben Azzouz",
        daira_name: "بن عزوز",
        daira_name_ascii: "Ben Azzouz",
        wilaya_code: 21,
        wilaya_name: "سكيكدة",
        wilaya_name_ascii: "Skikda"
    },
    {
        commune_name: "بكوش لخضر",
        commune_name_ascii: "Bekkouche Lakhdar",
        daira_name: "بن عزوز",
        daira_name_ascii: "Ben Azzouz",
        wilaya_code: 21,
        wilaya_name: "سكيكدة",
        wilaya_name_ascii: "Skikda"
    },
    {
        commune_name: "السبت",
        commune_name_ascii: "Es Sebt",
        daira_name: "عزابة",
        daira_name_ascii: "Azzaba",
        wilaya_code: 21,
        wilaya_name: "سكيكدة",
        wilaya_name_ascii: "Skikda"
    },
    {
        commune_name: "عين شرشار",
        commune_name_ascii: "Ain Charchar",
        daira_name: "عزابة",
        daira_name_ascii: "Azzaba",
        wilaya_code: 21,
        wilaya_name: "سكيكدة",
        wilaya_name_ascii: "Skikda"
    },
    {
        commune_name: "عزابة",
        commune_name_ascii: "Azzaba",
        daira_name: "عزابة",
        daira_name_ascii: "Azzaba",
        wilaya_code: 21,
        wilaya_name: "سكيكدة",
        wilaya_name_ascii: "Skikda"
    },
    {
        commune_name: "بوشطاطة",
        commune_name_ascii: "Bouchetata",
        daira_name: "الحدائق",
        daira_name_ascii: "El Hadaiek",
        wilaya_code: 21,
        wilaya_name: "سكيكدة",
        wilaya_name_ascii: "Skikda"
    },
    {
        commune_name: "فلفلة",
        commune_name_ascii: "Filfila",
        daira_name: "سكيكدة",
        daira_name_ascii: "Skikda",
        wilaya_code: 21,
        wilaya_name: "سكيكدة",
        wilaya_name_ascii: "Skikda"
    },
    {
        commune_name: "حمادي كرومة",
        commune_name_ascii: "Hammadi Krouma",
        daira_name: "سكيكدة",
        daira_name_ascii: "Skikda",
        wilaya_code: 21,
        wilaya_name: "سكيكدة",
        wilaya_name_ascii: "Skikda"
    },
    {
        commune_name: "سكيكدة",
        commune_name_ascii: "Skikda",
        daira_name: "سكيكدة",
        daira_name_ascii: "Skikda",
        wilaya_code: 21,
        wilaya_name: "سكيكدة",
        wilaya_name_ascii: "Skikda"
    },
    {
        commune_name: "عين زويت",
        commune_name_ascii: "Ain Zouit",
        daira_name: "الحدائق",
        daira_name_ascii: "El Hadaiek",
        wilaya_code: 21,
        wilaya_name: "سكيكدة",
        wilaya_name_ascii: "Skikda"
    },
    {
        commune_name: "جندل سعدي محمد",
        commune_name_ascii: "Djendel Saadi Mohamed",
        daira_name: "عزابة",
        daira_name_ascii: "Azzaba",
        wilaya_code: 21,
        wilaya_name: "سكيكدة",
        wilaya_name_ascii: "Skikda"
    },
    {
        commune_name: "قنواع",
        commune_name_ascii: "Kanoua",
        daira_name: "الزيتونة",
        daira_name_ascii: "Zitouna",
        wilaya_code: 21,
        wilaya_name: "سكيكدة",
        wilaya_name_ascii: "Skikda"
    },
    {
        commune_name: "سيدي علي بن يوب",
        commune_name_ascii: "Sidi Ali Benyoub",
        daira_name: "سيدي علي بن يوب",
        daira_name_ascii: "Sidi Ali Ben Youb",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "مولاي سليسن",
        commune_name_ascii: "Moulay Slissen",
        daira_name: "مولاي سليسن",
        daira_name_ascii: "Moulay Slissen",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "الحصيبة",
        commune_name_ascii: "El Hacaiba",
        daira_name: "مولاي سليسن",
        daira_name_ascii: "Moulay Slissen",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "عين تندمين",
        commune_name_ascii: "Ain Tindamine",
        daira_name: "مولاي سليسن",
        daira_name_ascii: "Moulay Slissen",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "تنيرة",
        commune_name_ascii: "Tenira",
        daira_name: "تنيرة",
        daira_name_ascii: "Tenira",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "وادي سفيون",
        commune_name_ascii: "Oued Sefioun",
        daira_name: "تنيرة",
        daira_name_ascii: "Tenira",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "حاسي دحو",
        commune_name_ascii: "Hassi Dahou",
        daira_name: "تنيرة",
        daira_name_ascii: "Tenira",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "وادي تاوريرة",
        commune_name_ascii: "Oued Taourira",
        daira_name: "مرين",
        daira_name_ascii: "Merine",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "بن عشيبة شلية",
        commune_name_ascii: "Benachiba Chelia",
        daira_name: "تنيرة",
        daira_name_ascii: "Tenira",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "سيدي يعقوب",
        commune_name_ascii: "Sidi Yacoub",
        daira_name: "سيدي لحسن",
        daira_name_ascii: "Sidi Lahcene",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "سيدي لحسن",
        commune_name_ascii: "Sidi Lahcene",
        daira_name: "سيدي لحسن",
        daira_name_ascii: "Sidi Lahcene",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "سيدي خالد",
        commune_name_ascii: "Sidi Khaled",
        daira_name: "سيدي لحسن",
        daira_name_ascii: "Sidi Lahcene",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "طابية",
        commune_name_ascii: "Tabia",
        daira_name: "سيدي علي بن يوب",
        daira_name_ascii: "Sidi Ali Ben Youb",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "سيدي ابراهيم",
        commune_name_ascii: "Sidi Brahim",
        daira_name: "عين البرد",
        daira_name_ascii: "Ain El Berd",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "العمارنة",
        commune_name_ascii: "Amarnas",
        daira_name: "سيدي لحسن",
        daira_name_ascii: "Sidi Lahcene",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "بوخنفيس",
        commune_name_ascii: "Boukhanefis",
        daira_name: "سيدي علي بن يوب",
        daira_name_ascii: "Sidi Ali Ben Youb",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "حاسي زهانة",
        commune_name_ascii: "Hassi Zahana",
        daira_name: "بن باديس",
        daira_name_ascii: "Ben Badis",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "شيطوان البلايلة",
        commune_name_ascii: "Chetouane Belaila",
        daira_name: "بن باديس",
        daira_name_ascii: "Ben Badis",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "بن باديس",
        commune_name_ascii: "Ben Badis",
        daira_name: "بن باديس",
        daira_name_ascii: "Ben Badis",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "بضرابين المقراني",
        commune_name_ascii: "Bedrabine El Mokrani",
        daira_name: "بن باديس",
        daira_name_ascii: "Ben Badis",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "سفيزف",
        commune_name_ascii: "Sfisef",
        daira_name: "سفيزف",
        daira_name_ascii: "Sfisef",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "مسيد",
        commune_name_ascii: "M'cid",
        daira_name: "سفيزف",
        daira_name_ascii: "Sfisef",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "بوجبهة البرج",
        commune_name_ascii: "Boudjebaa El Bordj",
        daira_name: "سفيزف",
        daira_name_ascii: "Sfisef",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "عين أدن",
        commune_name_ascii: "Ain- Adden",
        daira_name: "سفيزف",
        daira_name_ascii: "Sfisef",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "سيدي حمادوش",
        commune_name_ascii: "Sidi Hamadouche",
        daira_name: "عين البرد",
        daira_name_ascii: "Ain El Berd",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "سيدي شعيب",
        commune_name_ascii: "Sidi Chaib",
        daira_name: "مرحوم",
        daira_name_ascii: "Marhoum",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "مكدرة",
        commune_name_ascii: "Makedra",
        daira_name: "عين البرد",
        daira_name_ascii: "Ain El Berd",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "عين البرد",
        commune_name_ascii: "Ain El Berd",
        daira_name: "عين البرد",
        daira_name_ascii: "Ain El Berd",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "رجم دموش",
        commune_name_ascii: "Redjem Demouche",
        daira_name: "راس الماء",
        daira_name_ascii: "Ras El Ma",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "راس الماء",
        commune_name_ascii: "Ras El Ma",
        daira_name: "راس الماء",
        daira_name_ascii: "Ras El Ma",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "وادي السبع",
        commune_name_ascii: "Oued Sebaa",
        daira_name: "راس الماء",
        daira_name_ascii: "Ras El Ma",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "مرحوم",
        commune_name_ascii: "Marhoum",
        daira_name: "مرحوم",
        daira_name_ascii: "Marhoum",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "سيدي بلعباس",
        commune_name_ascii: "Sidi Bel-Abbes",
        daira_name: "سيدي بلعباس",
        daira_name_ascii: "Sidi Bel Abbes",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "عين الثريد",
        commune_name_ascii: "Ain Thrid",
        daira_name: "تسالة",
        daira_name_ascii: "Tessala",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "السهالة الثورة",
        commune_name_ascii: "Sehala Thaoura",
        daira_name: "تسالة",
        daira_name_ascii: "Tessala",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "تسالة",
        commune_name_ascii: "Tessala",
        daira_name: "تسالة",
        daira_name_ascii: "Tessala",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "بلعربي",
        commune_name_ascii: "Belarbi",
        daira_name: "مصطفى بن ابراهيم",
        daira_name_ascii: "Mostefa  Ben Brahim",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "مصطفى بن ابراهيم",
        commune_name_ascii: "Mostefa  Ben Brahim",
        daira_name: "مصطفى بن ابراهيم",
        daira_name_ascii: "Mostefa  Ben Brahim",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "تلموني",
        commune_name_ascii: "Tilmouni",
        daira_name: "مصطفى بن ابراهيم",
        daira_name_ascii: "Mostefa  Ben Brahim",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "زروالة",
        commune_name_ascii: "Zerouala",
        daira_name: "مصطفى بن ابراهيم",
        daira_name_ascii: "Mostefa  Ben Brahim",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "الضاية",
        commune_name_ascii: "Dhaya",
        daira_name: "تلاغ",
        daira_name_ascii: "Telagh",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "مزاورو",
        commune_name_ascii: "Mezaourou",
        daira_name: "تلاغ",
        daira_name_ascii: "Telagh",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "تغاليمت",
        commune_name_ascii: "Teghalimet",
        daira_name: "تلاغ",
        daira_name_ascii: "Telagh",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "تلاغ",
        commune_name_ascii: "Telagh",
        daira_name: "تلاغ",
        daira_name_ascii: "Telagh",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "عين قادة",
        commune_name_ascii: "Ain Kada",
        daira_name: "سيدي علي بوسيدي",
        daira_name_ascii: "Sidi Ali Boussidi",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "لمطار",
        commune_name_ascii: "Lamtar",
        daira_name: "سيدي علي بوسيدي",
        daira_name_ascii: "Sidi Ali Boussidi",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "سيدي علي بوسيدي",
        commune_name_ascii: "Sidi Ali Boussidi",
        daira_name: "سيدي علي بوسيدي",
        daira_name_ascii: "Sidi Ali Boussidi",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "سيدي دحو الزاير",
        commune_name_ascii: "Sidi Dahou Zairs",
        daira_name: "سيدي علي بوسيدي",
        daira_name_ascii: "Sidi Ali Boussidi",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "بئر الحمام",
        commune_name_ascii: "Bir El Hammam",
        daira_name: "مرحوم",
        daira_name_ascii: "Marhoum",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "مرين",
        commune_name_ascii: "Merine",
        daira_name: "مرين",
        daira_name_ascii: "Merine",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "تفسور",
        commune_name_ascii: "Tefessour",
        daira_name: "مرين",
        daira_name_ascii: "Merine",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "تاودموت",
        commune_name_ascii: "Taoudmout",
        daira_name: "مرين",
        daira_name_ascii: "Merine",
        wilaya_code: 22,
        wilaya_name: "سيدي بلعباس",
        wilaya_name_ascii: "Sidi Bel Abbès"
    },
    {
        commune_name: "عنابة",
        commune_name_ascii: "Annaba",
        daira_name: "عنابة",
        daira_name_ascii: "Annaba",
        wilaya_code: 23,
        wilaya_name: "عنابة",
        wilaya_name_ascii: "Annaba"
    },
    {
        commune_name: "سرايدي",
        commune_name_ascii: "Seraidi",
        daira_name: "عنابة",
        daira_name_ascii: "Annaba",
        wilaya_code: 23,
        wilaya_name: "عنابة",
        wilaya_name_ascii: "Annaba"
    },
    {
        commune_name: "برحال",
        commune_name_ascii: "Berrahal",
        daira_name: "برحال",
        daira_name_ascii: "Berrahal",
        wilaya_code: 23,
        wilaya_name: "عنابة",
        wilaya_name_ascii: "Annaba"
    },
    {
        commune_name: "واد العنب",
        commune_name_ascii: "Oued El Aneb",
        daira_name: "برحال",
        daira_name_ascii: "Berrahal",
        wilaya_code: 23,
        wilaya_name: "عنابة",
        wilaya_name_ascii: "Annaba"
    },
    {
        commune_name: "الحجار",
        commune_name_ascii: "El Hadjar",
        daira_name: "الحجار",
        daira_name_ascii: "El Hadjar",
        wilaya_code: 23,
        wilaya_name: "عنابة",
        wilaya_name_ascii: "Annaba"
    },
    {
        commune_name: "سيدي عمار",
        commune_name_ascii: "Sidi Amar",
        daira_name: "الحجار",
        daira_name_ascii: "El Hadjar",
        wilaya_code: 23,
        wilaya_name: "عنابة",
        wilaya_name_ascii: "Annaba"
    },
    {
        commune_name: "البوني",
        commune_name_ascii: "El Bouni",
        daira_name: "البوني",
        daira_name_ascii: "El Bouni",
        wilaya_code: 23,
        wilaya_name: "عنابة",
        wilaya_name_ascii: "Annaba"
    },
    {
        commune_name: "عين الباردة",
        commune_name_ascii: "Ain El Berda",
        daira_name: "عين الباردة",
        daira_name_ascii: "Ain El Berda",
        wilaya_code: 23,
        wilaya_name: "عنابة",
        wilaya_name_ascii: "Annaba"
    },
    {
        commune_name: "الشرفة",
        commune_name_ascii: "Cheurfa",
        daira_name: "عين الباردة",
        daira_name_ascii: "Ain El Berda",
        wilaya_code: 23,
        wilaya_name: "عنابة",
        wilaya_name_ascii: "Annaba"
    },
    {
        commune_name: "العلمة",
        commune_name_ascii: "El Eulma",
        daira_name: "عين الباردة",
        daira_name_ascii: "Ain El Berda",
        wilaya_code: 23,
        wilaya_name: "عنابة",
        wilaya_name_ascii: "Annaba"
    },
    {
        commune_name: "التريعات",
        commune_name_ascii: "Treat",
        daira_name: "برحال",
        daira_name_ascii: "Berrahal",
        wilaya_code: 23,
        wilaya_name: "عنابة",
        wilaya_name_ascii: "Annaba"
    },
    {
        commune_name: "شطايبي",
        commune_name_ascii: "Chetaibi",
        daira_name: "شطايبي",
        daira_name_ascii: "Chetaibi",
        wilaya_code: 23,
        wilaya_name: "عنابة",
        wilaya_name_ascii: "Annaba"
    },
    {
        commune_name: "نشماية",
        commune_name_ascii: "Nechmaya",
        daira_name: "قلعة بوصبع",
        daira_name_ascii: "Guelaat Bousbaa",
        wilaya_code: 24,
        wilaya_name: "قالمة",
        wilaya_name_ascii: "Guelma"
    },
    {
        commune_name: "بوحمدان",
        commune_name_ascii: "Bou Hamdane",
        daira_name: "حمام دباغ",
        daira_name_ascii: "Hammam Debagh",
        wilaya_code: 24,
        wilaya_name: "قالمة",
        wilaya_name_ascii: "Guelma"
    },
    {
        commune_name: "حمام دباغ",
        commune_name_ascii: "Hammam Debagh",
        daira_name: "حمام دباغ",
        daira_name_ascii: "Hammam Debagh",
        wilaya_code: 24,
        wilaya_name: "قالمة",
        wilaya_name_ascii: "Guelma"
    },
    {
        commune_name: "الركنية",
        commune_name_ascii: "Roknia",
        daira_name: "حمام دباغ",
        daira_name_ascii: "Hammam Debagh",
        wilaya_code: 24,
        wilaya_name: "قالمة",
        wilaya_name_ascii: "Guelma"
    },
    {
        commune_name: "الدهوارة",
        commune_name_ascii: "Dahouara",
        daira_name: "حمام النبايل",
        daira_name_ascii: "Hammam N'bails",
        wilaya_code: 24,
        wilaya_name: "قالمة",
        wilaya_name_ascii: "Guelma"
    },
    {
        commune_name: "حمام النبايل",
        commune_name_ascii: "Hammam N'bail",
        daira_name: "حمام النبايل",
        daira_name_ascii: "Hammam N'bails",
        wilaya_code: 24,
        wilaya_name: "قالمة",
        wilaya_name_ascii: "Guelma"
    },
    {
        commune_name: "قالمة",
        commune_name_ascii: "Guelma",
        daira_name: "قالمة",
        daira_name_ascii: "Guelma",
        wilaya_code: 24,
        wilaya_name: "قالمة",
        wilaya_name_ascii: "Guelma"
    },
    {
        commune_name: "بومهرة أحمد",
        commune_name_ascii: "Boumahra Ahmed",
        daira_name: "قلعة بوصبع",
        daira_name_ascii: "Guelaat Bousbaa",
        wilaya_code: 24,
        wilaya_name: "قالمة",
        wilaya_name_ascii: "Guelma"
    },
    {
        commune_name: "عين بن بيضاء",
        commune_name_ascii: "Ain Ben Beida",
        daira_name: "بوشقوف",
        daira_name_ascii: "Bouchegouf",
        wilaya_code: 24,
        wilaya_name: "قالمة",
        wilaya_name_ascii: "Guelma"
    },
    {
        commune_name: "بوشقوف",
        commune_name_ascii: "Bouchegouf",
        daira_name: "بوشقوف",
        daira_name_ascii: "Bouchegouf",
        wilaya_code: 24,
        wilaya_name: "قالمة",
        wilaya_name_ascii: "Guelma"
    },
    {
        commune_name: "مجاز الصفاء",
        commune_name_ascii: "Medjez Sfa",
        daira_name: "بوشقوف",
        daira_name_ascii: "Bouchegouf",
        wilaya_code: 24,
        wilaya_name: "قالمة",
        wilaya_name_ascii: "Guelma"
    },
    {
        commune_name: "وادي فراغة",
        commune_name_ascii: "Oued Ferragha",
        daira_name: "بوشقوف",
        daira_name_ascii: "Bouchegouf",
        wilaya_code: 24,
        wilaya_name: "قالمة",
        wilaya_name_ascii: "Guelma"
    },
    {
        commune_name: "بوعاتي محمود",
        commune_name_ascii: "Bouati Mahmoud",
        daira_name: "هيليوبوليس",
        daira_name_ascii: "Heliopolis",
        wilaya_code: 24,
        wilaya_name: "قالمة",
        wilaya_name_ascii: "Guelma"
    },
    {
        commune_name: "الفجوج",
        commune_name_ascii: "El Fedjoudj",
        daira_name: "هيليوبوليس",
        daira_name_ascii: "Heliopolis",
        wilaya_code: 24,
        wilaya_name: "قالمة",
        wilaya_name_ascii: "Guelma"
    },
    {
        commune_name: "هيليوبوليس",
        commune_name_ascii: "Heliopolis",
        daira_name: "هيليوبوليس",
        daira_name_ascii: "Heliopolis",
        wilaya_code: 24,
        wilaya_name: "قالمة",
        wilaya_name_ascii: "Guelma"
    },
    {
        commune_name: "مجاز عمار",
        commune_name_ascii: "Medjez Amar",
        daira_name: "عين حساينية",
        daira_name_ascii: "Ain Hessainia",
        wilaya_code: 24,
        wilaya_name: "قالمة",
        wilaya_name_ascii: "Guelma"
    },
    {
        commune_name: "هواري بومدين",
        commune_name_ascii: "Houari Boumedienne",
        daira_name: "عين حساينية",
        daira_name_ascii: "Ain Hessainia",
        wilaya_code: 24,
        wilaya_name: "قالمة",
        wilaya_name_ascii: "Guelma"
    },
    {
        commune_name: "رأس العقبة",
        commune_name_ascii: "Ras El Agba",
        daira_name: "عين حساينية",
        daira_name_ascii: "Ain Hessainia",
        wilaya_code: 24,
        wilaya_name: "قالمة",
        wilaya_name_ascii: "Guelma"
    },
    {
        commune_name: "سلاوة عنونة",
        commune_name_ascii: "Sellaoua Announa",
        daira_name: "عين حساينية",
        daira_name_ascii: "Ain Hessainia",
        wilaya_code: 24,
        wilaya_name: "قالمة",
        wilaya_name_ascii: "Guelma"
    },
    {
        commune_name: "جبالة الخميسي",
        commune_name_ascii: "Djeballah Khemissi",
        daira_name: "قلعة بوصبع",
        daira_name_ascii: "Guelaat Bousbaa",
        wilaya_code: 24,
        wilaya_name: "قالمة",
        wilaya_name_ascii: "Guelma"
    },
    {
        commune_name: "برج صباط",
        commune_name_ascii: "Bordj Sabath",
        daira_name: "وادي الزناتي",
        daira_name_ascii: "Oued Zenati",
        wilaya_code: 24,
        wilaya_name: "قالمة",
        wilaya_name_ascii: "Guelma"
    },
    {
        commune_name: "وادي الزناتي",
        commune_name_ascii: "Oued Zenati",
        daira_name: "وادي الزناتي",
        daira_name_ascii: "Oued Zenati",
        wilaya_code: 24,
        wilaya_name: "قالمة",
        wilaya_name_ascii: "Guelma"
    },
    {
        commune_name: "عين رقادة",
        commune_name_ascii: "Ain Regada",
        daira_name: "وادي الزناتي",
        daira_name_ascii: "Oued Zenati",
        wilaya_code: 24,
        wilaya_name: "قالمة",
        wilaya_name_ascii: "Guelma"
    },
    {
        commune_name: "عين العربي",
        commune_name_ascii: "Ain Larbi",
        daira_name: "عين مخلوف",
        daira_name_ascii: "Ain Makhlouf",
        wilaya_code: 24,
        wilaya_name: "قالمة",
        wilaya_name_ascii: "Guelma"
    },
    {
        commune_name: "عين مخلوف",
        commune_name_ascii: "Ain Makhlouf",
        daira_name: "عين مخلوف",
        daira_name_ascii: "Ain Makhlouf",
        wilaya_code: 24,
        wilaya_name: "قالمة",
        wilaya_name_ascii: "Guelma"
    },
    {
        commune_name: "تاملوكة",
        commune_name_ascii: "Tamlouka",
        daira_name: "عين مخلوف",
        daira_name_ascii: "Ain Makhlouf",
        wilaya_code: 24,
        wilaya_name: "قالمة",
        wilaya_name_ascii: "Guelma"
    },
    {
        commune_name: "عين صندل",
        commune_name_ascii: "Ain Sandel",
        daira_name: "خزارة",
        daira_name_ascii: "Khezaras",
        wilaya_code: 24,
        wilaya_name: "قالمة",
        wilaya_name_ascii: "Guelma"
    },
    {
        commune_name: "بوحشانة",
        commune_name_ascii: "Bou Hachana",
        daira_name: "خزارة",
        daira_name_ascii: "Khezaras",
        wilaya_code: 24,
        wilaya_name: "قالمة",
        wilaya_name_ascii: "Guelma"
    },
    {
        commune_name: "لخزارة",
        commune_name_ascii: "Khezaras",
        daira_name: "خزارة",
        daira_name_ascii: "Khezaras",
        wilaya_code: 24,
        wilaya_name: "قالمة",
        wilaya_name_ascii: "Guelma"
    },
    {
        commune_name: "بلخير",
        commune_name_ascii: "Belkheir",
        daira_name: "قلعة بوصبع",
        daira_name_ascii: "Guelaat Bousbaa",
        wilaya_code: 24,
        wilaya_name: "قالمة",
        wilaya_name_ascii: "Guelma"
    },
    {
        commune_name: "بني مزلين",
        commune_name_ascii: "Beni Mezline",
        daira_name: "قلعة بوصبع",
        daira_name_ascii: "Guelaat Bousbaa",
        wilaya_code: 24,
        wilaya_name: "قالمة",
        wilaya_name_ascii: "Guelma"
    },
    {
        commune_name: "قلعة بوصبع",
        commune_name_ascii: "Guelaat Bou Sbaa",
        daira_name: "قلعة بوصبع",
        daira_name_ascii: "Guelaat Bousbaa",
        wilaya_code: 24,
        wilaya_name: "قالمة",
        wilaya_name_ascii: "Guelma"
    },
    {
        commune_name: "وادي الشحم",
        commune_name_ascii: "Oued Cheham",
        daira_name: "حمام النبايل",
        daira_name_ascii: "Hammam N'bails",
        wilaya_code: 24,
        wilaya_name: "قالمة",
        wilaya_name_ascii: "Guelma"
    },
    {
        commune_name: "بن جراح",
        commune_name_ascii: "Bendjarah",
        daira_name: "قالمة",
        daira_name_ascii: "Guelma",
        wilaya_code: 24,
        wilaya_name: "قالمة",
        wilaya_name_ascii: "Guelma"
    },
    {
        commune_name: "ديدوش مراد",
        commune_name_ascii: "Didouche Mourad",
        daira_name: "حامة بوزيان",
        daira_name_ascii: "Hamma Bouziane",
        wilaya_code: 25,
        wilaya_name: "قسنطينة",
        wilaya_name_ascii: "Constantine"
    },
    {
        commune_name: "حامة بوزيان",
        commune_name_ascii: "Hamma Bouziane",
        daira_name: "حامة بوزيان",
        daira_name_ascii: "Hamma Bouziane",
        wilaya_code: 25,
        wilaya_name: "قسنطينة",
        wilaya_name_ascii: "Constantine"
    },
    {
        commune_name: "بني حميدان",
        commune_name_ascii: "Beni Hamidane",
        daira_name: "زيغود يوسف",
        daira_name_ascii: "Zighoud Youcef",
        wilaya_code: 25,
        wilaya_name: "قسنطينة",
        wilaya_name_ascii: "Constantine"
    },
    {
        commune_name: "زيغود يوسف",
        commune_name_ascii: "Zighoud Youcef",
        daira_name: "زيغود يوسف",
        daira_name_ascii: "Zighoud Youcef",
        wilaya_code: 25,
        wilaya_name: "قسنطينة",
        wilaya_name_ascii: "Constantine"
    },
    {
        commune_name: "عين السمارة",
        commune_name_ascii: "Ain Smara",
        daira_name: "الخروب",
        daira_name_ascii: "El Khroub",
        wilaya_code: 25,
        wilaya_name: "قسنطينة",
        wilaya_name_ascii: "Constantine"
    },
    {
        commune_name: "الخروب",
        commune_name_ascii: "El Khroub",
        daira_name: "الخروب",
        daira_name_ascii: "El Khroub",
        wilaya_code: 25,
        wilaya_name: "قسنطينة",
        wilaya_name_ascii: "Constantine"
    },
    {
        commune_name: "أولاد رحمون",
        commune_name_ascii: "Ouled Rahmoun",
        daira_name: "الخروب",
        daira_name_ascii: "El Khroub",
        wilaya_code: 25,
        wilaya_name: "قسنطينة",
        wilaya_name_ascii: "Constantine"
    },
    {
        commune_name: "عين عبيد",
        commune_name_ascii: "Ain Abid",
        daira_name: "عين عبيد",
        daira_name_ascii: "Ain Abid",
        wilaya_code: 25,
        wilaya_name: "قسنطينة",
        wilaya_name_ascii: "Constantine"
    },
    {
        commune_name: "أبن باديس الهرية",
        commune_name_ascii: "Ben Badis",
        daira_name: "عين عبيد",
        daira_name_ascii: "Ain Abid",
        wilaya_code: 25,
        wilaya_name: "قسنطينة",
        wilaya_name_ascii: "Constantine"
    },
    {
        commune_name: "ابن زياد",
        commune_name_ascii: "Ibn Ziad",
        daira_name: "ابن زياد",
        daira_name_ascii: "Ibn Ziad",
        wilaya_code: 25,
        wilaya_name: "قسنطينة",
        wilaya_name_ascii: "Constantine"
    },
    {
        commune_name: "بوجريو مسعود",
        commune_name_ascii: "Messaoud Boudjeriou",
        daira_name: "ابن زياد",
        daira_name_ascii: "Ibn Ziad",
        wilaya_code: 25,
        wilaya_name: "قسنطينة",
        wilaya_name_ascii: "Constantine"
    },
    {
        commune_name: "قسنطينة",
        commune_name_ascii: "Constantine",
        daira_name: "قسنطينة",
        daira_name_ascii: "Constantine",
        wilaya_code: 25,
        wilaya_name: "قسنطينة",
        wilaya_name_ascii: "Constantine"
    },
    {
        commune_name: "أولاد هلال",
        commune_name_ascii: "Ouled Hellal",
        daira_name: "أولاد عنتر",
        daira_name_ascii: "Ouled Antar",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "السواقي",
        commune_name_ascii: "Souagui",
        daira_name: "السواقي",
        daira_name_ascii: "Souaghi",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "قصر البخاري",
        commune_name_ascii: "Ksar El Boukhari",
        daira_name: "قصر البخاري",
        daira_name_ascii: "Ksar El Boukhari",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "مفاتحة",
        commune_name_ascii: "M'fatha",
        daira_name: "قصر البخاري",
        daira_name_ascii: "Ksar El Boukhari",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "السانق",
        commune_name_ascii: "Saneg",
        daira_name: "قصر البخاري",
        daira_name_ascii: "Ksar El Boukhari",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "العزيزية",
        commune_name_ascii: "El Azizia",
        daira_name: "العزيزية",
        daira_name_ascii: "El Azizia",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "مغراوة",
        commune_name_ascii: "Maghraoua",
        daira_name: "العزيزية",
        daira_name_ascii: "El Azizia",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "ميهوب",
        commune_name_ascii: "Mihoub",
        daira_name: "العزيزية",
        daira_name_ascii: "El Azizia",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "بوعيش",
        commune_name_ascii: "Bouaiche",
        daira_name: "الشهبونية",
        daira_name_ascii: "Chahbounia",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "بوغزول",
        commune_name_ascii: "Boughzoul",
        daira_name: "الشهبونية",
        daira_name_ascii: "Chahbounia",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "الشهبونية",
        commune_name_ascii: "Chabounia",
        daira_name: "الشهبونية",
        daira_name_ascii: "Chahbounia",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "حناشة",
        commune_name_ascii: "Hannacha",
        daira_name: "عوامري",
        daira_name_ascii: "Ouamri",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "عوامري",
        commune_name_ascii: "Ouamri",
        daira_name: "عوامري",
        daira_name_ascii: "Ouamri",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "وادي حربيل",
        commune_name_ascii: "Oued Harbil",
        daira_name: "عوامري",
        daira_name_ascii: "Ouamri",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "بني سليمان",
        commune_name_ascii: "Beni Slimane",
        daira_name: "بني سليمان",
        daira_name_ascii: "Beni Slimane",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "بوعيشون",
        commune_name_ascii: "Bouaichoune",
        daira_name: "سي المحجوب",
        daira_name_ascii: "Si Mahdjoub",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "أولاد بوعشرة",
        commune_name_ascii: "Ouled Bouachra",
        daira_name: "سي المحجوب",
        daira_name_ascii: "Si Mahdjoub",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "سي المحجوب",
        commune_name_ascii: "Si Mahdjoub",
        daira_name: "سي المحجوب",
        daira_name_ascii: "Si Mahdjoub",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "بوسكن",
        commune_name_ascii: "Bouskene",
        daira_name: "بني سليمان",
        daira_name_ascii: "Beni Slimane",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "سيدي الربيع",
        commune_name_ascii: "Sidi Rabie",
        daira_name: "بني سليمان",
        daira_name_ascii: "Beni Slimane",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "البرواقية",
        commune_name_ascii: "Berrouaghia",
        daira_name: "البرواقية",
        daira_name_ascii: "Berrouaghia",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "أولاد دايد",
        commune_name_ascii: "Ouled Deid",
        daira_name: "البرواقية",
        daira_name_ascii: "Berrouaghia",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "الربعية",
        commune_name_ascii: "Rebaia",
        daira_name: "البرواقية",
        daira_name_ascii: "Berrouaghia",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "مجبر",
        commune_name_ascii: "Medjebar",
        daira_name: "سغوان",
        daira_name_ascii: "Seghouane",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "ثلاث دوائر",
        commune_name_ascii: "Tletat Ed Douair",
        daira_name: "سغوان",
        daira_name_ascii: "Seghouane",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "الزبيرية",
        commune_name_ascii: "Zoubiria",
        daira_name: "سغوان",
        daira_name_ascii: "Seghouane",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "العيساوية",
        commune_name_ascii: "Aissaouia",
        daira_name: "تابلاط",
        daira_name_ascii: "Tablat",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "الحوضان",
        commune_name_ascii: "El Haoudane",
        daira_name: "تابلاط",
        daira_name_ascii: "Tablat",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "مزغنة",
        commune_name_ascii: "Mezerana",
        daira_name: "تابلاط",
        daira_name_ascii: "Tablat",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "تابلاط",
        commune_name_ascii: "Tablat",
        daira_name: "تابلاط",
        daira_name_ascii: "Tablat",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "بوغار",
        commune_name_ascii: "Boghar",
        daira_name: "أولاد عنتر",
        daira_name_ascii: "Ouled Antar",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "سغوان",
        commune_name_ascii: "Seghouane",
        daira_name: "سغوان",
        daira_name_ascii: "Seghouane",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "ذراع السمار",
        commune_name_ascii: "Draa Esmar",
        daira_name: "المدية",
        daira_name_ascii: "Medea",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "المدية",
        commune_name_ascii: "Medea",
        daira_name: "المدية",
        daira_name_ascii: "Medea",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "تمسقيدة",
        commune_name_ascii: "Tamesguida",
        daira_name: "المدية",
        daira_name_ascii: "Medea",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "بن شكاو",
        commune_name_ascii: "Ben Chicao",
        daira_name: "وزرة",
        daira_name_ascii: "Ouzera",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "الحمدانية",
        commune_name_ascii: "El Hamdania",
        daira_name: "وزرة",
        daira_name_ascii: "Ouzera",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "وزرة",
        commune_name_ascii: "Ouzera",
        daira_name: "وزرة",
        daira_name_ascii: "Ouzera",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "تيزي مهدي",
        commune_name_ascii: "Tizi Mahdi",
        daira_name: "وزرة",
        daira_name_ascii: "Ouzera",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "عين بوسيف",
        commune_name_ascii: "Ain Boucif",
        daira_name: "عين بوسيف",
        daira_name_ascii: "Ain Boucif",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "العوينات",
        commune_name_ascii: "El Ouinet",
        daira_name: "عين بوسيف",
        daira_name_ascii: "Ain Boucif",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "الكاف الاخضر",
        commune_name_ascii: "Kef Lakhdar",
        daira_name: "عين بوسيف",
        daira_name_ascii: "Ain Boucif",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "أولاد امعرف",
        commune_name_ascii: "Ouled Emaaraf",
        daira_name: "عين بوسيف",
        daira_name_ascii: "Ain Boucif",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "سيدي دامد",
        commune_name_ascii: "Sidi Demed",
        daira_name: "عين بوسيف",
        daira_name_ascii: "Ain Boucif",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "بعطة",
        commune_name_ascii: "Baata",
        daira_name: "العمارية",
        daira_name_ascii: "El Omaria",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "العمارية",
        commune_name_ascii: "El Omaria",
        daira_name: "العمارية",
        daira_name_ascii: "El Omaria",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "أولاد إبراهيم",
        commune_name_ascii: "Ouled Brahim",
        daira_name: "العمارية",
        daira_name_ascii: "El Omaria",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "بئر بن عابد",
        commune_name_ascii: "Bir Ben Laabed",
        daira_name: "القلب الكبير",
        daira_name_ascii: "Guelb El Kebir",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "القلب الكبير",
        commune_name_ascii: "El Guelbelkebir",
        daira_name: "القلب الكبير",
        daira_name_ascii: "Guelb El Kebir",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "سدراية",
        commune_name_ascii: "Sedraya",
        daira_name: "القلب الكبير",
        daira_name_ascii: "Guelb El Kebir",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "عين اقصير",
        commune_name_ascii: "Ain Ouksir",
        daira_name: "شلالة العذاورة",
        daira_name_ascii: "Chellalat El Adhaoura",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "شلالة العذاورة",
        commune_name_ascii: "Chelalet El Adhaoura",
        daira_name: "شلالة العذاورة",
        daira_name_ascii: "Chellalat El Adhaoura",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "شنيقل",
        commune_name_ascii: "Cheniguel",
        daira_name: "شلالة العذاورة",
        daira_name_ascii: "Chellalat El Adhaoura",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "تفراوت",
        commune_name_ascii: "Tafraout",
        daira_name: "شلالة العذاورة",
        daira_name_ascii: "Chellalat El Adhaoura",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "بوشراحيل",
        commune_name_ascii: "Bouchrahil",
        daira_name: "سيدي نعمان",
        daira_name_ascii: "Sidi Naamane",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "خمس جوامع",
        commune_name_ascii: "Khams Djouamaa",
        daira_name: "سيدي نعمان",
        daira_name_ascii: "Sidi Naamane",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "سيدي نعمان",
        commune_name_ascii: "Sidi Naamane",
        daira_name: "سيدي نعمان",
        daira_name_ascii: "Sidi Naamane",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "عزيز",
        commune_name_ascii: "Aziz",
        daira_name: "عزيز",
        daira_name_ascii: "Aziz",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "دراق",
        commune_name_ascii: "Derrag",
        daira_name: "عزيز",
        daira_name_ascii: "Aziz",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "أم الجليل",
        commune_name_ascii: "Oum El Djellil",
        daira_name: "عزيز",
        daira_name_ascii: "Aziz",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "جواب",
        commune_name_ascii: "Djouab",
        daira_name: "السواقي",
        daira_name_ascii: "Souaghi",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "سيدي زهار",
        commune_name_ascii: "Sidi Zahar",
        daira_name: "السواقي",
        daira_name_ascii: "Souaghi",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "سيدي زيان",
        commune_name_ascii: "Sidi Ziane",
        daira_name: "السواقي",
        daira_name_ascii: "Souaghi",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "أولاد عنتر",
        commune_name_ascii: "Ouled Antar",
        daira_name: "أولاد عنتر",
        daira_name_ascii: "Ouled Antar",
        wilaya_code: 26,
        wilaya_name: "المدية",
        wilaya_name_ascii: "Médéa"
    },
    {
        commune_name: "فرناقة",
        commune_name_ascii: "Fornaka",
        daira_name: "عين نويسي",
        daira_name_ascii: "Ain Nouicy",
        wilaya_code: 27,
        wilaya_name: "مستغانم",
        wilaya_name_ascii: "Mostaganem"
    },
    {
        commune_name: "وادي الخير",
        commune_name_ascii: "Oued El Kheir",
        daira_name: "عين تادلس",
        daira_name_ascii: "Ain Tedeles",
        wilaya_code: 27,
        wilaya_name: "مستغانم",
        wilaya_name_ascii: "Mostaganem"
    },
    {
        commune_name: "الحسيان (بني ياحي",
        commune_name_ascii: "Hassiane",
        daira_name: "عين نويسي",
        daira_name_ascii: "Ain Nouicy",
        wilaya_code: 27,
        wilaya_name: "مستغانم",
        wilaya_name_ascii: "Mostaganem"
    },
    {
        commune_name: "حاسي ماماش",
        commune_name_ascii: "Hassi Mameche",
        daira_name: "حاسي ماماش",
        daira_name_ascii: "Hassi Mameche",
        wilaya_code: 27,
        wilaya_name: "مستغانم",
        wilaya_name_ascii: "Mostaganem"
    },
    {
        commune_name: "مزغران",
        commune_name_ascii: "Mazagran",
        daira_name: "حاسي ماماش",
        daira_name_ascii: "Hassi Mameche",
        wilaya_code: 27,
        wilaya_name: "مستغانم",
        wilaya_name_ascii: "Mostaganem"
    },
    {
        commune_name: "ستيدية",
        commune_name_ascii: "Stidia",
        daira_name: "حاسي ماماش",
        daira_name_ascii: "Hassi Mameche",
        wilaya_code: 27,
        wilaya_name: "مستغانم",
        wilaya_name_ascii: "Mostaganem"
    },
    {
        commune_name: "عين تادلس",
        commune_name_ascii: "Ain-Tedles",
        daira_name: "عين تادلس",
        daira_name_ascii: "Ain Tedeles",
        wilaya_code: 27,
        wilaya_name: "مستغانم",
        wilaya_name_ascii: "Mostaganem"
    },
    {
        commune_name: "سيدي بلعطار",
        commune_name_ascii: "Sidi Belaattar",
        daira_name: "عين تادلس",
        daira_name_ascii: "Ain Tedeles",
        wilaya_code: 27,
        wilaya_name: "مستغانم",
        wilaya_name_ascii: "Mostaganem"
    },
    {
        commune_name: "سور",
        commune_name_ascii: "Sour",
        daira_name: "عين تادلس",
        daira_name_ascii: "Ain Tedeles",
        wilaya_code: 27,
        wilaya_name: "مستغانم",
        wilaya_name_ascii: "Mostaganem"
    },
    {
        commune_name: "عين بودينار",
        commune_name_ascii: "Ain-Boudinar",
        daira_name: "خير الدين",
        daira_name_ascii: "Kheir Eddine",
        wilaya_code: 27,
        wilaya_name: "مستغانم",
        wilaya_name_ascii: "Mostaganem"
    },
    {
        commune_name: "خير الدين",
        commune_name_ascii: "Kheir-Eddine",
        daira_name: "خير الدين",
        daira_name_ascii: "Kheir Eddine",
        wilaya_code: 27,
        wilaya_name: "مستغانم",
        wilaya_name_ascii: "Mostaganem"
    },
    {
        commune_name: "صيادة",
        commune_name_ascii: "Sayada",
        daira_name: "خير الدين",
        daira_name_ascii: "Kheir Eddine",
        wilaya_code: 27,
        wilaya_name: "مستغانم",
        wilaya_name_ascii: "Mostaganem"
    },
    {
        commune_name: "سيدي علي",
        commune_name_ascii: "Sidi Ali",
        daira_name: "سيدي علي",
        daira_name_ascii: "Sidi Ali",
        wilaya_code: 27,
        wilaya_name: "مستغانم",
        wilaya_name_ascii: "Mostaganem"
    },
    {
        commune_name: "تزقايت",
        commune_name_ascii: "Tazgait",
        daira_name: "سيدي علي",
        daira_name_ascii: "Sidi Ali",
        wilaya_code: 27,
        wilaya_name: "مستغانم",
        wilaya_name_ascii: "Mostaganem"
    },
    {
        commune_name: "بن عبد المالك رمضان",
        commune_name_ascii: "Benabdelmalek Ramdane",
        daira_name: "سيدي لخضر",
        daira_name_ascii: "Sidi Lakhdar",
        wilaya_code: 27,
        wilaya_name: "مستغانم",
        wilaya_name_ascii: "Mostaganem"
    },
    {
        commune_name: "مستغانم",
        commune_name_ascii: "Mostaganem",
        daira_name: "مستغانم",
        daira_name_ascii: "Mostaganem",
        wilaya_code: 27,
        wilaya_name: "مستغانم",
        wilaya_name_ascii: "Mostaganem"
    },
    {
        commune_name: "حجاج",
        commune_name_ascii: "Hadjadj",
        daira_name: "سيدي لخضر",
        daira_name_ascii: "Sidi Lakhdar",
        wilaya_code: 27,
        wilaya_name: "مستغانم",
        wilaya_name_ascii: "Mostaganem"
    },
    {
        commune_name: "سيدي لخضر",
        commune_name_ascii: "Sidi-Lakhdar",
        daira_name: "سيدي لخضر",
        daira_name_ascii: "Sidi Lakhdar",
        wilaya_code: 27,
        wilaya_name: "مستغانم",
        wilaya_name_ascii: "Mostaganem"
    },
    {
        commune_name: "عشعاشة",
        commune_name_ascii: "Achaacha",
        daira_name: "عشعاشة",
        daira_name_ascii: "Achaacha",
        wilaya_code: 27,
        wilaya_name: "مستغانم",
        wilaya_name_ascii: "Mostaganem"
    },
    {
        commune_name: "خضرة",
        commune_name_ascii: "Khadra",
        daira_name: "عشعاشة",
        daira_name_ascii: "Achaacha",
        wilaya_code: 27,
        wilaya_name: "مستغانم",
        wilaya_name_ascii: "Mostaganem"
    },
    {
        commune_name: "نكمارية",
        commune_name_ascii: "Nekmaria",
        daira_name: "عشعاشة",
        daira_name_ascii: "Achaacha",
        wilaya_code: 27,
        wilaya_name: "مستغانم",
        wilaya_name_ascii: "Mostaganem"
    },
    {
        commune_name: "أولاد بوغالم",
        commune_name_ascii: "Ouled Boughalem",
        daira_name: "عشعاشة",
        daira_name_ascii: "Achaacha",
        wilaya_code: 27,
        wilaya_name: "مستغانم",
        wilaya_name_ascii: "Mostaganem"
    },
    {
        commune_name: "بوقيراط",
        commune_name_ascii: "Bouguirat",
        daira_name: "بوقيراط",
        daira_name_ascii: "Bouguirat",
        wilaya_code: 27,
        wilaya_name: "مستغانم",
        wilaya_name_ascii: "Mostaganem"
    },
    {
        commune_name: "صفصاف",
        commune_name_ascii: "Safsaf",
        daira_name: "بوقيراط",
        daira_name_ascii: "Bouguirat",
        wilaya_code: 27,
        wilaya_name: "مستغانم",
        wilaya_name_ascii: "Mostaganem"
    },
    {
        commune_name: "سيرات",
        commune_name_ascii: "Sirat",
        daira_name: "بوقيراط",
        daira_name_ascii: "Bouguirat",
        wilaya_code: 27,
        wilaya_name: "مستغانم",
        wilaya_name_ascii: "Mostaganem"
    },
    {
        commune_name: "السوافلية",
        commune_name_ascii: "Souaflia",
        daira_name: "بوقيراط",
        daira_name_ascii: "Bouguirat",
        wilaya_code: 27,
        wilaya_name: "مستغانم",
        wilaya_name_ascii: "Mostaganem"
    },
    {
        commune_name: "عين سيدي الشريف",
        commune_name_ascii: "Ain-Sidi Cherif",
        daira_name: "ماسرة",
        daira_name_ascii: "Mesra",
        wilaya_code: 27,
        wilaya_name: "مستغانم",
        wilaya_name_ascii: "Mostaganem"
    },
    {
        commune_name: "منصورة",
        commune_name_ascii: "Mansourah",
        daira_name: "ماسرة",
        daira_name_ascii: "Mesra",
        wilaya_code: 27,
        wilaya_name: "مستغانم",
        wilaya_name_ascii: "Mostaganem"
    },
    {
        commune_name: "ماسرة",
        commune_name_ascii: "Mesra",
        daira_name: "ماسرة",
        daira_name_ascii: "Mesra",
        wilaya_code: 27,
        wilaya_name: "مستغانم",
        wilaya_name_ascii: "Mostaganem"
    },
    {
        commune_name: "الطواهرية",
        commune_name_ascii: "Touahria",
        daira_name: "ماسرة",
        daira_name_ascii: "Mesra",
        wilaya_code: 27,
        wilaya_name: "مستغانم",
        wilaya_name_ascii: "Mostaganem"
    },
    {
        commune_name: "عين نويسي",
        commune_name_ascii: "Ain-Nouissy",
        daira_name: "عين نويسي",
        daira_name_ascii: "Ain Nouicy",
        wilaya_code: 27,
        wilaya_name: "مستغانم",
        wilaya_name_ascii: "Mostaganem"
    },
    {
        commune_name: "أولاد مع الله",
        commune_name_ascii: "Ouled-Maalah",
        daira_name: "سيدي علي",
        daira_name_ascii: "Sidi Ali",
        wilaya_code: 27,
        wilaya_name: "مستغانم",
        wilaya_name_ascii: "Mostaganem"
    },
    {
        commune_name: "شلال",
        commune_name_ascii: "Chellal",
        daira_name: "شلال",
        daira_name_ascii: "Chellal",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "أولاد ماضي",
        commune_name_ascii: "Ouled Madhi",
        daira_name: "شلال",
        daira_name_ascii: "Chellal",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "خطوطي سد الجير",
        commune_name_ascii: "Khettouti Sed-El-Jir",
        daira_name: "شلال",
        daira_name_ascii: "Chellal",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "بلعايبة",
        commune_name_ascii: "Belaiba",
        daira_name: "مقرة",
        daira_name_ascii: "Magra",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "برهوم",
        commune_name_ascii: "Berhoum",
        daira_name: "مقرة",
        daira_name_ascii: "Magra",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "دهاهنة",
        commune_name_ascii: "Dehahna",
        daira_name: "مقرة",
        daira_name_ascii: "Magra",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "مقرة",
        commune_name_ascii: "Magra",
        daira_name: "مقرة",
        daira_name_ascii: "Magra",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "بني يلمان",
        commune_name_ascii: "Beni Ilmane",
        daira_name: "سيدي عيسى",
        daira_name_ascii: "Sidi Aissa",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "بوطي السايح",
        commune_name_ascii: "Bouti Sayeh",
        daira_name: "سيدي عيسى",
        daira_name_ascii: "Sidi Aissa",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "سيدي عيسى",
        commune_name_ascii: "Sidi Aissa",
        daira_name: "سيدي عيسى",
        daira_name_ascii: "Sidi Aissa",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "عين الحجل",
        commune_name_ascii: "Ain El Hadjel",
        daira_name: "عين الحجل",
        daira_name_ascii: "Ain El Hadjel",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "سيدي هجرس",
        commune_name_ascii: "Sidi Hadjeres",
        daira_name: "عين الحجل",
        daira_name_ascii: "Ain El Hadjel",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "بوسعادة",
        commune_name_ascii: "Bou Saada",
        daira_name: "بوسعادة",
        daira_name_ascii: "Bousaada",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "الهامل",
        commune_name_ascii: "El Hamel",
        daira_name: "بوسعادة",
        daira_name_ascii: "Bousaada",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "ولتام",
        commune_name_ascii: "Oulteme",
        daira_name: "بوسعادة",
        daira_name_ascii: "Bousaada",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "بن زوه",
        commune_name_ascii: "Benzouh",
        daira_name: "أولاد سيدي ابراهيم",
        daira_name_ascii: "Ouled Sidi Brahim",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "أولاد سيدي ابراهيم",
        commune_name_ascii: "Ouled Sidi Brahim",
        daira_name: "أولاد سيدي ابراهيم",
        daira_name_ascii: "Ouled Sidi Brahim",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "سيدي عامر",
        commune_name_ascii: "Sidi Ameur",
        daira_name: "سيدي عامر",
        daira_name_ascii: "Sidi Ameur",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "تامسة",
        commune_name_ascii: "Tamsa",
        daira_name: "سيدي عامر",
        daira_name_ascii: "Sidi Ameur",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "بن سرور",
        commune_name_ascii: "Ben Srour",
        daira_name: "بن سرور",
        daira_name_ascii: "Ben Srour",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "محمد بوضياف",
        commune_name_ascii: "Mohamed Boudiaf",
        daira_name: "بن سرور",
        daira_name_ascii: "Ben Srour",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "أولاد سليمان",
        commune_name_ascii: "Ouled Slimane",
        daira_name: "بن سرور",
        daira_name_ascii: "Ben Srour",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "زرزور",
        commune_name_ascii: "Zarzour",
        daira_name: "بن سرور",
        daira_name_ascii: "Ben Srour",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "عين الملح",
        commune_name_ascii: "Ain El Melh",
        daira_name: "عين الملح",
        daira_name_ascii: "Ain El Melh",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "عين فارس",
        commune_name_ascii: "Ain Fares",
        daira_name: "عين الملح",
        daira_name_ascii: "Ain El Melh",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "عين الريش",
        commune_name_ascii: "Ain Rich",
        daira_name: "عين الملح",
        daira_name_ascii: "Ain El Melh",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "بئر فضة",
        commune_name_ascii: "Bir Foda",
        daira_name: "عين الملح",
        daira_name_ascii: "Ain El Melh",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "سيدي امحمد",
        commune_name_ascii: "Sidi M'hamed",
        daira_name: "عين الملح",
        daira_name_ascii: "Ain El Melh",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "امجدل",
        commune_name_ascii: "Medjedel",
        daira_name: "امجدل",
        daira_name_ascii: "Medjedel",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "مناعة",
        commune_name_ascii: "Menaa",
        daira_name: "امجدل",
        daira_name_ascii: "Medjedel",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "جبل مساعد",
        commune_name_ascii: "Djebel Messaad",
        daira_name: "جبل مساعد",
        daira_name_ascii: "Djebel Messaad",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "سليم",
        commune_name_ascii: "Slim",
        daira_name: "جبل مساعد",
        daira_name_ascii: "Djebel Messaad",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "المسيلة",
        commune_name_ascii: "M'sila",
        daira_name: "المسيلة",
        daira_name_ascii: "M'sila",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "حمام الضلعة",
        commune_name_ascii: "Hammam Dalaa",
        daira_name: "حمام الضلعة",
        daira_name_ascii: "Hammam Dalaa",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "ونوغة",
        commune_name_ascii: "Ouanougha",
        daira_name: "حمام الضلعة",
        daira_name_ascii: "Hammam Dalaa",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "أولاد منصور",
        commune_name_ascii: "Ouled Mansour",
        daira_name: "حمام الضلعة",
        daira_name_ascii: "Hammam Dalaa",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "تارمونت",
        commune_name_ascii: "Tarmount",
        daira_name: "حمام الضلعة",
        daira_name_ascii: "Hammam Dalaa",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "المعاضيد",
        commune_name_ascii: "Maadid",
        daira_name: "أولاد دراج",
        daira_name_ascii: "Ouled Derradj",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "المطارفة",
        commune_name_ascii: "M'tarfa",
        daira_name: "أولاد دراج",
        daira_name_ascii: "Ouled Derradj",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "معاريف",
        commune_name_ascii: "Maarif",
        daira_name: "شلال",
        daira_name_ascii: "Chellal",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "أولاد دراج",
        commune_name_ascii: "Ouled Derradj",
        daira_name: "أولاد دراج",
        daira_name_ascii: "Ouled Derradj",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "السوامع",
        commune_name_ascii: "Souamaa",
        daira_name: "أولاد دراج",
        daira_name_ascii: "Ouled Derradj",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "الحوامد",
        commune_name_ascii: "El Houamed",
        daira_name: "خبانة",
        daira_name_ascii: "Khoubana",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "خبانة",
        commune_name_ascii: "Khoubana",
        daira_name: "خبانة",
        daira_name_ascii: "Khoubana",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "مسيف",
        commune_name_ascii: "M'cif",
        daira_name: "خبانة",
        daira_name_ascii: "Khoubana",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "عين الخضراء",
        commune_name_ascii: "Ain Khadra",
        daira_name: "مقرة",
        daira_name_ascii: "Magra",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "أولاد عدي لقبالة",
        commune_name_ascii: "Ouled Addi Guebala",
        daira_name: "أولاد دراج",
        daira_name_ascii: "Ouled Derradj",
        wilaya_code: 28,
        wilaya_name: "المسيلة",
        wilaya_name_ascii: "M'Sila"
    },
    {
        commune_name: "وادي الأبطال",
        commune_name_ascii: "Oued El Abtal",
        daira_name: "وادي الأبطال",
        daira_name_ascii: "Oued El Abtal",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "سيدي عبد المومن",
        commune_name_ascii: "Sidi Abdelmoumene",
        daira_name: "المحمدية",
        daira_name_ascii: "Mohammadia",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "سجرارة",
        commune_name_ascii: "Sedjerara",
        daira_name: "المحمدية",
        daira_name_ascii: "Mohammadia",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "المحمدية",
        commune_name_ascii: "Mohammadia",
        daira_name: "المحمدية",
        daira_name_ascii: "Mohammadia",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "تيغنيف",
        commune_name_ascii: "Tighennif",
        daira_name: "تيغنيف",
        daira_name_ascii: "Tighennif",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "مقطع الدوز",
        commune_name_ascii: "Mocta-Douz",
        daira_name: "المحمدية",
        daira_name_ascii: "Mohammadia",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "فراقيق",
        commune_name_ascii: "Ferraguig",
        daira_name: "المحمدية",
        daira_name_ascii: "Mohammadia",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "الغمري",
        commune_name_ascii: "El Ghomri",
        daira_name: "المحمدية",
        daira_name_ascii: "Mohammadia",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "زهانة",
        commune_name_ascii: "Zahana",
        daira_name: "زهانة",
        daira_name_ascii: "Zahana",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "القعدة",
        commune_name_ascii: "El Gaada",
        daira_name: "زهانة",
        daira_name_ascii: "Zahana",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "رأس عين عميروش",
        commune_name_ascii: "Ras El Ain Amirouche",
        daira_name: "عقاز",
        daira_name_ascii: "Oggaz",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "عقاز",
        commune_name_ascii: "Oggaz",
        daira_name: "عقاز",
        daira_name_ascii: "Oggaz",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "العلايمية",
        commune_name_ascii: "Alaimia",
        daira_name: "عقاز",
        daira_name_ascii: "Oggaz",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "سيق",
        commune_name_ascii: "Sig",
        daira_name: "سيق",
        daira_name_ascii: "Sig",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "الشرفاء",
        commune_name_ascii: "Chorfa",
        daira_name: "سيق",
        daira_name_ascii: "Sig",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "بوهني",
        commune_name_ascii: "Bou Henni",
        daira_name: "سيق",
        daira_name_ascii: "Sig",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "المأمونية",
        commune_name_ascii: "El Mamounia",
        daira_name: "عين فارس",
        daira_name_ascii: "Ain Fares",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "القطنة",
        commune_name_ascii: "El Gueitena",
        daira_name: "بوحنيفية",
        daira_name_ascii: "Bouhanifia",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "عين فارس",
        commune_name_ascii: "Ain Fares",
        daira_name: "عين فارس",
        daira_name_ascii: "Ain Fares",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "غروس",
        commune_name_ascii: "Gharrous",
        daira_name: "عوف",
        daira_name_ascii: "Aouf",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "بنيان",
        commune_name_ascii: "Benian",
        daira_name: "عوف",
        daira_name_ascii: "Aouf",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "عوف",
        commune_name_ascii: "Aouf",
        daira_name: "عوف",
        daira_name_ascii: "Aouf",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "قرجوم",
        commune_name_ascii: "Guerdjoum",
        daira_name: "وادي التاغية",
        daira_name_ascii: "Oued Taria",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "عين أفرص",
        commune_name_ascii: "Ain Frass",
        daira_name: "عين فكان",
        daira_name_ascii: "Ain Fekan",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "عين فكان",
        commune_name_ascii: "Ain Fekan",
        daira_name: "عين فكان",
        daira_name_ascii: "Ain Fekan",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "خلوية",
        commune_name_ascii: "Khalouia",
        daira_name: "البرج",
        daira_name_ascii: "El Bordj",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "المنور",
        commune_name_ascii: "El Menaouer",
        daira_name: "البرج",
        daira_name_ascii: "El Bordj",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "البرج",
        commune_name_ascii: "El Bordj",
        daira_name: "البرج",
        daira_name_ascii: "El Bordj",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "سيدي بوسعيد",
        commune_name_ascii: "Sidi Boussaid",
        daira_name: "غريس",
        daira_name_ascii: "Ghriss",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "المطمور",
        commune_name_ascii: "Matemore",
        daira_name: "غريس",
        daira_name_ascii: "Ghriss",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "سيدي قادة",
        commune_name_ascii: "Sidi Kada",
        daira_name: "تيغنيف",
        daira_name_ascii: "Tighennif",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "ماقضة",
        commune_name_ascii: "Makhda",
        daira_name: "غريس",
        daira_name_ascii: "Ghriss",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "معسكر",
        commune_name_ascii: "Mascara",
        daira_name: "معسكر",
        daira_name_ascii: "Mascara",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "بوحنيفية",
        commune_name_ascii: "Bouhanifia",
        daira_name: "بوحنيفية",
        daira_name_ascii: "Bouhanifia",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "غريس",
        commune_name_ascii: "Ghriss",
        daira_name: "غريس",
        daira_name_ascii: "Ghriss",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "حسين",
        commune_name_ascii: "Hacine",
        daira_name: "بوحنيفية",
        daira_name_ascii: "Bouhanifia",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "القرط",
        commune_name_ascii: "El Keurt",
        daira_name: "تيزي",
        daira_name_ascii: "Tizi",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "فروحة",
        commune_name_ascii: "Froha",
        daira_name: "تيزي",
        daira_name_ascii: "Tizi",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "تيزي",
        commune_name_ascii: "Tizi",
        daira_name: "تيزي",
        daira_name_ascii: "Tizi",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "السهايلية",
        commune_name_ascii: "Sehailia",
        daira_name: "تيغنيف",
        daira_name_ascii: "Tighennif",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "ماوسة",
        commune_name_ascii: "Maoussa",
        daira_name: "غريس",
        daira_name_ascii: "Ghriss",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "سيدي عبد الجبار",
        commune_name_ascii: "Sidi Abdeldjebar",
        daira_name: "وادي الأبطال",
        daira_name_ascii: "Oued El Abtal",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "الحشم",
        commune_name_ascii: "El Hachem",
        daira_name: "الحشم",
        daira_name_ascii: "Hachem",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "نسمط",
        commune_name_ascii: "Nesmot",
        daira_name: "الحشم",
        daira_name_ascii: "Hachem",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "زلامطة",
        commune_name_ascii: "Zelamta",
        daira_name: "الحشم",
        daira_name_ascii: "Hachem",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "عين فراح",
        commune_name_ascii: "Ain Ferah",
        daira_name: "وادي الأبطال",
        daira_name_ascii: "Oued El Abtal",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "وادي التاغية",
        commune_name_ascii: "Oued Taria",
        daira_name: "وادي التاغية",
        daira_name_ascii: "Oued Taria",
        wilaya_code: 29,
        wilaya_name: "معسكر",
        wilaya_name_ascii: "Mascara"
    },
    {
        commune_name: "ورقلة",
        commune_name_ascii: "Ouargla",
        daira_name: "ورقلة",
        daira_name_ascii: "Ouargla",
        wilaya_code: 30,
        wilaya_name: "ورقلة",
        wilaya_name_ascii: "Ouargla"
    },
    {
        commune_name: "حاسي مسعود",
        commune_name_ascii: "Hassi Messaoud",
        daira_name: "حاسي مسعود",
        daira_name_ascii: "Hassi Messaoud",
        wilaya_code: 30,
        wilaya_name: "ورقلة",
        wilaya_name_ascii: "Ouargla"
    },
    {
        commune_name: "عين البيضاء",
        commune_name_ascii: "Ain Beida",
        daira_name: "سيدي خويلد",
        daira_name_ascii: "Sidi Khouiled",
        wilaya_code: 30,
        wilaya_name: "ورقلة",
        wilaya_name_ascii: "Ouargla"
    },
    {
        commune_name: "حاسي بن عبد الله",
        commune_name_ascii: "Hassi Ben Abdellah",
        daira_name: "سيدي خويلد",
        daira_name_ascii: "Sidi Khouiled",
        wilaya_code: 30,
        wilaya_name: "ورقلة",
        wilaya_name_ascii: "Ouargla"
    },
    {
        commune_name: "سيدي خويلد",
        commune_name_ascii: "Sidi Khouiled",
        daira_name: "سيدي خويلد",
        daira_name_ascii: "Sidi Khouiled",
        wilaya_code: 30,
        wilaya_name: "ورقلة",
        wilaya_name_ascii: "Ouargla"
    },
    {
        commune_name: "البرمة",
        commune_name_ascii: "El Borma",
        daira_name: "البرمة",
        daira_name_ascii: "El Borma",
        wilaya_code: 30,
        wilaya_name: "ورقلة",
        wilaya_name_ascii: "Ouargla"
    },
    {
        commune_name: "الرويسات",
        commune_name_ascii: "Rouissat",
        daira_name: "ورقلة",
        daira_name_ascii: "Ouargla",
        wilaya_code: 30,
        wilaya_name: "ورقلة",
        wilaya_name_ascii: "Ouargla"
    },
    {
        commune_name: "انقوسة",
        commune_name_ascii: "N'goussa",
        daira_name: "انقوسة",
        daira_name_ascii: "N'goussa",
        wilaya_code: 30,
        wilaya_name: "ورقلة",
        wilaya_name_ascii: "Ouargla"
    },
    {
        commune_name: "سيدي الشحمي",
        commune_name_ascii: "Sidi Chami",
        daira_name: "السانية",
        daira_name_ascii: "Es Senia",
        wilaya_code: 31,
        wilaya_name: "وهران",
        wilaya_name_ascii: "Oran"
    },
    {
        commune_name: "حاسي مفسوخ",
        commune_name_ascii: "Hassi Mefsoukh",
        daira_name: "قديل",
        daira_name_ascii: "Gdyel",
        wilaya_code: 31,
        wilaya_name: "وهران",
        wilaya_name_ascii: "Oran"
    },
    {
        commune_name: "بئر الجير",
        commune_name_ascii: "Bir El Djir",
        daira_name: "بئر الجير",
        daira_name_ascii: "Bir El Djir",
        wilaya_code: 31,
        wilaya_name: "وهران",
        wilaya_name_ascii: "Oran"
    },
    {
        commune_name: "حاسي بن عقبة",
        commune_name_ascii: "Hassi Ben Okba",
        daira_name: "بئر الجير",
        daira_name_ascii: "Bir El Djir",
        wilaya_code: 31,
        wilaya_name: "وهران",
        wilaya_name_ascii: "Oran"
    },
    {
        commune_name: "قديل",
        commune_name_ascii: "Gdyel",
        daira_name: "قديل",
        daira_name_ascii: "Gdyel",
        wilaya_code: 31,
        wilaya_name: "وهران",
        wilaya_name_ascii: "Oran"
    },
    {
        commune_name: "حاسي بونيف",
        commune_name_ascii: "Hassi Bounif",
        daira_name: "بئر الجير",
        daira_name_ascii: "Bir El Djir",
        wilaya_code: 31,
        wilaya_name: "وهران",
        wilaya_name_ascii: "Oran"
    },
    {
        commune_name: "الكرمة",
        commune_name_ascii: "El Kerma",
        daira_name: "السانية",
        daira_name_ascii: "Es Senia",
        wilaya_code: 31,
        wilaya_name: "وهران",
        wilaya_name_ascii: "Oran"
    },
    {
        commune_name: "السانية",
        commune_name_ascii: "Es Senia",
        daira_name: "السانية",
        daira_name_ascii: "Es Senia",
        wilaya_code: 31,
        wilaya_name: "وهران",
        wilaya_name_ascii: "Oran"
    },
    {
        commune_name: "بن فريحة",
        commune_name_ascii: "Ben Freha",
        daira_name: "قديل",
        daira_name_ascii: "Gdyel",
        wilaya_code: 31,
        wilaya_name: "وهران",
        wilaya_name_ascii: "Oran"
    },
    {
        commune_name: "أرزيو",
        commune_name_ascii: "Arzew",
        daira_name: "أرزيو",
        daira_name_ascii: "Arzew",
        wilaya_code: 31,
        wilaya_name: "وهران",
        wilaya_name_ascii: "Oran"
    },
    {
        commune_name: "سيدي بن يبقى",
        commune_name_ascii: "Sidi Ben Yebka",
        daira_name: "أرزيو",
        daira_name_ascii: "Arzew",
        wilaya_code: 31,
        wilaya_name: "وهران",
        wilaya_name_ascii: "Oran"
    },
    {
        commune_name: "عين البية",
        commune_name_ascii: "Ain Biya",
        daira_name: "بطيوة",
        daira_name_ascii: "Bethioua",
        wilaya_code: 31,
        wilaya_name: "وهران",
        wilaya_name_ascii: "Oran"
    },
    {
        commune_name: "بطيوة",
        commune_name_ascii: "Bethioua",
        daira_name: "بطيوة",
        daira_name_ascii: "Bethioua",
        wilaya_code: 31,
        wilaya_name: "وهران",
        wilaya_name_ascii: "Oran"
    },
    {
        commune_name: "مرسى الحجاج",
        commune_name_ascii: "Marsat El Hadjadj",
        daira_name: "بطيوة",
        daira_name_ascii: "Bethioua",
        wilaya_code: 31,
        wilaya_name: "وهران",
        wilaya_name_ascii: "Oran"
    },
    {
        commune_name: "عين الترك",
        commune_name_ascii: "Ain Turk",
        daira_name: "عين الترك",
        daira_name_ascii: "Ain Turk",
        wilaya_code: 31,
        wilaya_name: "وهران",
        wilaya_name_ascii: "Oran"
    },
    {
        commune_name: "وهران",
        commune_name_ascii: "Oran",
        daira_name: "وهران",
        daira_name_ascii: "Oran",
        wilaya_code: 31,
        wilaya_name: "وهران",
        wilaya_name_ascii: "Oran"
    },
    {
        commune_name: "العنصر",
        commune_name_ascii: "El Ancor",
        daira_name: "عين الترك",
        daira_name_ascii: "Ain Turk",
        wilaya_code: 31,
        wilaya_name: "وهران",
        wilaya_name_ascii: "Oran"
    },
    {
        commune_name: "المرسى الكبير",
        commune_name_ascii: "Mers El Kebir",
        daira_name: "عين الترك",
        daira_name_ascii: "Ain Turk",
        wilaya_code: 31,
        wilaya_name: "وهران",
        wilaya_name_ascii: "Oran"
    },
    {
        commune_name: "بوفاتيس",
        commune_name_ascii: "Boufatis",
        daira_name: "وادي تليلات",
        daira_name_ascii: "Oued Tlelat",
        wilaya_code: 31,
        wilaya_name: "وهران",
        wilaya_name_ascii: "Oran"
    },
    {
        commune_name: "البراية",
        commune_name_ascii: "El Braya",
        daira_name: "وادي تليلات",
        daira_name_ascii: "Oued Tlelat",
        wilaya_code: 31,
        wilaya_name: "وهران",
        wilaya_name_ascii: "Oran"
    },
    {
        commune_name: "وادي تليلات",
        commune_name_ascii: "Oued Tlelat",
        daira_name: "وادي تليلات",
        daira_name_ascii: "Oued Tlelat",
        wilaya_code: 31,
        wilaya_name: "وهران",
        wilaya_name_ascii: "Oran"
    },
    {
        commune_name: "عين الكرمة",
        commune_name_ascii: "Ain Kerma",
        daira_name: "بوتليليس",
        daira_name_ascii: "Boutlelis",
        wilaya_code: 31,
        wilaya_name: "وهران",
        wilaya_name_ascii: "Oran"
    },
    {
        commune_name: "بوتليليس",
        commune_name_ascii: "Boutlelis",
        daira_name: "بوتليليس",
        daira_name_ascii: "Boutlelis",
        wilaya_code: 31,
        wilaya_name: "وهران",
        wilaya_name_ascii: "Oran"
    },
    {
        commune_name: "مسرغين",
        commune_name_ascii: "Messerghin",
        daira_name: "بوتليليس",
        daira_name_ascii: "Boutlelis",
        wilaya_code: 31,
        wilaya_name: "وهران",
        wilaya_name_ascii: "Oran"
    },
    {
        commune_name: "بوسفر",
        commune_name_ascii: "Bousfer",
        daira_name: "عين الترك",
        daira_name_ascii: "Ain Turk",
        wilaya_code: 31,
        wilaya_name: "وهران",
        wilaya_name_ascii: "Oran"
    },
    {
        commune_name: "طفراوي",
        commune_name_ascii: "Tafraoui",
        daira_name: "وادي تليلات",
        daira_name_ascii: "Oued Tlelat",
        wilaya_code: 31,
        wilaya_name: "وهران",
        wilaya_name_ascii: "Oran"
    },
    {
        commune_name: "عين العراك",
        commune_name_ascii: "Ain El Orak",
        daira_name: "الأبيض سيدي الشيخ",
        daira_name_ascii: "Labiodh Sidi Cheikh",
        wilaya_code: 32,
        wilaya_name: "البيض",
        wilaya_name_ascii: "El Bayadh"
    },
    {
        commune_name: "كراكدة",
        commune_name_ascii: "Krakda",
        daira_name: "بريزينة",
        daira_name_ascii: "Brezina",
        wilaya_code: 32,
        wilaya_name: "البيض",
        wilaya_name_ascii: "El Bayadh"
    },
    {
        commune_name: "سيدي سليمان",
        commune_name_ascii: "Sidi Slimane",
        daira_name: "بوعلام",
        daira_name_ascii: "Boualem",
        wilaya_code: 32,
        wilaya_name: "البيض",
        wilaya_name_ascii: "El Bayadh"
    },
    {
        commune_name: "سيدي عامر",
        commune_name_ascii: "Sidi Ameur",
        daira_name: "بوعلام",
        daira_name_ascii: "Boualem",
        wilaya_code: 32,
        wilaya_name: "البيض",
        wilaya_name_ascii: "El Bayadh"
    },
    {
        commune_name: "بوعلام",
        commune_name_ascii: "Boualem",
        daira_name: "بوعلام",
        daira_name_ascii: "Boualem",
        wilaya_code: 32,
        wilaya_name: "البيض",
        wilaya_name_ascii: "El Bayadh"
    },
    {
        commune_name: "البنود",
        commune_name_ascii: "El Bnoud",
        daira_name: "الأبيض سيدي الشيخ",
        daira_name_ascii: "Labiodh Sidi Cheikh",
        wilaya_code: 32,
        wilaya_name: "البيض",
        wilaya_name_ascii: "El Bayadh"
    },
    {
        commune_name: "بوقطب",
        commune_name_ascii: "Bougtoub",
        daira_name: "بوقطب",
        daira_name_ascii: "Bougtoub",
        wilaya_code: 32,
        wilaya_name: "البيض",
        wilaya_name_ascii: "El Bayadh"
    },
    {
        commune_name: "الخيثر",
        commune_name_ascii: "El Kheiter",
        daira_name: "بوقطب",
        daira_name_ascii: "Bougtoub",
        wilaya_code: 32,
        wilaya_name: "البيض",
        wilaya_name_ascii: "El Bayadh"
    },
    {
        commune_name: "توسمولين",
        commune_name_ascii: "Tousmouline",
        daira_name: "بوقطب",
        daira_name_ascii: "Bougtoub",
        wilaya_code: 32,
        wilaya_name: "البيض",
        wilaya_name_ascii: "El Bayadh"
    },
    {
        commune_name: "سيدي طيفور",
        commune_name_ascii: "Sidi Tiffour",
        daira_name: "بوعلام",
        daira_name_ascii: "Boualem",
        wilaya_code: 32,
        wilaya_name: "البيض",
        wilaya_name_ascii: "El Bayadh"
    },
    {
        commune_name: "ستيتن",
        commune_name_ascii: "Stitten",
        daira_name: "بوعلام",
        daira_name_ascii: "Boualem",
        wilaya_code: 32,
        wilaya_name: "البيض",
        wilaya_name_ascii: "El Bayadh"
    },
    {
        commune_name: "البيض",
        commune_name_ascii: "El Bayadh",
        daira_name: "البيض",
        daira_name_ascii: "El Bayadh",
        wilaya_code: 32,
        wilaya_name: "البيض",
        wilaya_name_ascii: "El Bayadh"
    },
    {
        commune_name: "رقاصة",
        commune_name_ascii: "Rogassa",
        daira_name: "رقاصة",
        daira_name_ascii: "Rogassa",
        wilaya_code: 32,
        wilaya_name: "البيض",
        wilaya_name_ascii: "El Bayadh"
    },
    {
        commune_name: "المحرة",
        commune_name_ascii: "El Mehara",
        daira_name: "شلالة",
        daira_name_ascii: "Chellala",
        wilaya_code: 32,
        wilaya_name: "البيض",
        wilaya_name_ascii: "El Bayadh"
    },
    {
        commune_name: "الكاف الأحمر",
        commune_name_ascii: "Kef El Ahmar",
        daira_name: "رقاصة",
        daira_name_ascii: "Rogassa",
        wilaya_code: 32,
        wilaya_name: "البيض",
        wilaya_name_ascii: "El Bayadh"
    },
    {
        commune_name: "بريزينة",
        commune_name_ascii: "Brezina",
        daira_name: "بريزينة",
        daira_name_ascii: "Brezina",
        wilaya_code: 32,
        wilaya_name: "البيض",
        wilaya_name_ascii: "El Bayadh"
    },
    {
        commune_name: "الغاسول",
        commune_name_ascii: "Ghassoul",
        daira_name: "بريزينة",
        daira_name_ascii: "Brezina",
        wilaya_code: 32,
        wilaya_name: "البيض",
        wilaya_name_ascii: "El Bayadh"
    },
    {
        commune_name: "الأبيض سيدي الشيخ",
        commune_name_ascii: "Labiodh Sidi Cheikh",
        daira_name: "الأبيض سيدي الشيخ",
        daira_name_ascii: "Labiodh Sidi Cheikh",
        wilaya_code: 32,
        wilaya_name: "البيض",
        wilaya_name_ascii: "El Bayadh"
    },
    {
        commune_name: "بوسمغون",
        commune_name_ascii: "Boussemghoun",
        daira_name: "بوسمغون",
        daira_name_ascii: "Boussemghoun",
        wilaya_code: 32,
        wilaya_name: "البيض",
        wilaya_name_ascii: "El Bayadh"
    },
    {
        commune_name: "الشقيق",
        commune_name_ascii: "Cheguig",
        daira_name: "رقاصة",
        daira_name_ascii: "Rogassa",
        wilaya_code: 32,
        wilaya_name: "البيض",
        wilaya_name_ascii: "El Bayadh"
    },
    {
        commune_name: "شلالة",
        commune_name_ascii: "Chellala",
        daira_name: "شلالة",
        daira_name_ascii: "Chellala",
        wilaya_code: 32,
        wilaya_name: "البيض",
        wilaya_name_ascii: "El Bayadh"
    },
    {
        commune_name: "اربوات",
        commune_name_ascii: "Arbaouat",
        daira_name: "الأبيض سيدي الشيخ",
        daira_name_ascii: "Labiodh Sidi Cheikh",
        wilaya_code: 32,
        wilaya_name: "البيض",
        wilaya_name_ascii: "El Bayadh"
    },
    {
        commune_name: "برج عمر إدريس",
        commune_name_ascii: "Bordj Omar Driss",
        daira_name: "إن أمناس",
        daira_name_ascii: "In Amenas",
        wilaya_code: 33,
        wilaya_name: "إليزي",
        wilaya_name_ascii: "Illizi"
    },
    {
        commune_name: "دبداب",
        commune_name_ascii: "Debdeb",
        daira_name: "إن أمناس",
        daira_name_ascii: "In Amenas",
        wilaya_code: 33,
        wilaya_name: "إليزي",
        wilaya_name_ascii: "Illizi"
    },
    {
        commune_name: "إن أمناس",
        commune_name_ascii: "In Amenas",
        daira_name: "إن أمناس",
        daira_name_ascii: "In Amenas",
        wilaya_code: 33,
        wilaya_name: "إليزي",
        wilaya_name_ascii: "Illizi"
    },
    {
        commune_name: "إيليزي",
        commune_name_ascii: "Illizi",
        daira_name: "إيليزي",
        daira_name_ascii: "Illizi",
        wilaya_code: 33,
        wilaya_name: "إليزي",
        wilaya_name_ascii: "Illizi"
    },
    {
        commune_name: "الحمادية",
        commune_name_ascii: "Elhammadia",
        daira_name: "الحمادية",
        daira_name_ascii: "El Hamadia",
        wilaya_code: 34,
        wilaya_name: "برج بوعريريج",
        wilaya_name_ascii: "Bordj Bou Arreridj"
    },
    {
        commune_name: "أولاد سيدي ابراهيم",
        commune_name_ascii: "Ouled Sidi-Brahim",
        daira_name: "المنصورة",
        daira_name_ascii: "Mansourah",
        wilaya_code: 34,
        wilaya_name: "برج بوعريريج",
        wilaya_name_ascii: "Bordj Bou Arreridj"
    },
    {
        commune_name: "عين تاغروت",
        commune_name_ascii: "Ain Taghrout",
        daira_name: "عين تاغروت",
        daira_name_ascii: "Ain Taghrout",
        wilaya_code: 34,
        wilaya_name: "برج بوعريريج",
        wilaya_name_ascii: "Bordj Bou Arreridj"
    },
    {
        commune_name: "تيكستار",
        commune_name_ascii: "Tixter",
        daira_name: "عين تاغروت",
        daira_name_ascii: "Ain Taghrout",
        wilaya_code: 34,
        wilaya_name: "برج بوعريريج",
        wilaya_name_ascii: "Bordj Bou Arreridj"
    },
    {
        commune_name: "بليمور",
        commune_name_ascii: "Belimour",
        daira_name: "برج الغدير",
        daira_name_ascii: "Bordj Ghedir",
        wilaya_code: 34,
        wilaya_name: "برج بوعريريج",
        wilaya_name_ascii: "Bordj Bou Arreridj"
    },
    {
        commune_name: "العناصر",
        commune_name_ascii: "El Annasseur",
        daira_name: "برج الغدير",
        daira_name_ascii: "Bordj Ghedir",
        wilaya_code: 34,
        wilaya_name: "برج بوعريريج",
        wilaya_name_ascii: "Bordj Bou Arreridj"
    },
    {
        commune_name: "غيلاسة",
        commune_name_ascii: "Ghailasa",
        daira_name: "برج الغدير",
        daira_name_ascii: "Bordj Ghedir",
        wilaya_code: 34,
        wilaya_name: "برج بوعريريج",
        wilaya_name_ascii: "Bordj Bou Arreridj"
    },
    {
        commune_name: "تقلعيت",
        commune_name_ascii: "Taglait",
        daira_name: "برج الغدير",
        daira_name_ascii: "Bordj Ghedir",
        wilaya_code: 34,
        wilaya_name: "برج بوعريريج",
        wilaya_name_ascii: "Bordj Bou Arreridj"
    },
    {
        commune_name: "برج الغدير",
        commune_name_ascii: "Bordj Ghedir",
        daira_name: "برج الغدير",
        daira_name_ascii: "Bordj Ghedir",
        wilaya_code: 34,
        wilaya_name: "برج بوعريريج",
        wilaya_name_ascii: "Bordj Bou Arreridj"
    },
    {
        commune_name: "العش",
        commune_name_ascii: "El Euch",
        daira_name: "الحمادية",
        daira_name_ascii: "El Hamadia",
        wilaya_code: 34,
        wilaya_name: "برج بوعريريج",
        wilaya_name_ascii: "Bordj Bou Arreridj"
    },
    {
        commune_name: "سيدي أمبارك",
        commune_name_ascii: "Sidi-Embarek",
        daira_name: "بئر قاصد علي",
        daira_name_ascii: "Bir Kasdali",
        wilaya_code: 34,
        wilaya_name: "برج بوعريريج",
        wilaya_name_ascii: "Bordj Bou Arreridj"
    },
    {
        commune_name: "خليل",
        commune_name_ascii: "Khelil",
        daira_name: "بئر قاصد علي",
        daira_name_ascii: "Bir Kasdali",
        wilaya_code: 34,
        wilaya_name: "برج بوعريريج",
        wilaya_name_ascii: "Bordj Bou Arreridj"
    },
    {
        commune_name: "بئر قاصد علي",
        commune_name_ascii: "Bir Kasdali",
        daira_name: "بئر قاصد علي",
        daira_name_ascii: "Bir Kasdali",
        wilaya_code: 34,
        wilaya_name: "برج بوعريريج",
        wilaya_name_ascii: "Bordj Bou Arreridj"
    },
    {
        commune_name: "تفرق",
        commune_name_ascii: "Tefreg",
        daira_name: "جعافرة",
        daira_name_ascii: "Djaafra",
        wilaya_code: 34,
        wilaya_name: "برج بوعريريج",
        wilaya_name_ascii: "Bordj Bou Arreridj"
    },
    {
        commune_name: "الماين",
        commune_name_ascii: "El Main",
        daira_name: "جعافرة",
        daira_name_ascii: "Djaafra",
        wilaya_code: 34,
        wilaya_name: "برج بوعريريج",
        wilaya_name_ascii: "Bordj Bou Arreridj"
    },
    {
        commune_name: "جعافرة",
        commune_name_ascii: "Djaafra",
        daira_name: "جعافرة",
        daira_name_ascii: "Djaafra",
        wilaya_code: 34,
        wilaya_name: "برج بوعريريج",
        wilaya_name_ascii: "Bordj Bou Arreridj"
    },
    {
        commune_name: "القلة",
        commune_name_ascii: "Colla",
        daira_name: "جعافرة",
        daira_name_ascii: "Djaafra",
        wilaya_code: 34,
        wilaya_name: "برج بوعريريج",
        wilaya_name_ascii: "Bordj Bou Arreridj"
    },
    {
        commune_name: "ثنية النصر",
        commune_name_ascii: "Teniet En Nasr",
        daira_name: "مجانة",
        daira_name_ascii: "Medjana",
        wilaya_code: 34,
        wilaya_name: "برج بوعريريج",
        wilaya_name_ascii: "Bordj Bou Arreridj"
    },
    {
        commune_name: "المهير",
        commune_name_ascii: "El M'hir",
        daira_name: "المنصورة",
        daira_name_ascii: "Mansourah",
        wilaya_code: 34,
        wilaya_name: "برج بوعريريج",
        wilaya_name_ascii: "Bordj Bou Arreridj"
    },
    {
        commune_name: "القصور",
        commune_name_ascii: "Ksour",
        daira_name: "الحمادية",
        daira_name_ascii: "El Hamadia",
        wilaya_code: 34,
        wilaya_name: "برج بوعريريج",
        wilaya_name_ascii: "Bordj Bou Arreridj"
    },
    {
        commune_name: "المنصورة",
        commune_name_ascii: "Mansoura",
        daira_name: "المنصورة",
        daira_name_ascii: "Mansourah",
        wilaya_code: 34,
        wilaya_name: "برج بوعريريج",
        wilaya_name_ascii: "Bordj Bou Arreridj"
    },
    {
        commune_name: "حرازة",
        commune_name_ascii: "Haraza",
        daira_name: "المنصورة",
        daira_name_ascii: "Mansourah",
        wilaya_code: 34,
        wilaya_name: "برج بوعريريج",
        wilaya_name_ascii: "Bordj Bou Arreridj"
    },
    {
        commune_name: "الرابطة",
        commune_name_ascii: "Rabta",
        daira_name: "الحمادية",
        daira_name_ascii: "El Hamadia",
        wilaya_code: 34,
        wilaya_name: "برج بوعريريج",
        wilaya_name_ascii: "Bordj Bou Arreridj"
    },
    {
        commune_name: "الياشير",
        commune_name_ascii: "El Achir",
        daira_name: "مجانة",
        daira_name_ascii: "Medjana",
        wilaya_code: 34,
        wilaya_name: "برج بوعريريج",
        wilaya_name_ascii: "Bordj Bou Arreridj"
    },
    {
        commune_name: "حسناوة",
        commune_name_ascii: "Hasnaoua",
        daira_name: "مجانة",
        daira_name_ascii: "Medjana",
        wilaya_code: 34,
        wilaya_name: "برج بوعريريج",
        wilaya_name_ascii: "Bordj Bou Arreridj"
    },
    {
        commune_name: "مجانة",
        commune_name_ascii: "Medjana",
        daira_name: "مجانة",
        daira_name_ascii: "Medjana",
        wilaya_code: 34,
        wilaya_name: "برج بوعريريج",
        wilaya_name_ascii: "Bordj Bou Arreridj"
    },
    {
        commune_name: "عين تسرة",
        commune_name_ascii: "Ain Tesra",
        daira_name: "رأس الوادي",
        daira_name_ascii: "Ras El Oued",
        wilaya_code: 34,
        wilaya_name: "برج بوعريريج",
        wilaya_name_ascii: "Bordj Bou Arreridj"
    },
    {
        commune_name: "أولاد أبراهم",
        commune_name_ascii: "Ouled Brahem",
        daira_name: "رأس الوادي",
        daira_name_ascii: "Ras El Oued",
        wilaya_code: 34,
        wilaya_name: "برج بوعريريج",
        wilaya_name_ascii: "Bordj Bou Arreridj"
    },
    {
        commune_name: "رأس الوادي",
        commune_name_ascii: "Ras El Oued",
        daira_name: "رأس الوادي",
        daira_name_ascii: "Ras El Oued",
        wilaya_code: 34,
        wilaya_name: "برج بوعريريج",
        wilaya_name_ascii: "Bordj Bou Arreridj"
    },
    {
        commune_name: "برج زمورة",
        commune_name_ascii: "Bordj Zemmoura",
        daira_name: "برج زمورة",
        daira_name_ascii: "Bordj Zemmoura",
        wilaya_code: 34,
        wilaya_name: "برج بوعريريج",
        wilaya_name_ascii: "Bordj Bou Arreridj"
    },
    {
        commune_name: "أولاد دحمان",
        commune_name_ascii: "Ouled Dahmane",
        daira_name: "برج زمورة",
        daira_name_ascii: "Bordj Zemmoura",
        wilaya_code: 34,
        wilaya_name: "برج بوعريريج",
        wilaya_name_ascii: "Bordj Bou Arreridj"
    },
    {
        commune_name: "تسامرت",
        commune_name_ascii: "Tassamert",
        daira_name: "برج زمورة",
        daira_name_ascii: "Bordj Zemmoura",
        wilaya_code: 34,
        wilaya_name: "برج بوعريريج",
        wilaya_name_ascii: "Bordj Bou Arreridj"
    },
    {
        commune_name: "برج بوعريرج",
        commune_name_ascii: "B. B. Arreridj",
        daira_name: "برج بوعريريج",
        daira_name_ascii: "Bordj Bou Arreridj",
        wilaya_code: 34,
        wilaya_name: "برج بوعريريج",
        wilaya_name_ascii: "Bordj Bou Arreridj"
    },
    {
        commune_name: "بن داود",
        commune_name_ascii: "Ben Daoud",
        daira_name: "المنصورة",
        daira_name_ascii: "Mansourah",
        wilaya_code: 34,
        wilaya_name: "برج بوعريريج",
        wilaya_name_ascii: "Bordj Bou Arreridj"
    },
    {
        commune_name: "الخروبة",
        commune_name_ascii: "El Kharrouba",
        daira_name: "بودواو",
        daira_name_ascii: "Boudouaou",
        wilaya_code: 35,
        wilaya_name: "بومرداس",
        wilaya_name_ascii: "Boumerdès"
    },
    {
        commune_name: "دلس",
        commune_name_ascii: "Dellys",
        daira_name: "دلس",
        daira_name_ascii: "Dellys",
        wilaya_code: 35,
        wilaya_name: "بومرداس",
        wilaya_name_ascii: "Boumerdès"
    },
    {
        commune_name: "بن شود",
        commune_name_ascii: "Ben Choud",
        daira_name: "دلس",
        daira_name_ascii: "Dellys",
        wilaya_code: 35,
        wilaya_name: "بومرداس",
        wilaya_name_ascii: "Boumerdès"
    },
    {
        commune_name: "أعفير",
        commune_name_ascii: "Afir",
        daira_name: "دلس",
        daira_name_ascii: "Dellys",
        wilaya_code: 35,
        wilaya_name: "بومرداس",
        wilaya_name_ascii: "Boumerdès"
    },
    {
        commune_name: "الثنية",
        commune_name_ascii: "Thenia",
        daira_name: "الثنية",
        daira_name_ascii: "Thenia",
        wilaya_code: 35,
        wilaya_name: "بومرداس",
        wilaya_name_ascii: "Boumerdès"
    },
    {
        commune_name: "بني عمران",
        commune_name_ascii: "Beni Amrane",
        daira_name: "الثنية",
        daira_name_ascii: "Thenia",
        wilaya_code: 35,
        wilaya_name: "بومرداس",
        wilaya_name_ascii: "Boumerdès"
    },
    {
        commune_name: "خميس الخشنة",
        commune_name_ascii: "Khemis El Khechna",
        daira_name: "خميس الخشنة",
        daira_name_ascii: "Khemis El Khechna",
        wilaya_code: 35,
        wilaya_name: "بومرداس",
        wilaya_name_ascii: "Boumerdès"
    },
    {
        commune_name: "عمال",
        commune_name_ascii: "Ammal",
        daira_name: "الثنية",
        daira_name_ascii: "Thenia",
        wilaya_code: 35,
        wilaya_name: "بومرداس",
        wilaya_name_ascii: "Boumerdès"
    },
    {
        commune_name: "تيمزريت",
        commune_name_ascii: "Timezrit",
        daira_name: "يسر",
        daira_name_ascii: "Isser",
        wilaya_code: 35,
        wilaya_name: "بومرداس",
        wilaya_name_ascii: "Boumerdès"
    },
    {
        commune_name: "زموري",
        commune_name_ascii: "Zemmouri",
        daira_name: "برج منايل",
        daira_name_ascii: "Bordj Menaiel",
        wilaya_code: 35,
        wilaya_name: "بومرداس",
        wilaya_name_ascii: "Boumerdès"
    },
    {
        commune_name: "الاربعطاش",
        commune_name_ascii: "Larbatache",
        daira_name: "خميس الخشنة",
        daira_name_ascii: "Khemis El Khechna",
        wilaya_code: 35,
        wilaya_name: "بومرداس",
        wilaya_name_ascii: "Boumerdès"
    },
    {
        commune_name: "يسر",
        commune_name_ascii: "Isser",
        daira_name: "يسر",
        daira_name_ascii: "Isser",
        wilaya_code: 35,
        wilaya_name: "بومرداس",
        wilaya_name_ascii: "Boumerdès"
    },
    {
        commune_name: "شعبة العامر",
        commune_name_ascii: "Chabet El Ameur",
        daira_name: "يسر",
        daira_name_ascii: "Isser",
        wilaya_code: 35,
        wilaya_name: "بومرداس",
        wilaya_name_ascii: "Boumerdès"
    },
    {
        commune_name: "أولاد عيسى",
        commune_name_ascii: "Ouled Aissa",
        daira_name: "الناصرية",
        daira_name_ascii: "Naciria",
        wilaya_code: 35,
        wilaya_name: "بومرداس",
        wilaya_name_ascii: "Boumerdès"
    },
    {
        commune_name: "الناصرية",
        commune_name_ascii: "Naciria",
        daira_name: "الناصرية",
        daira_name_ascii: "Naciria",
        wilaya_code: 35,
        wilaya_name: "بومرداس",
        wilaya_name_ascii: "Boumerdès"
    },
    {
        commune_name: "بوزقزة قدارة",
        commune_name_ascii: "Bouzegza Keddara",
        daira_name: "بودواو",
        daira_name_ascii: "Boudouaou",
        wilaya_code: 35,
        wilaya_name: "بومرداس",
        wilaya_name_ascii: "Boumerdès"
    },
    {
        commune_name: "سوق الحد",
        commune_name_ascii: "Souk El Had",
        daira_name: "الثنية",
        daira_name_ascii: "Thenia",
        wilaya_code: 35,
        wilaya_name: "بومرداس",
        wilaya_name_ascii: "Boumerdès"
    },
    {
        commune_name: "سيدي داود",
        commune_name_ascii: "Sidi Daoud",
        daira_name: "بغلية",
        daira_name_ascii: "Baghlia",
        wilaya_code: 35,
        wilaya_name: "بومرداس",
        wilaya_name_ascii: "Boumerdès"
    },
    {
        commune_name: "بغلية",
        commune_name_ascii: "Baghlia",
        daira_name: "بغلية",
        daira_name_ascii: "Baghlia",
        wilaya_code: 35,
        wilaya_name: "بومرداس",
        wilaya_name_ascii: "Boumerdès"
    },
    {
        commune_name: "لقاطة",
        commune_name_ascii: "Leghata",
        daira_name: "برج منايل",
        daira_name_ascii: "Bordj Menaiel",
        wilaya_code: 35,
        wilaya_name: "بومرداس",
        wilaya_name_ascii: "Boumerdès"
    },
    {
        commune_name: "جنات",
        commune_name_ascii: "Djinet",
        daira_name: "برج منايل",
        daira_name_ascii: "Bordj Menaiel",
        wilaya_code: 35,
        wilaya_name: "بومرداس",
        wilaya_name_ascii: "Boumerdès"
    },
    {
        commune_name: "تيجلابين",
        commune_name_ascii: "Tidjelabine",
        daira_name: "بومرداس",
        daira_name_ascii: "Boumerdes",
        wilaya_code: 35,
        wilaya_name: "بومرداس",
        wilaya_name_ascii: "Boumerdès"
    },
    {
        commune_name: "سي مصطفى",
        commune_name_ascii: "Si Mustapha",
        daira_name: "يسر",
        daira_name_ascii: "Isser",
        wilaya_code: 35,
        wilaya_name: "بومرداس",
        wilaya_name_ascii: "Boumerdès"
    },
    {
        commune_name: "أولاد هداج",
        commune_name_ascii: "Ouled Hedadj",
        daira_name: "بودواو",
        daira_name_ascii: "Boudouaou",
        wilaya_code: 35,
        wilaya_name: "بومرداس",
        wilaya_name_ascii: "Boumerdès"
    },
    {
        commune_name: "أولاد موسى",
        commune_name_ascii: "Ouled Moussa",
        daira_name: "خميس الخشنة",
        daira_name_ascii: "Khemis El Khechna",
        wilaya_code: 35,
        wilaya_name: "بومرداس",
        wilaya_name_ascii: "Boumerdès"
    },
    {
        commune_name: "بومرداس",
        commune_name_ascii: "Boumerdes",
        daira_name: "بومرداس",
        daira_name_ascii: "Boumerdes",
        wilaya_code: 35,
        wilaya_name: "بومرداس",
        wilaya_name_ascii: "Boumerdès"
    },
    {
        commune_name: "قورصو",
        commune_name_ascii: "Corso",
        daira_name: "بومرداس",
        daira_name_ascii: "Boumerdes",
        wilaya_code: 35,
        wilaya_name: "بومرداس",
        wilaya_name_ascii: "Boumerdès"
    },
    {
        commune_name: "برج منايل",
        commune_name_ascii: "Bordj Menaiel",
        daira_name: "برج منايل",
        daira_name_ascii: "Bordj Menaiel",
        wilaya_code: 35,
        wilaya_name: "بومرداس",
        wilaya_name_ascii: "Boumerdès"
    },
    {
        commune_name: "بودواو",
        commune_name_ascii: "Boudouaou",
        daira_name: "بودواو",
        daira_name_ascii: "Boudouaou",
        wilaya_code: 35,
        wilaya_name: "بومرداس",
        wilaya_name_ascii: "Boumerdès"
    },
    {
        commune_name: "بودواو البحري",
        commune_name_ascii: "Boudouaou El Bahri",
        daira_name: "بودواو",
        daira_name_ascii: "Boudouaou",
        wilaya_code: 35,
        wilaya_name: "بومرداس",
        wilaya_name_ascii: "Boumerdès"
    },
    {
        commune_name: "تاورقة",
        commune_name_ascii: "Taourga",
        daira_name: "بغلية",
        daira_name_ascii: "Baghlia",
        wilaya_code: 35,
        wilaya_name: "بومرداس",
        wilaya_name_ascii: "Boumerdès"
    },
    {
        commune_name: "حمادي",
        commune_name_ascii: "Hammedi",
        daira_name: "خميس الخشنة",
        daira_name_ascii: "Khemis El Khechna",
        wilaya_code: 35,
        wilaya_name: "بومرداس",
        wilaya_name_ascii: "Boumerdès"
    },
    {
        commune_name: "عين العسل",
        commune_name_ascii: "Ain El Assel",
        daira_name: "الطارف",
        daira_name_ascii: "El Tarf",
        wilaya_code: 36,
        wilaya_name: "الطارف",
        wilaya_name_ascii: "El Tarf"
    },
    {
        commune_name: "بوقوس",
        commune_name_ascii: "Bougous",
        daira_name: "الطارف",
        daira_name_ascii: "El Tarf",
        wilaya_code: 36,
        wilaya_name: "الطارف",
        wilaya_name_ascii: "El Tarf"
    },
    {
        commune_name: "الطارف",
        commune_name_ascii: "El Tarf",
        daira_name: "الطارف",
        daira_name_ascii: "El Tarf",
        wilaya_code: 36,
        wilaya_name: "الطارف",
        wilaya_name_ascii: "El Tarf"
    },
    {
        commune_name: "الزيتونة",
        commune_name_ascii: "Zitouna",
        daira_name: "الطارف",
        daira_name_ascii: "El Tarf",
        wilaya_code: 36,
        wilaya_name: "الطارف",
        wilaya_name_ascii: "El Tarf"
    },
    {
        commune_name: "البسباس",
        commune_name_ascii: "Besbes",
        daira_name: "البسباس",
        daira_name_ascii: "Besbes",
        wilaya_code: 36,
        wilaya_name: "الطارف",
        wilaya_name_ascii: "El Tarf"
    },
    {
        commune_name: "عين الكرمة",
        commune_name_ascii: "Ain Kerma",
        daira_name: "بوحجار",
        daira_name_ascii: "Bouhadjar",
        wilaya_code: 36,
        wilaya_name: "الطارف",
        wilaya_name_ascii: "El Tarf"
    },
    {
        commune_name: "بوحجار",
        commune_name_ascii: "Bouhadjar",
        daira_name: "بوحجار",
        daira_name_ascii: "Bouhadjar",
        wilaya_code: 36,
        wilaya_name: "الطارف",
        wilaya_name_ascii: "El Tarf"
    },
    {
        commune_name: "حمام بني صالح",
        commune_name_ascii: "Hammam Beni Salah",
        daira_name: "بوحجار",
        daira_name_ascii: "Bouhadjar",
        wilaya_code: 36,
        wilaya_name: "الطارف",
        wilaya_name_ascii: "El Tarf"
    },
    {
        commune_name: "وادي الزيتون",
        commune_name_ascii: "Oued Zitoun",
        daira_name: "بوحجار",
        daira_name_ascii: "Bouhadjar",
        wilaya_code: 36,
        wilaya_name: "الطارف",
        wilaya_name_ascii: "El Tarf"
    },
    {
        commune_name: "بن مهيدي",
        commune_name_ascii: "Ben M Hidi",
        daira_name: "بن مهيدي",
        daira_name_ascii: "Ben M'hidi",
        wilaya_code: 36,
        wilaya_name: "الطارف",
        wilaya_name_ascii: "El Tarf"
    },
    {
        commune_name: "بريحان",
        commune_name_ascii: "Berrihane",
        daira_name: "بن مهيدي",
        daira_name_ascii: "Ben M'hidi",
        wilaya_code: 36,
        wilaya_name: "الطارف",
        wilaya_name_ascii: "El Tarf"
    },
    {
        commune_name: "شبيطة مختار",
        commune_name_ascii: "Chebaita Mokhtar",
        daira_name: "الذرعان",
        daira_name_ascii: "Drean",
        wilaya_code: 36,
        wilaya_name: "الطارف",
        wilaya_name_ascii: "El Tarf"
    },
    {
        commune_name: "الشط",
        commune_name_ascii: "Echatt",
        daira_name: "بن مهيدي",
        daira_name_ascii: "Ben M'hidi",
        wilaya_code: 36,
        wilaya_name: "الطارف",
        wilaya_name_ascii: "El Tarf"
    },
    {
        commune_name: "العيون",
        commune_name_ascii: "El Aioun",
        daira_name: "القالة",
        daira_name_ascii: "El Kala",
        wilaya_code: 36,
        wilaya_name: "الطارف",
        wilaya_name_ascii: "El Tarf"
    },
    {
        commune_name: "القالة",
        commune_name_ascii: "El Kala",
        daira_name: "القالة",
        daira_name_ascii: "El Kala",
        wilaya_code: 36,
        wilaya_name: "الطارف",
        wilaya_name_ascii: "El Tarf"
    },
    {
        commune_name: "السوارخ",
        commune_name_ascii: "Souarekh",
        daira_name: "القالة",
        daira_name_ascii: "El Kala",
        wilaya_code: 36,
        wilaya_name: "الطارف",
        wilaya_name_ascii: "El Tarf"
    },
    {
        commune_name: "زريزر",
        commune_name_ascii: "Zerizer",
        daira_name: "البسباس",
        daira_name_ascii: "Besbes",
        wilaya_code: 36,
        wilaya_name: "الطارف",
        wilaya_name_ascii: "El Tarf"
    },
    {
        commune_name: "بوثلجة",
        commune_name_ascii: "Bouteldja",
        daira_name: "بوثلجة",
        daira_name_ascii: "Bouteldja",
        wilaya_code: 36,
        wilaya_name: "الطارف",
        wilaya_name_ascii: "El Tarf"
    },
    {
        commune_name: "الشافية",
        commune_name_ascii: "Chefia",
        daira_name: "بوثلجة",
        daira_name_ascii: "Bouteldja",
        wilaya_code: 36,
        wilaya_name: "الطارف",
        wilaya_name_ascii: "El Tarf"
    },
    {
        commune_name: "بحيرة الطيور",
        commune_name_ascii: "Lac Des Oiseaux",
        daira_name: "بوثلجة",
        daira_name_ascii: "Bouteldja",
        wilaya_code: 36,
        wilaya_name: "الطارف",
        wilaya_name_ascii: "El Tarf"
    },
    {
        commune_name: "شحاني",
        commune_name_ascii: "Chihani",
        daira_name: "الذرعان",
        daira_name_ascii: "Drean",
        wilaya_code: 36,
        wilaya_name: "الطارف",
        wilaya_name_ascii: "El Tarf"
    },
    {
        commune_name: "رمل السوق",
        commune_name_ascii: "Raml Souk",
        daira_name: "القالة",
        daira_name_ascii: "El Kala",
        wilaya_code: 36,
        wilaya_name: "الطارف",
        wilaya_name_ascii: "El Tarf"
    },
    {
        commune_name: "عصفور",
        commune_name_ascii: "Asfour",
        daira_name: "البسباس",
        daira_name_ascii: "Besbes",
        wilaya_code: 36,
        wilaya_name: "الطارف",
        wilaya_name_ascii: "El Tarf"
    },
    {
        commune_name: "الذرعـان",
        commune_name_ascii: "Drean",
        daira_name: "الذرعان",
        daira_name_ascii: "Drean",
        wilaya_code: 36,
        wilaya_name: "الطارف",
        wilaya_name_ascii: "El Tarf"
    },
    {
        commune_name: "تندوف",
        commune_name_ascii: "Tindouf",
        daira_name: "تندوف",
        daira_name_ascii: "Tindouf",
        wilaya_code: 37,
        wilaya_name: "تندوف",
        wilaya_name_ascii: "Tindouf"
    },
    {
        commune_name: "أم العسل",
        commune_name_ascii: "Oum El Assel",
        daira_name: "تندوف",
        daira_name_ascii: "Tindouf",
        wilaya_code: 37,
        wilaya_name: "تندوف",
        wilaya_name_ascii: "Tindouf"
    },
    {
        commune_name: "خميستي",
        commune_name_ascii: "Khemisti",
        daira_name: "خميستي",
        daira_name_ascii: "Khemisti",
        wilaya_code: 38,
        wilaya_name: "تيسمسيلت",
        wilaya_name_ascii: "Tissemsilt"
    },
    {
        commune_name: "ثنية الاحد",
        commune_name_ascii: "Theniet El Had",
        daira_name: "ثنية الاحد",
        daira_name_ascii: "Theniet El Had",
        wilaya_code: 38,
        wilaya_name: "تيسمسيلت",
        wilaya_name_ascii: "Tissemsilt"
    },
    {
        commune_name: "أولاد بسام",
        commune_name_ascii: "Ouled Bessam",
        daira_name: "تيسمسيلت",
        daira_name_ascii: "Tissemsilt",
        wilaya_code: 38,
        wilaya_name: "تيسمسيلت",
        wilaya_name_ascii: "Tissemsilt"
    },
    {
        commune_name: "سيدي بوتوشنت",
        commune_name_ascii: "Sidi Boutouchent",
        daira_name: "ثنية الاحد",
        daira_name_ascii: "Theniet El Had",
        wilaya_code: 38,
        wilaya_name: "تيسمسيلت",
        wilaya_name_ascii: "Tissemsilt"
    },
    {
        commune_name: "تيسمسيلت",
        commune_name_ascii: "Tissemsilt",
        daira_name: "تيسمسيلت",
        daira_name_ascii: "Tissemsilt",
        wilaya_code: 38,
        wilaya_name: "تيسمسيلت",
        wilaya_name_ascii: "Tissemsilt"
    },
    {
        commune_name: "سيدي العنتري",
        commune_name_ascii: "Sidi Lantri",
        daira_name: "لرجام",
        daira_name_ascii: "Lardjem",
        wilaya_code: 38,
        wilaya_name: "تيسمسيلت",
        wilaya_name_ascii: "Tissemsilt"
    },
    {
        commune_name: "بني شعيب",
        commune_name_ascii: "Beni Chaib",
        daira_name: "برج بونعامة",
        daira_name_ascii: "Bordj Bounaama",
        wilaya_code: 38,
        wilaya_name: "تيسمسيلت",
        wilaya_name_ascii: "Tissemsilt"
    },
    {
        commune_name: "بني لحسن",
        commune_name_ascii: "Beni Lahcene",
        daira_name: "برج بونعامة",
        daira_name_ascii: "Bordj Bounaama",
        wilaya_code: 38,
        wilaya_name: "تيسمسيلت",
        wilaya_name_ascii: "Tissemsilt"
    },
    {
        commune_name: "سيدي عابد",
        commune_name_ascii: "Sidi Abed",
        daira_name: "عماري",
        daira_name_ascii: "Ammari",
        wilaya_code: 38,
        wilaya_name: "تيسمسيلت",
        wilaya_name_ascii: "Tissemsilt"
    },
    {
        commune_name: "سيدي سليمان",
        commune_name_ascii: "Sidi Slimane",
        daira_name: "برج بونعامة",
        daira_name_ascii: "Bordj Bounaama",
        wilaya_code: 38,
        wilaya_name: "تيسمسيلت",
        wilaya_name_ascii: "Tissemsilt"
    },
    {
        commune_name: "بوقائد",
        commune_name_ascii: "Boucaid",
        daira_name: "الأزهرية",
        daira_name_ascii: "Lazharia",
        wilaya_code: 38,
        wilaya_name: "تيسمسيلت",
        wilaya_name_ascii: "Tissemsilt"
    },
    {
        commune_name: "الأربعاء",
        commune_name_ascii: "Larbaa",
        daira_name: "الأزهرية",
        daira_name_ascii: "Lazharia",
        wilaya_code: 38,
        wilaya_name: "تيسمسيلت",
        wilaya_name_ascii: "Tissemsilt"
    },
    {
        commune_name: "الأزهرية",
        commune_name_ascii: "Lazharia",
        daira_name: "الأزهرية",
        daira_name_ascii: "Lazharia",
        wilaya_code: 38,
        wilaya_name: "تيسمسيلت",
        wilaya_name_ascii: "Tissemsilt"
    },
    {
        commune_name: "لرجام",
        commune_name_ascii: "Lardjem",
        daira_name: "لرجام",
        daira_name_ascii: "Lardjem",
        wilaya_code: 38,
        wilaya_name: "تيسمسيلت",
        wilaya_name_ascii: "Tissemsilt"
    },
    {
        commune_name: "الملعب",
        commune_name_ascii: "Melaab",
        daira_name: "لرجام",
        daira_name_ascii: "Lardjem",
        wilaya_code: 38,
        wilaya_name: "تيسمسيلت",
        wilaya_name_ascii: "Tissemsilt"
    },
    {
        commune_name: "العيون",
        commune_name_ascii: "Layoune",
        daira_name: "خميستي",
        daira_name_ascii: "Khemisti",
        wilaya_code: 38,
        wilaya_name: "تيسمسيلت",
        wilaya_name_ascii: "Tissemsilt"
    },
    {
        commune_name: "تملاحت",
        commune_name_ascii: "Tamellahet",
        daira_name: "لرجام",
        daira_name_ascii: "Lardjem",
        wilaya_code: 38,
        wilaya_name: "تيسمسيلت",
        wilaya_name_ascii: "Tissemsilt"
    },
    {
        commune_name: "اليوسفية",
        commune_name_ascii: "Youssoufia",
        daira_name: "برج الأمير عبد القادر",
        daira_name_ascii: "Bordj Emir Abdelkader",
        wilaya_code: 38,
        wilaya_name: "تيسمسيلت",
        wilaya_name_ascii: "Tissemsilt"
    },
    {
        commune_name: "برج الأمير عبد القادر",
        commune_name_ascii: "Bordj El Emir Abdelkader",
        daira_name: "برج الأمير عبد القادر",
        daira_name_ascii: "Bordj Emir Abdelkader",
        wilaya_code: 38,
        wilaya_name: "تيسمسيلت",
        wilaya_name_ascii: "Tissemsilt"
    },
    {
        commune_name: "عماري",
        commune_name_ascii: "Ammari",
        daira_name: "عماري",
        daira_name_ascii: "Ammari",
        wilaya_code: 38,
        wilaya_name: "تيسمسيلت",
        wilaya_name_ascii: "Tissemsilt"
    },
    {
        commune_name: "المعاصم",
        commune_name_ascii: "Maacem",
        daira_name: "عماري",
        daira_name_ascii: "Ammari",
        wilaya_code: 38,
        wilaya_name: "تيسمسيلت",
        wilaya_name_ascii: "Tissemsilt"
    },
    {
        commune_name: "برج بونعامة",
        commune_name_ascii: "Bordj Bounaama",
        daira_name: "برج بونعامة",
        daira_name_ascii: "Bordj Bounaama",
        wilaya_code: 38,
        wilaya_name: "تيسمسيلت",
        wilaya_name_ascii: "Tissemsilt"
    },
    {
        commune_name: "دوار الماء",
        commune_name_ascii: "Douar El Maa",
        daira_name: "الطالب العربي",
        daira_name_ascii: "Taleb Larbi",
        wilaya_code: 39,
        wilaya_name: "الوادي",
        wilaya_name_ascii: "El Oued"
    },
    {
        commune_name: "العقلة",
        commune_name_ascii: "El Ogla",
        daira_name: "الرباح",
        daira_name_ascii: "Robbah",
        wilaya_code: 39,
        wilaya_name: "الوادي",
        wilaya_name_ascii: "El Oued"
    },
    {
        commune_name: "المقرن",
        commune_name_ascii: "Magrane",
        daira_name: "المقرن",
        daira_name_ascii: "Magrane",
        wilaya_code: 39,
        wilaya_name: "الوادي",
        wilaya_name_ascii: "El Oued"
    },
    {
        commune_name: "سيدي عون",
        commune_name_ascii: "Sidi Aoun",
        daira_name: "المقرن",
        daira_name_ascii: "Magrane",
        wilaya_code: 39,
        wilaya_name: "الوادي",
        wilaya_name_ascii: "El Oued"
    },
    {
        commune_name: "اميه وانسة",
        commune_name_ascii: "Mih Ouansa",
        daira_name: "اميه وانسة",
        daira_name_ascii: "Mih Ouensa",
        wilaya_code: 39,
        wilaya_name: "الوادي",
        wilaya_name_ascii: "El Oued"
    },
    {
        commune_name: "كوينين",
        commune_name_ascii: "Kouinine",
        daira_name: "الوادي",
        daira_name_ascii: "El Oued",
        wilaya_code: 39,
        wilaya_name: "الوادي",
        wilaya_name_ascii: "El Oued"
    },
    {
        commune_name: "البياضة",
        commune_name_ascii: "Bayadha",
        daira_name: "البياضة",
        daira_name_ascii: "Bayadha",
        wilaya_code: 39,
        wilaya_name: "الوادي",
        wilaya_name_ascii: "El Oued"
    },
    {
        commune_name: "النخلة",
        commune_name_ascii: "Nakhla",
        daira_name: "الرباح",
        daira_name_ascii: "Robbah",
        wilaya_code: 39,
        wilaya_name: "الوادي",
        wilaya_name_ascii: "El Oued"
    },
    {
        commune_name: "الرباح",
        commune_name_ascii: "Robbah",
        daira_name: "الرباح",
        daira_name_ascii: "Robbah",
        wilaya_code: 39,
        wilaya_name: "الوادي",
        wilaya_name_ascii: "El Oued"
    },
    {
        commune_name: "قمار",
        commune_name_ascii: "Guemar",
        daira_name: "قمار",
        daira_name_ascii: "Guemar",
        wilaya_code: 39,
        wilaya_name: "الوادي",
        wilaya_name_ascii: "El Oued"
    },
    {
        commune_name: "بن  قشة",
        commune_name_ascii: "Ben Guecha",
        daira_name: "الطالب العربي",
        daira_name_ascii: "Taleb Larbi",
        wilaya_code: 39,
        wilaya_name: "الوادي",
        wilaya_name_ascii: "El Oued"
    },
    {
        commune_name: "ورماس",
        commune_name_ascii: "Ourmes",
        daira_name: "قمار",
        daira_name_ascii: "Guemar",
        wilaya_code: 39,
        wilaya_name: "الوادي",
        wilaya_name_ascii: "El Oued"
    },
    {
        commune_name: "تغزوت",
        commune_name_ascii: "Taghzout",
        daira_name: "قمار",
        daira_name_ascii: "Guemar",
        wilaya_code: 39,
        wilaya_name: "الوادي",
        wilaya_name_ascii: "El Oued"
    },
    {
        commune_name: "الحمراية",
        commune_name_ascii: "Hamraia",
        daira_name: "الرقيبة",
        daira_name_ascii: "Reguiba",
        wilaya_code: 39,
        wilaya_name: "الوادي",
        wilaya_name_ascii: "El Oued"
    },
    {
        commune_name: "الرقيبة",
        commune_name_ascii: "Reguiba",
        daira_name: "الرقيبة",
        daira_name_ascii: "Reguiba",
        wilaya_code: 39,
        wilaya_name: "الوادي",
        wilaya_name_ascii: "El Oued"
    },
    {
        commune_name: "الدبيلة",
        commune_name_ascii: "Debila",
        daira_name: "الدبيلة",
        daira_name_ascii: "Debila",
        wilaya_code: 39,
        wilaya_name: "الوادي",
        wilaya_name_ascii: "El Oued"
    },
    {
        commune_name: "حساني عبد الكريم",
        commune_name_ascii: "Hassani Abdelkrim",
        daira_name: "الدبيلة",
        daira_name_ascii: "Debila",
        wilaya_code: 39,
        wilaya_name: "الوادي",
        wilaya_name_ascii: "El Oued"
    },
    {
        commune_name: "حاسي خليفة",
        commune_name_ascii: "Hassi Khalifa",
        daira_name: "حاسي خليفة",
        daira_name_ascii: "Hassi Khalifa",
        wilaya_code: 39,
        wilaya_name: "الوادي",
        wilaya_name_ascii: "El Oued"
    },
    {
        commune_name: "الطريفاوي",
        commune_name_ascii: "Trifaoui",
        daira_name: "حاسي خليفة",
        daira_name_ascii: "Hassi Khalifa",
        wilaya_code: 39,
        wilaya_name: "الوادي",
        wilaya_name_ascii: "El Oued"
    },
    {
        commune_name: "الطالب العربي",
        commune_name_ascii: "Taleb Larbi",
        daira_name: "الطالب العربي",
        daira_name_ascii: "Taleb Larbi",
        wilaya_code: 39,
        wilaya_name: "الوادي",
        wilaya_name_ascii: "El Oued"
    },
    {
        commune_name: "وادي العلندة",
        commune_name_ascii: "Oued El Alenda",
        daira_name: "اميه وانسة",
        daira_name_ascii: "Mih Ouensa",
        wilaya_code: 39,
        wilaya_name: "الوادي",
        wilaya_name_ascii: "El Oued"
    },
    {
        commune_name: "الوادي",
        commune_name_ascii: "El-Oued",
        daira_name: "الوادي",
        daira_name_ascii: "El Oued",
        wilaya_code: 39,
        wilaya_name: "الوادي",
        wilaya_name_ascii: "El Oued"
    },
    {
        commune_name: "خيران",
        commune_name_ascii: "Khirane",
        daira_name: "ششار",
        daira_name_ascii: "Chechar",
        wilaya_code: 40,
        wilaya_name: "خنشلة",
        wilaya_name_ascii: "Khenchela"
    },
    {
        commune_name: "بابار",
        commune_name_ascii: "Babar",
        daira_name: "بابار",
        daira_name_ascii: "Babar",
        wilaya_code: 40,
        wilaya_name: "خنشلة",
        wilaya_name_ascii: "Khenchela"
    },
    {
        commune_name: "المحمل",
        commune_name_ascii: "El Mahmal",
        daira_name: "أولاد رشاش",
        daira_name_ascii: "Ouled Rechache",
        wilaya_code: 40,
        wilaya_name: "خنشلة",
        wilaya_name_ascii: "Khenchela"
    },
    {
        commune_name: "أولاد رشاش",
        commune_name_ascii: "Ouled Rechache",
        daira_name: "أولاد رشاش",
        daira_name_ascii: "Ouled Rechache",
        wilaya_code: 40,
        wilaya_name: "خنشلة",
        wilaya_name_ascii: "Khenchela"
    },
    {
        commune_name: "جلال",
        commune_name_ascii: "Djellal",
        daira_name: "ششار",
        daira_name_ascii: "Chechar",
        wilaya_code: 40,
        wilaya_name: "خنشلة",
        wilaya_name_ascii: "Khenchela"
    },
    {
        commune_name: "يابوس",
        commune_name_ascii: "Yabous",
        daira_name: "بوحمامة",
        daira_name_ascii: "Bouhmama",
        wilaya_code: 40,
        wilaya_name: "خنشلة",
        wilaya_name_ascii: "Khenchela"
    },
    {
        commune_name: "خنشلة",
        commune_name_ascii: "Khenchela",
        daira_name: "خنشلة",
        daira_name_ascii: "Khenchela",
        wilaya_code: 40,
        wilaya_name: "خنشلة",
        wilaya_name_ascii: "Khenchela"
    },
    {
        commune_name: "قايس",
        commune_name_ascii: "Kais",
        daira_name: "قايس",
        daira_name_ascii: "Kais",
        wilaya_code: 40,
        wilaya_name: "خنشلة",
        wilaya_name_ascii: "Khenchela"
    },
    {
        commune_name: "شلية",
        commune_name_ascii: "Chelia",
        daira_name: "بوحمامة",
        daira_name_ascii: "Bouhmama",
        wilaya_code: 40,
        wilaya_name: "خنشلة",
        wilaya_name_ascii: "Khenchela"
    },
    {
        commune_name: "الرميلة",
        commune_name_ascii: "Remila",
        daira_name: "قايس",
        daira_name_ascii: "Kais",
        wilaya_code: 40,
        wilaya_name: "خنشلة",
        wilaya_name_ascii: "Khenchela"
    },
    {
        commune_name: "تاوزيانت",
        commune_name_ascii: "Taouzianat",
        daira_name: "قايس",
        daira_name_ascii: "Kais",
        wilaya_code: 40,
        wilaya_name: "خنشلة",
        wilaya_name_ascii: "Khenchela"
    },
    {
        commune_name: "بغاي",
        commune_name_ascii: "Baghai",
        daira_name: "الحامة",
        daira_name_ascii: "El Hamma",
        wilaya_code: 40,
        wilaya_name: "خنشلة",
        wilaya_name_ascii: "Khenchela"
    },
    {
        commune_name: "الحامة",
        commune_name_ascii: "El Hamma",
        daira_name: "الحامة",
        daira_name_ascii: "El Hamma",
        wilaya_code: 40,
        wilaya_name: "خنشلة",
        wilaya_name_ascii: "Khenchela"
    },
    {
        commune_name: "انسيغة",
        commune_name_ascii: "Ensigha",
        daira_name: "الحامة",
        daira_name_ascii: "El Hamma",
        wilaya_code: 40,
        wilaya_name: "خنشلة",
        wilaya_name_ascii: "Khenchela"
    },
    {
        commune_name: "طامزة",
        commune_name_ascii: "Tamza",
        daira_name: "الحامة",
        daira_name_ascii: "El Hamma",
        wilaya_code: 40,
        wilaya_name: "خنشلة",
        wilaya_name_ascii: "Khenchela"
    },
    {
        commune_name: "عين الطويلة",
        commune_name_ascii: "Ain Touila",
        daira_name: "عين الطويلة",
        daira_name_ascii: "Ain Touila",
        wilaya_code: 40,
        wilaya_name: "خنشلة",
        wilaya_name_ascii: "Khenchela"
    },
    {
        commune_name: "متوسة",
        commune_name_ascii: "M'toussa",
        daira_name: "عين الطويلة",
        daira_name_ascii: "Ain Touila",
        wilaya_code: 40,
        wilaya_name: "خنشلة",
        wilaya_name_ascii: "Khenchela"
    },
    {
        commune_name: "بوحمامة",
        commune_name_ascii: "Bouhmama",
        daira_name: "بوحمامة",
        daira_name_ascii: "Bouhmama",
        wilaya_code: 40,
        wilaya_name: "خنشلة",
        wilaya_name_ascii: "Khenchela"
    },
    {
        commune_name: "الولجة",
        commune_name_ascii: "El Oueldja",
        daira_name: "ششار",
        daira_name_ascii: "Chechar",
        wilaya_code: 40,
        wilaya_name: "خنشلة",
        wilaya_name_ascii: "Khenchela"
    },
    {
        commune_name: "مصارة",
        commune_name_ascii: "M'sara",
        daira_name: "بوحمامة",
        daira_name_ascii: "Bouhmama",
        wilaya_code: 40,
        wilaya_name: "خنشلة",
        wilaya_name_ascii: "Khenchela"
    },
    {
        commune_name: "ششار",
        commune_name_ascii: "Chechar",
        daira_name: "ششار",
        daira_name_ascii: "Chechar",
        wilaya_code: 40,
        wilaya_name: "خنشلة",
        wilaya_name_ascii: "Khenchela"
    },
    {
        commune_name: "سوق أهراس",
        commune_name_ascii: "Souk Ahras",
        daira_name: "سوق أهراس",
        daira_name_ascii: "Souk Ahras",
        wilaya_code: 41,
        wilaya_name: "سوق أهراس",
        wilaya_name_ascii: "Souk Ahras"
    },
    {
        commune_name: "عين سلطان",
        commune_name_ascii: "Ain Soltane",
        daira_name: "سدراتة",
        daira_name_ascii: "Sedrata",
        wilaya_code: 41,
        wilaya_name: "سوق أهراس",
        wilaya_name_ascii: "Souk Ahras"
    },
    {
        commune_name: "سدراتة",
        commune_name_ascii: "Sedrata",
        daira_name: "سدراتة",
        daira_name_ascii: "Sedrata",
        wilaya_code: 41,
        wilaya_name: "سوق أهراس",
        wilaya_name_ascii: "Souk Ahras"
    },
    {
        commune_name: "الحنانشة",
        commune_name_ascii: "Hanencha",
        daira_name: "المشروحة",
        daira_name_ascii: "Mechroha",
        wilaya_code: 41,
        wilaya_name: "سوق أهراس",
        wilaya_name_ascii: "Souk Ahras"
    },
    {
        commune_name: "المشروحة",
        commune_name_ascii: "Machroha",
        daira_name: "المشروحة",
        daira_name_ascii: "Mechroha",
        wilaya_code: 41,
        wilaya_name: "سوق أهراس",
        wilaya_name_ascii: "Souk Ahras"
    },
    {
        commune_name: "عين الزانة",
        commune_name_ascii: "Ain Zana",
        daira_name: "أولاد إدريس",
        daira_name_ascii: "Ouled Driss",
        wilaya_code: 41,
        wilaya_name: "سوق أهراس",
        wilaya_name_ascii: "Souk Ahras"
    },
    {
        commune_name: "أولاد إدريس",
        commune_name_ascii: "Ouled Driss",
        daira_name: "أولاد إدريس",
        daira_name_ascii: "Ouled Driss",
        wilaya_code: 41,
        wilaya_name: "سوق أهراس",
        wilaya_name_ascii: "Souk Ahras"
    },
    {
        commune_name: "ترقالت",
        commune_name_ascii: "Terraguelt",
        daira_name: "أم العظايم",
        daira_name_ascii: "Oum El Adhaim",
        wilaya_code: 41,
        wilaya_name: "سوق أهراس",
        wilaya_name_ascii: "Souk Ahras"
    },
    {
        commune_name: "أم العظايم",
        commune_name_ascii: "Oum El Adhaim",
        daira_name: "أم العظايم",
        daira_name_ascii: "Oum El Adhaim",
        wilaya_code: 41,
        wilaya_name: "سوق أهراس",
        wilaya_name_ascii: "Souk Ahras"
    },
    {
        commune_name: "وادي الكبريت",
        commune_name_ascii: "Oued Kebrit",
        daira_name: "أم العظايم",
        daira_name_ascii: "Oum El Adhaim",
        wilaya_code: 41,
        wilaya_name: "سوق أهراس",
        wilaya_name_ascii: "Souk Ahras"
    },
    {
        commune_name: "تيفاش",
        commune_name_ascii: "Tiffech",
        daira_name: "مداوروش",
        daira_name_ascii: "M'daourouche",
        wilaya_code: 41,
        wilaya_name: "سوق أهراس",
        wilaya_name_ascii: "Souk Ahras"
    },
    {
        commune_name: "الراقوبة",
        commune_name_ascii: "Ragouba",
        daira_name: "مداوروش",
        daira_name_ascii: "M'daourouche",
        wilaya_code: 41,
        wilaya_name: "سوق أهراس",
        wilaya_name_ascii: "Souk Ahras"
    },
    {
        commune_name: "الدريعة",
        commune_name_ascii: "Drea",
        daira_name: "تاورة",
        daira_name_ascii: "Taoura",
        wilaya_code: 41,
        wilaya_name: "سوق أهراس",
        wilaya_name_ascii: "Souk Ahras"
    },
    {
        commune_name: "تاورة",
        commune_name_ascii: "Taoura",
        daira_name: "تاورة",
        daira_name_ascii: "Taoura",
        wilaya_code: 41,
        wilaya_name: "سوق أهراس",
        wilaya_name_ascii: "Souk Ahras"
    },
    {
        commune_name: "الزعرورية",
        commune_name_ascii: "Zaarouria",
        daira_name: "تاورة",
        daira_name_ascii: "Taoura",
        wilaya_code: 41,
        wilaya_name: "سوق أهراس",
        wilaya_name_ascii: "Souk Ahras"
    },
    {
        commune_name: "الحدادة",
        commune_name_ascii: "Haddada",
        daira_name: "الحدادة",
        daira_name_ascii: "Haddada",
        wilaya_code: 41,
        wilaya_name: "سوق أهراس",
        wilaya_name_ascii: "Souk Ahras"
    },
    {
        commune_name: "الخضارة",
        commune_name_ascii: "Khedara",
        daira_name: "الحدادة",
        daira_name_ascii: "Haddada",
        wilaya_code: 41,
        wilaya_name: "سوق أهراس",
        wilaya_name_ascii: "Souk Ahras"
    },
    {
        commune_name: "أولاد مومن",
        commune_name_ascii: "Ouled Moumen",
        daira_name: "الحدادة",
        daira_name_ascii: "Haddada",
        wilaya_code: 41,
        wilaya_name: "سوق أهراس",
        wilaya_name_ascii: "Souk Ahras"
    },
    {
        commune_name: "المراهنة",
        commune_name_ascii: "Merahna",
        daira_name: "المراهنة",
        daira_name_ascii: "Merahna",
        wilaya_code: 41,
        wilaya_name: "سوق أهراس",
        wilaya_name_ascii: "Souk Ahras"
    },
    {
        commune_name: "ويلان",
        commune_name_ascii: "Ouillen",
        daira_name: "المراهنة",
        daira_name_ascii: "Merahna",
        wilaya_code: 41,
        wilaya_name: "سوق أهراس",
        wilaya_name_ascii: "Souk Ahras"
    },
    {
        commune_name: "سيدي فرج",
        commune_name_ascii: "Sidi Fredj",
        daira_name: "المراهنة",
        daira_name_ascii: "Merahna",
        wilaya_code: 41,
        wilaya_name: "سوق أهراس",
        wilaya_name_ascii: "Souk Ahras"
    },
    {
        commune_name: "بئر بوحوش",
        commune_name_ascii: "Bir Bouhouche",
        daira_name: "بئر بوحوش",
        daira_name_ascii: "Bir Bouhouche",
        wilaya_code: 41,
        wilaya_name: "سوق أهراس",
        wilaya_name_ascii: "Souk Ahras"
    },
    {
        commune_name: "سافل الويدان",
        commune_name_ascii: "Safel El Ouiden",
        daira_name: "بئر بوحوش",
        daira_name_ascii: "Bir Bouhouche",
        wilaya_code: 41,
        wilaya_name: "سوق أهراس",
        wilaya_name_ascii: "Souk Ahras"
    },
    {
        commune_name: "خميسة",
        commune_name_ascii: "Khemissa",
        daira_name: "سدراتة",
        daira_name_ascii: "Sedrata",
        wilaya_code: 41,
        wilaya_name: "سوق أهراس",
        wilaya_name_ascii: "Souk Ahras"
    },
    {
        commune_name: "مداوروش",
        commune_name_ascii: "M'daourouche",
        daira_name: "مداوروش",
        daira_name_ascii: "M'daourouche",
        wilaya_code: 41,
        wilaya_name: "سوق أهراس",
        wilaya_name_ascii: "Souk Ahras"
    },
    {
        commune_name: "الزوابي",
        commune_name_ascii: "Zouabi",
        daira_name: "بئر بوحوش",
        daira_name_ascii: "Bir Bouhouche",
        wilaya_code: 41,
        wilaya_name: "سوق أهراس",
        wilaya_name_ascii: "Souk Ahras"
    },
    {
        commune_name: "حجوط",
        commune_name_ascii: "Hadjout",
        daira_name: "حجوط",
        daira_name_ascii: "Hadjout",
        wilaya_code: 42,
        wilaya_name: "تيبازة",
        wilaya_name_ascii: "Tipaza"
    },
    {
        commune_name: "مراد",
        commune_name_ascii: "Merad",
        daira_name: "حجوط",
        daira_name_ascii: "Hadjout",
        wilaya_code: 42,
        wilaya_name: "تيبازة",
        wilaya_name_ascii: "Tipaza"
    },
    {
        commune_name: "مناصر",
        commune_name_ascii: "Menaceur",
        daira_name: "سيدي أعمر",
        daira_name_ascii: "Sidi Amar",
        wilaya_code: 42,
        wilaya_name: "تيبازة",
        wilaya_name_ascii: "Tipaza"
    },
    {
        commune_name: "أغبال",
        commune_name_ascii: "Aghbal",
        daira_name: "قوراية",
        daira_name_ascii: "Gouraya",
        wilaya_code: 42,
        wilaya_name: "تيبازة",
        wilaya_name_ascii: "Tipaza"
    },
    {
        commune_name: "الناظور",
        commune_name_ascii: "Nador",
        daira_name: "سيدي أعمر",
        daira_name_ascii: "Sidi Amar",
        wilaya_code: 42,
        wilaya_name: "تيبازة",
        wilaya_name_ascii: "Tipaza"
    },
    {
        commune_name: "سيدي عامر",
        commune_name_ascii: "Sidi-Amar",
        daira_name: "سيدي أعمر",
        daira_name_ascii: "Sidi Amar",
        wilaya_code: 42,
        wilaya_name: "تيبازة",
        wilaya_name_ascii: "Tipaza"
    },
    {
        commune_name: "قوراية",
        commune_name_ascii: "Gouraya",
        daira_name: "قوراية",
        daira_name_ascii: "Gouraya",
        wilaya_code: 42,
        wilaya_name: "تيبازة",
        wilaya_name_ascii: "Tipaza"
    },
    {
        commune_name: "مسلمون",
        commune_name_ascii: "Messelmoun",
        daira_name: "قوراية",
        daira_name_ascii: "Gouraya",
        wilaya_code: 42,
        wilaya_name: "تيبازة",
        wilaya_name_ascii: "Tipaza"
    },
    {
        commune_name: "شرشال",
        commune_name_ascii: "Cherchell",
        daira_name: "شرشال",
        daira_name_ascii: "Cherchell",
        wilaya_code: 42,
        wilaya_name: "تيبازة",
        wilaya_name_ascii: "Tipaza"
    },
    {
        commune_name: "حجرة النص",
        commune_name_ascii: "Hadjret Ennous",
        daira_name: "شرشال",
        daira_name_ascii: "Cherchell",
        wilaya_code: 42,
        wilaya_name: "تيبازة",
        wilaya_name_ascii: "Tipaza"
    },
    {
        commune_name: "سيدي غيلاس",
        commune_name_ascii: "Sidi Ghiles",
        daira_name: "شرشال",
        daira_name_ascii: "Cherchell",
        wilaya_code: 42,
        wilaya_name: "تيبازة",
        wilaya_name_ascii: "Tipaza"
    },
    {
        commune_name: "الداموس",
        commune_name_ascii: "Damous",
        daira_name: "الداموس",
        daira_name_ascii: "Damous",
        wilaya_code: 42,
        wilaya_name: "تيبازة",
        wilaya_name_ascii: "Tipaza"
    },
    {
        commune_name: "الأرهاط",
        commune_name_ascii: "Larhat",
        daira_name: "الداموس",
        daira_name_ascii: "Damous",
        wilaya_code: 42,
        wilaya_name: "تيبازة",
        wilaya_name_ascii: "Tipaza"
    },
    {
        commune_name: "فوكة",
        commune_name_ascii: "Fouka",
        daira_name: "فوكة",
        daira_name_ascii: "Fouka",
        wilaya_code: 42,
        wilaya_name: "تيبازة",
        wilaya_name_ascii: "Tipaza"
    },
    {
        commune_name: "عين تاقورايت",
        commune_name_ascii: "Ain Tagourait",
        daira_name: "بواسماعيل",
        daira_name_ascii: "Bou Ismail",
        wilaya_code: 42,
        wilaya_name: "تيبازة",
        wilaya_name_ascii: "Tipaza"
    },
    {
        commune_name: "بوهارون",
        commune_name_ascii: "Bou Haroun",
        daira_name: "بواسماعيل",
        daira_name_ascii: "Bou Ismail",
        wilaya_code: 42,
        wilaya_name: "تيبازة",
        wilaya_name_ascii: "Tipaza"
    },
    {
        commune_name: "بواسماعيل",
        commune_name_ascii: "Bou Ismail",
        daira_name: "بواسماعيل",
        daira_name_ascii: "Bou Ismail",
        wilaya_code: 42,
        wilaya_name: "تيبازة",
        wilaya_name_ascii: "Tipaza"
    },
    {
        commune_name: "خميستي",
        commune_name_ascii: "Khemisti",
        daira_name: "بواسماعيل",
        daira_name_ascii: "Bou Ismail",
        wilaya_code: 42,
        wilaya_name: "تيبازة",
        wilaya_name_ascii: "Tipaza"
    },
    {
        commune_name: "أحمر العين",
        commune_name_ascii: "Ahmer El Ain",
        daira_name: "أحمر العين",
        daira_name_ascii: "Ahmar El Ain",
        wilaya_code: 42,
        wilaya_name: "تيبازة",
        wilaya_name_ascii: "Tipaza"
    },
    {
        commune_name: "بورقيقة",
        commune_name_ascii: "Bourkika",
        daira_name: "أحمر العين",
        daira_name_ascii: "Ahmar El Ain",
        wilaya_code: 42,
        wilaya_name: "تيبازة",
        wilaya_name_ascii: "Tipaza"
    },
    {
        commune_name: "دواودة",
        commune_name_ascii: "Douaouda",
        daira_name: "فوكة",
        daira_name_ascii: "Fouka",
        wilaya_code: 42,
        wilaya_name: "تيبازة",
        wilaya_name_ascii: "Tipaza"
    },
    {
        commune_name: "سيدي راشد",
        commune_name_ascii: "Sidi Rached",
        daira_name: "أحمر العين",
        daira_name_ascii: "Ahmar El Ain",
        wilaya_code: 42,
        wilaya_name: "تيبازة",
        wilaya_name_ascii: "Tipaza"
    },
    {
        commune_name: "الحطاطبة",
        commune_name_ascii: "Attatba",
        daira_name: "القليعة",
        daira_name_ascii: "Kolea",
        wilaya_code: 42,
        wilaya_name: "تيبازة",
        wilaya_name_ascii: "Tipaza"
    },
    {
        commune_name: "الشعيبة",
        commune_name_ascii: "Chaiba",
        daira_name: "القليعة",
        daira_name_ascii: "Kolea",
        wilaya_code: 42,
        wilaya_name: "تيبازة",
        wilaya_name_ascii: "Tipaza"
    },
    {
        commune_name: "القليعة",
        commune_name_ascii: "Kolea",
        daira_name: "القليعة",
        daira_name_ascii: "Kolea",
        wilaya_code: 42,
        wilaya_name: "تيبازة",
        wilaya_name_ascii: "Tipaza"
    },
    {
        commune_name: "سيدي سميان",
        commune_name_ascii: "Sidi Semiane",
        daira_name: "شرشال",
        daira_name_ascii: "Cherchell",
        wilaya_code: 42,
        wilaya_name: "تيبازة",
        wilaya_name_ascii: "Tipaza"
    },
    {
        commune_name: "تيبازة",
        commune_name_ascii: "Tipaza",
        daira_name: "تيبازة",
        daira_name_ascii: "Tipaza",
        wilaya_code: 42,
        wilaya_name: "تيبازة",
        wilaya_name_ascii: "Tipaza"
    },
    {
        commune_name: "بني ميلك",
        commune_name_ascii: "Beni Mileuk",
        daira_name: "الداموس",
        daira_name_ascii: "Damous",
        wilaya_code: 42,
        wilaya_name: "تيبازة",
        wilaya_name_ascii: "Tipaza"
    },
    {
        commune_name: "مشيرة",
        commune_name_ascii: "El Mechira",
        daira_name: "التلاغمة",
        daira_name_ascii: "Teleghma",
        wilaya_code: 43,
        wilaya_name: "ميلة",
        wilaya_name_ascii: "Mila"
    },
    {
        commune_name: "العياضي برباس",
        commune_name_ascii: "El Ayadi Barbes",
        daira_name: "عين البيضاء أحريش",
        daira_name_ascii: "Ain Beida Harriche",
        wilaya_code: 43,
        wilaya_name: "ميلة",
        wilaya_name_ascii: "Mila"
    },
    {
        commune_name: " عين البيضاء أحريش",
        commune_name_ascii: "Ain Beida Harriche",
        daira_name: "عين البيضاء أحريش",
        daira_name_ascii: "Ain Beida Harriche",
        wilaya_code: 43,
        wilaya_name: "ميلة",
        wilaya_name_ascii: "Mila"
    },
    {
        commune_name: "تسالة لمطاعي",
        commune_name_ascii: "Tassala Lematai",
        daira_name: "ترعي باينان",
        daira_name_ascii: "Terrai Bainen",
        wilaya_code: 43,
        wilaya_name: "ميلة",
        wilaya_name_ascii: "Mila"
    },
    {
        commune_name: "ترعي باينان",
        commune_name_ascii: "Terrai Bainen",
        daira_name: "ترعي باينان",
        daira_name_ascii: "Terrai Bainen",
        wilaya_code: 43,
        wilaya_name: "ميلة",
        wilaya_name_ascii: "Mila"
    },
    {
        commune_name: "اعميرة اراس",
        commune_name_ascii: "Amira Arres",
        daira_name: "ترعي باينان",
        daira_name_ascii: "Terrai Bainen",
        wilaya_code: 43,
        wilaya_name: "ميلة",
        wilaya_name_ascii: "Mila"
    },
    {
        commune_name: "تسدان حدادة",
        commune_name_ascii: "Tassadane Haddada",
        daira_name: "تسدان حدادة",
        daira_name_ascii: "Tassadane Haddada",
        wilaya_code: 43,
        wilaya_name: "ميلة",
        wilaya_name_ascii: "Mila"
    },
    {
        commune_name: "مينار زارزة",
        commune_name_ascii: "Minar Zarza",
        daira_name: "تسدان حدادة",
        daira_name_ascii: "Tassadane Haddada",
        wilaya_code: 43,
        wilaya_name: "ميلة",
        wilaya_name_ascii: "Mila"
    },
    {
        commune_name: "سيدي مروان",
        commune_name_ascii: "Sidi Merouane",
        daira_name: "سيدي مروان",
        daira_name_ascii: "Sidi Merouane",
        wilaya_code: 43,
        wilaya_name: "ميلة",
        wilaya_name_ascii: "Mila"
    },
    {
        commune_name: "الشيقارة",
        commune_name_ascii: "Chigara",
        daira_name: "سيدي مروان",
        daira_name_ascii: "Sidi Merouane",
        wilaya_code: 43,
        wilaya_name: "ميلة",
        wilaya_name_ascii: "Mila"
    },
    {
        commune_name: "حمالة",
        commune_name_ascii: "Hamala",
        daira_name: "القرارم قوقة",
        daira_name_ascii: "Grarem Gouga",
        wilaya_code: 43,
        wilaya_name: "ميلة",
        wilaya_name_ascii: "Mila"
    },
    {
        commune_name: "القرارم قوقة",
        commune_name_ascii: "Grarem Gouga",
        daira_name: "القرارم قوقة",
        daira_name_ascii: "Grarem Gouga",
        wilaya_code: 43,
        wilaya_name: "ميلة",
        wilaya_name_ascii: "Mila"
    },
    {
        commune_name: "تيبرقنت",
        commune_name_ascii: "Tiberguent",
        daira_name: "الرواشد",
        daira_name_ascii: "Rouached",
        wilaya_code: 43,
        wilaya_name: "ميلة",
        wilaya_name_ascii: "Mila"
    },
    {
        commune_name: "الرواشد",
        commune_name_ascii: "Rouached",
        daira_name: "الرواشد",
        daira_name_ascii: "Rouached",
        wilaya_code: 43,
        wilaya_name: "ميلة",
        wilaya_name_ascii: "Mila"
    },
    {
        commune_name: "دراحي بوصلاح",
        commune_name_ascii: "Derrahi Bousselah",
        daira_name: "بوحاتم",
        daira_name_ascii: "Bouhatem",
        wilaya_code: 43,
        wilaya_name: "ميلة",
        wilaya_name_ascii: "Mila"
    },
    {
        commune_name: "زغاية",
        commune_name_ascii: "Zeghaia",
        daira_name: "وادي النجاء",
        daira_name_ascii: "Oued Endja",
        wilaya_code: 43,
        wilaya_name: "ميلة",
        wilaya_name_ascii: "Mila"
    },
    {
        commune_name: "وادي النجاء",
        commune_name_ascii: "Oued Endja",
        daira_name: "وادي النجاء",
        daira_name_ascii: "Oued Endja",
        wilaya_code: 43,
        wilaya_name: "ميلة",
        wilaya_name_ascii: "Mila"
    },
    {
        commune_name: "أحمد راشدي",
        commune_name_ascii: "Ahmed Rachedi",
        daira_name: "وادي النجاء",
        daira_name_ascii: "Oued Endja",
        wilaya_code: 43,
        wilaya_name: "ميلة",
        wilaya_name_ascii: "Mila"
    },
    {
        commune_name: "تاجنانت",
        commune_name_ascii: "Tadjenanet",
        daira_name: "تاجنانت",
        daira_name_ascii: "Tadjenanet",
        wilaya_code: 43,
        wilaya_name: "ميلة",
        wilaya_name_ascii: "Mila"
    },
    {
        commune_name: "عين الملوك",
        commune_name_ascii: "Ain Mellouk",
        daira_name: "شلغوم العيد",
        daira_name_ascii: "Chelghoum Laid",
        wilaya_code: 43,
        wilaya_name: "ميلة",
        wilaya_name_ascii: "Mila"
    },
    {
        commune_name: "أولاد اخلوف",
        commune_name_ascii: "Ouled Khalouf",
        daira_name: "تاجنانت",
        daira_name_ascii: "Tadjenanet",
        wilaya_code: 43,
        wilaya_name: "ميلة",
        wilaya_name_ascii: "Mila"
    },
    {
        commune_name: "بن يحي عبد الرحمن",
        commune_name_ascii: "Benyahia Abderrahmane",
        daira_name: "تاجنانت",
        daira_name_ascii: "Tadjenanet",
        wilaya_code: 43,
        wilaya_name: "ميلة",
        wilaya_name_ascii: "Mila"
    },
    {
        commune_name: "التلاغمة",
        commune_name_ascii: "Teleghma",
        daira_name: "التلاغمة",
        daira_name_ascii: "Teleghma",
        wilaya_code: 43,
        wilaya_name: "ميلة",
        wilaya_name_ascii: "Mila"
    },
    {
        commune_name: "وادي سقان",
        commune_name_ascii: "Oued Seguen",
        daira_name: "التلاغمة",
        daira_name_ascii: "Teleghma",
        wilaya_code: 43,
        wilaya_name: "ميلة",
        wilaya_name_ascii: "Mila"
    },
    {
        commune_name: "وادي العثمانية",
        commune_name_ascii: "Oued Athmenia",
        daira_name: "شلغوم العيد",
        daira_name_ascii: "Chelghoum Laid",
        wilaya_code: 43,
        wilaya_name: "ميلة",
        wilaya_name_ascii: "Mila"
    },
    {
        commune_name: "عين التين",
        commune_name_ascii: "Ain Tine",
        daira_name: "ميلة",
        daira_name_ascii: "Mila",
        wilaya_code: 43,
        wilaya_name: "ميلة",
        wilaya_name_ascii: "Mila"
    },
    {
        commune_name: "شلغوم العيد",
        commune_name_ascii: "Chelghoum Laid",
        daira_name: "شلغوم العيد",
        daira_name_ascii: "Chelghoum Laid",
        wilaya_code: 43,
        wilaya_name: "ميلة",
        wilaya_name_ascii: "Mila"
    },
    {
        commune_name: "يحي بني قشة",
        commune_name_ascii: "Yahia Beniguecha",
        daira_name: "فرجيوة",
        daira_name_ascii: "Ferdjioua",
        wilaya_code: 43,
        wilaya_name: "ميلة",
        wilaya_name_ascii: "Mila"
    },
    {
        commune_name: "فرجيوة",
        commune_name_ascii: "Ferdjioua",
        daira_name: "فرجيوة",
        daira_name_ascii: "Ferdjioua",
        wilaya_code: 43,
        wilaya_name: "ميلة",
        wilaya_name_ascii: "Mila"
    },
    {
        commune_name: "سيدي خليفة",
        commune_name_ascii: "Sidi Khelifa",
        daira_name: "ميلة",
        daira_name_ascii: "Mila",
        wilaya_code: 43,
        wilaya_name: "ميلة",
        wilaya_name_ascii: "Mila"
    },
    {
        commune_name: "ميلة",
        commune_name_ascii: "Mila",
        daira_name: "ميلة",
        daira_name_ascii: "Mila",
        wilaya_code: 43,
        wilaya_name: "ميلة",
        wilaya_name_ascii: "Mila"
    },
    {
        commune_name: "بوحاتم",
        commune_name_ascii: "Bouhatem",
        daira_name: "بوحاتم",
        daira_name_ascii: "Bouhatem",
        wilaya_code: 43,
        wilaya_name: "ميلة",
        wilaya_name_ascii: "Mila"
    },
    {
        commune_name: "خميس مليانة",
        commune_name_ascii: "Khemis-Miliana",
        daira_name: "خميس",
        daira_name_ascii: "Khemis",
        wilaya_code: 44,
        wilaya_name: "عين الدفلة",
        wilaya_name_ascii: "Aïn Defla"
    },
    {
        commune_name: "سيدي الأخضر",
        commune_name_ascii: "Sidi-Lakhdar",
        daira_name: "خميس",
        daira_name_ascii: "Khemis",
        wilaya_code: 44,
        wilaya_name: "عين الدفلة",
        wilaya_name_ascii: "Aïn Defla"
    },
    {
        commune_name: "عين البنيان",
        commune_name_ascii: "Ain-Benian",
        daira_name: "حمام ريغة",
        daira_name_ascii: "Hammam Righa",
        wilaya_code: 44,
        wilaya_name: "عين الدفلة",
        wilaya_name_ascii: "Aïn Defla"
    },
    {
        commune_name: "عين التركي",
        commune_name_ascii: "Ain-Torki",
        daira_name: "حمام ريغة",
        daira_name_ascii: "Hammam Righa",
        wilaya_code: 44,
        wilaya_name: "عين الدفلة",
        wilaya_name_ascii: "Aïn Defla"
    },
    {
        commune_name: "حمام ريغة",
        commune_name_ascii: "Hammam-Righa",
        daira_name: "حمام ريغة",
        daira_name_ascii: "Hammam Righa",
        wilaya_code: 44,
        wilaya_name: "عين الدفلة",
        wilaya_name_ascii: "Aïn Defla"
    },
    {
        commune_name: "بوراشد",
        commune_name_ascii: "Bourached",
        daira_name: "جليدة",
        daira_name_ascii: "Djelida",
        wilaya_code: 44,
        wilaya_name: "عين الدفلة",
        wilaya_name_ascii: "Aïn Defla"
    },
    {
        commune_name: "الحسينية",
        commune_name_ascii: "Hoceinia",
        daira_name: "بومدفع",
        daira_name_ascii: "Boumedfaa",
        wilaya_code: 44,
        wilaya_name: "عين الدفلة",
        wilaya_name_ascii: "Aïn Defla"
    },
    {
        commune_name: "جليدة",
        commune_name_ascii: "Djelida",
        daira_name: "جليدة",
        daira_name_ascii: "Djelida",
        wilaya_code: 44,
        wilaya_name: "عين الدفلة",
        wilaya_name_ascii: "Aïn Defla"
    },
    {
        commune_name: "عريب",
        commune_name_ascii: "Arib",
        daira_name: "العامرة",
        daira_name_ascii: "El Amra",
        wilaya_code: 44,
        wilaya_name: "عين الدفلة",
        wilaya_name_ascii: "Aïn Defla"
    },
    {
        commune_name: "جمعة أولاد الشيخ",
        commune_name_ascii: "Djemaa Ouled Cheikh",
        daira_name: "جليدة",
        daira_name_ascii: "Djelida",
        wilaya_code: 44,
        wilaya_name: "عين الدفلة",
        wilaya_name_ascii: "Aïn Defla"
    },
    {
        commune_name: "العامرة",
        commune_name_ascii: "El-Amra",
        daira_name: "العامرة",
        daira_name_ascii: "El Amra",
        wilaya_code: 44,
        wilaya_name: "عين الدفلة",
        wilaya_name_ascii: "Aïn Defla"
    },
    {
        commune_name: "العطاف",
        commune_name_ascii: "El-Attaf",
        daira_name: "العطاف",
        daira_name_ascii: "El Attaf",
        wilaya_code: 44,
        wilaya_name: "عين الدفلة",
        wilaya_name_ascii: "Aïn Defla"
    },
    {
        commune_name: "تبركانين",
        commune_name_ascii: "Tiberkanine",
        daira_name: "العطاف",
        daira_name_ascii: "El Attaf",
        wilaya_code: 44,
        wilaya_name: "عين الدفلة",
        wilaya_name_ascii: "Aïn Defla"
    },
    {
        commune_name: "عين بويحيى",
        commune_name_ascii: "Ain-Bouyahia",
        daira_name: "العبادية",
        daira_name_ascii: "El Abadia",
        wilaya_code: 44,
        wilaya_name: "عين الدفلة",
        wilaya_name_ascii: "Aïn Defla"
    },
    {
        commune_name: "العبادية",
        commune_name_ascii: "El-Abadia",
        daira_name: "العبادية",
        daira_name_ascii: "El Abadia",
        wilaya_code: 44,
        wilaya_name: "عين الدفلة",
        wilaya_name_ascii: "Aïn Defla"
    },
    {
        commune_name: "تاشتة زقاغة",
        commune_name_ascii: "Tacheta Zegagha",
        daira_name: "العبادية",
        daira_name_ascii: "El Abadia",
        wilaya_code: 44,
        wilaya_name: "عين الدفلة",
        wilaya_name_ascii: "Aïn Defla"
    },
    {
        commune_name: "بربوش",
        commune_name_ascii: "Birbouche",
        daira_name: "جندل",
        daira_name_ascii: "Djendel",
        wilaya_code: 44,
        wilaya_name: "عين الدفلة",
        wilaya_name_ascii: "Aïn Defla"
    },
    {
        commune_name: "جندل",
        commune_name_ascii: "Djendel",
        daira_name: "جندل",
        daira_name_ascii: "Djendel",
        wilaya_code: 44,
        wilaya_name: "عين الدفلة",
        wilaya_name_ascii: "Aïn Defla"
    },
    {
        commune_name: "بن علال",
        commune_name_ascii: "Ben Allal",
        daira_name: "مليانة",
        daira_name_ascii: "Miliana",
        wilaya_code: 44,
        wilaya_name: "عين الدفلة",
        wilaya_name_ascii: "Aïn Defla"
    },
    {
        commune_name: "وادي الشرفاء",
        commune_name_ascii: "Oued Chorfa",
        daira_name: "جندل",
        daira_name_ascii: "Djendel",
        wilaya_code: 44,
        wilaya_name: "عين الدفلة",
        wilaya_name_ascii: "Aïn Defla"
    },
    {
        commune_name: "بومدفع",
        commune_name_ascii: "Boumedfaa",
        daira_name: "بومدفع",
        daira_name_ascii: "Boumedfaa",
        wilaya_code: 44,
        wilaya_name: "عين الدفلة",
        wilaya_name_ascii: "Aïn Defla"
    },
    {
        commune_name: "عين الاشياخ",
        commune_name_ascii: "Ain-Lechiakh",
        daira_name: "عين الاشياخ",
        daira_name_ascii: "Ain Lechiakh",
        wilaya_code: 44,
        wilaya_name: "عين الدفلة",
        wilaya_name_ascii: "Aïn Defla"
    },
    {
        commune_name: "عين السلطان",
        commune_name_ascii: "Ain-Soltane",
        daira_name: "عين الاشياخ",
        daira_name_ascii: "Ain Lechiakh",
        wilaya_code: 44,
        wilaya_name: "عين الدفلة",
        wilaya_name_ascii: "Aïn Defla"
    },
    {
        commune_name: "واد الجمعة",
        commune_name_ascii: "Oued Djemaa",
        daira_name: "عين الاشياخ",
        daira_name_ascii: "Ain Lechiakh",
        wilaya_code: 44,
        wilaya_name: "عين الدفلة",
        wilaya_name_ascii: "Aïn Defla"
    },
    {
        commune_name: "الماين",
        commune_name_ascii: "El-Maine",
        daira_name: "الروينة",
        daira_name_ascii: "Rouina",
        wilaya_code: 44,
        wilaya_name: "عين الدفلة",
        wilaya_name_ascii: "Aïn Defla"
    },
    {
        commune_name: "الروينة",
        commune_name_ascii: "Rouina",
        daira_name: "الروينة",
        daira_name_ascii: "Rouina",
        wilaya_code: 44,
        wilaya_name: "عين الدفلة",
        wilaya_name_ascii: "Aïn Defla"
    },
    {
        commune_name: "زدين",
        commune_name_ascii: "Zeddine",
        daira_name: "الروينة",
        daira_name_ascii: "Rouina",
        wilaya_code: 44,
        wilaya_name: "عين الدفلة",
        wilaya_name_ascii: "Aïn Defla"
    },
    {
        commune_name: "بئر ولد خليفة",
        commune_name_ascii: "Bir-Ould-Khelifa",
        daira_name: "برج الأمير خالد",
        daira_name_ascii: "Bordj El Emir Khaled",
        wilaya_code: 44,
        wilaya_name: "عين الدفلة",
        wilaya_name_ascii: "Aïn Defla"
    },
    {
        commune_name: "برج الأمير خالد",
        commune_name_ascii: "Bordj-Emir-Khaled",
        daira_name: "برج الأمير خالد",
        daira_name_ascii: "Bordj El Emir Khaled",
        wilaya_code: 44,
        wilaya_name: "عين الدفلة",
        wilaya_name_ascii: "Aïn Defla"
    },
    {
        commune_name: "طارق بن زياد",
        commune_name_ascii: "Tarik-Ibn-Ziad",
        daira_name: "برج الأمير خالد",
        daira_name_ascii: "Bordj El Emir Khaled",
        wilaya_code: 44,
        wilaya_name: "عين الدفلة",
        wilaya_name_ascii: "Aïn Defla"
    },
    {
        commune_name: "بطحية",
        commune_name_ascii: "Bathia",
        daira_name: "بطحية",
        daira_name_ascii: "Bathia",
        wilaya_code: 44,
        wilaya_name: "عين الدفلة",
        wilaya_name_ascii: "Aïn Defla"
    },
    {
        commune_name: "بلعاص",
        commune_name_ascii: "Belaas",
        daira_name: "بطحية",
        daira_name_ascii: "Bathia",
        wilaya_code: 44,
        wilaya_name: "عين الدفلة",
        wilaya_name_ascii: "Aïn Defla"
    },
    {
        commune_name: "الحسانية",
        commune_name_ascii: "Hassania",
        daira_name: "بطحية",
        daira_name_ascii: "Bathia",
        wilaya_code: 44,
        wilaya_name: "عين الدفلة",
        wilaya_name_ascii: "Aïn Defla"
    },
    {
        commune_name: "عين الدفلى",
        commune_name_ascii: "Ain-Defla",
        daira_name: "عين الدفلى",
        daira_name_ascii: "Ain Defla",
        wilaya_code: 44,
        wilaya_name: "عين الدفلة",
        wilaya_name_ascii: "Aïn Defla"
    },
    {
        commune_name: "مليانة",
        commune_name_ascii: "Miliana",
        daira_name: "مليانة",
        daira_name_ascii: "Miliana",
        wilaya_code: 44,
        wilaya_name: "عين الدفلة",
        wilaya_name_ascii: "Aïn Defla"
    },
    {
        commune_name: "المخاطرية",
        commune_name_ascii: "Mekhatria",
        daira_name: "العامرة",
        daira_name_ascii: "El Amra",
        wilaya_code: 44,
        wilaya_name: "عين الدفلة",
        wilaya_name_ascii: "Aïn Defla"
    },
    {
        commune_name: "تيوت",
        commune_name_ascii: "Tiout",
        daira_name: "عين الصفراء",
        daira_name_ascii: "Ain Sefra",
        wilaya_code: 45,
        wilaya_name: "النعامة",
        wilaya_name_ascii: "Naâma"
    },
    {
        commune_name: "مغرار",
        commune_name_ascii: "Moghrar",
        daira_name: "مغرار",
        daira_name_ascii: "Moghrar",
        wilaya_code: 45,
        wilaya_name: "النعامة",
        wilaya_name_ascii: "Naâma"
    },
    {
        commune_name: "عسلة",
        commune_name_ascii: "Asla",
        daira_name: "عسلة",
        daira_name_ascii: "Asla",
        wilaya_code: 45,
        wilaya_name: "النعامة",
        wilaya_name_ascii: "Naâma"
    },
    {
        commune_name: "القصدير",
        commune_name_ascii: "Kasdir",
        daira_name: "مكمن بن عمار",
        daira_name_ascii: "Mekmen Ben Amar",
        wilaya_code: 45,
        wilaya_name: "النعامة",
        wilaya_name_ascii: "Naâma"
    },
    {
        commune_name: "مكمن بن عمار",
        commune_name_ascii: "Makmen Ben Amar",
        daira_name: "مكمن بن عمار",
        daira_name_ascii: "Mekmen Ben Amar",
        wilaya_code: 45,
        wilaya_name: "النعامة",
        wilaya_name_ascii: "Naâma"
    },
    {
        commune_name: "عين الصفراء",
        commune_name_ascii: "Ain Sefra",
        daira_name: "عين الصفراء",
        daira_name_ascii: "Ain Sefra",
        wilaya_code: 45,
        wilaya_name: "النعامة",
        wilaya_name_ascii: "Naâma"
    },
    {
        commune_name: "المشرية",
        commune_name_ascii: "Mecheria",
        daira_name: "المشرية",
        daira_name_ascii: "Mecheria",
        wilaya_code: 45,
        wilaya_name: "النعامة",
        wilaya_name_ascii: "Naâma"
    },
    {
        commune_name: "البيوض",
        commune_name_ascii: "El Biodh",
        daira_name: "المشرية",
        daira_name_ascii: "Mecheria",
        wilaya_code: 45,
        wilaya_name: "النعامة",
        wilaya_name_ascii: "Naâma"
    },
    {
        commune_name: "عين بن خليل",
        commune_name_ascii: "Ain Ben Khelil",
        daira_name: "المشرية",
        daira_name_ascii: "Mecheria",
        wilaya_code: 45,
        wilaya_name: "النعامة",
        wilaya_name_ascii: "Naâma"
    },
    {
        commune_name: "النعامة",
        commune_name_ascii: "Naama",
        daira_name: "النعامة",
        daira_name_ascii: "Naama",
        wilaya_code: 45,
        wilaya_name: "النعامة",
        wilaya_name_ascii: "Naâma"
    },
    {
        commune_name: "جنين بورزق",
        commune_name_ascii: "Djenienne Bourezg",
        daira_name: "مغرار",
        daira_name_ascii: "Moghrar",
        wilaya_code: 45,
        wilaya_name: "النعامة",
        wilaya_name_ascii: "Naâma"
    },
    {
        commune_name: "سفيسيفة",
        commune_name_ascii: "Sfissifa",
        daira_name: "سفيسيفة",
        daira_name_ascii: "Sfissifa",
        wilaya_code: 45,
        wilaya_name: "النعامة",
        wilaya_name_ascii: "Naâma"
    },
    {
        commune_name: "سيدي بومدين",
        commune_name_ascii: "Sidi Boumediene",
        daira_name: "عين الأربعاء",
        daira_name_ascii: "Ain Larbaa",
        wilaya_code: 46,
        wilaya_name: "عين تيموشنت",
        wilaya_name_ascii: "Aïn Témouchent"
    },
    {
        commune_name: "تامزورة",
        commune_name_ascii: "Tamzoura",
        daira_name: "عين الأربعاء",
        daira_name_ascii: "Ain Larbaa",
        wilaya_code: 46,
        wilaya_name: "عين تيموشنت",
        wilaya_name_ascii: "Aïn Témouchent"
    },
    {
        commune_name: "شعبة اللحم",
        commune_name_ascii: "Chaabat El Ham",
        daira_name: "المالح",
        daira_name_ascii: "El Maleh",
        wilaya_code: 46,
        wilaya_name: "عين تيموشنت",
        wilaya_name_ascii: "Aïn Témouchent"
    },
    {
        commune_name: "المالح",
        commune_name_ascii: "El Maleh",
        daira_name: "المالح",
        daira_name_ascii: "El Maleh",
        wilaya_code: 46,
        wilaya_name: "عين تيموشنت",
        wilaya_name_ascii: "Aïn Témouchent"
    },
    {
        commune_name: "أولاد الكيحل",
        commune_name_ascii: "Ouled Kihal",
        daira_name: "المالح",
        daira_name_ascii: "El Maleh",
        wilaya_code: 46,
        wilaya_name: "عين تيموشنت",
        wilaya_name_ascii: "Aïn Témouchent"
    },
    {
        commune_name: "شنتوف",
        commune_name_ascii: "Chentouf",
        daira_name: "حمام بوحجر",
        daira_name_ascii: "Hammam Bou Hadjar",
        wilaya_code: 46,
        wilaya_name: "عين تيموشنت",
        wilaya_name_ascii: "Aïn Témouchent"
    },
    {
        commune_name: "تارقة",
        commune_name_ascii: "Terga",
        daira_name: "المالح",
        daira_name_ascii: "El Maleh",
        wilaya_code: 46,
        wilaya_name: "عين تيموشنت",
        wilaya_name_ascii: "Aïn Témouchent"
    },
    {
        commune_name: "وادي الصباح",
        commune_name_ascii: "Oued Sebbah",
        daira_name: "عين الأربعاء",
        daira_name_ascii: "Ain Larbaa",
        wilaya_code: 46,
        wilaya_name: "عين تيموشنت",
        wilaya_name_ascii: "Aïn Témouchent"
    },
    {
        commune_name: "العامرية",
        commune_name_ascii: "El Amria",
        daira_name: "العامرية",
        daira_name_ascii: "El Amria",
        wilaya_code: 46,
        wilaya_name: "عين تيموشنت",
        wilaya_name_ascii: "Aïn Témouchent"
    },
    {
        commune_name: "حاسي الغلة",
        commune_name_ascii: "Hassi El Ghella",
        daira_name: "العامرية",
        daira_name_ascii: "El Amria",
        wilaya_code: 46,
        wilaya_name: "عين تيموشنت",
        wilaya_name_ascii: "Aïn Témouchent"
    },
    {
        commune_name: "أولاد بوجمعة",
        commune_name_ascii: "Ouled Boudjemaa",
        daira_name: "العامرية",
        daira_name_ascii: "El Amria",
        wilaya_code: 46,
        wilaya_name: "عين تيموشنت",
        wilaya_name_ascii: "Aïn Témouchent"
    },
    {
        commune_name: "أغلال",
        commune_name_ascii: "Aghlal",
        daira_name: "عين الكيحل",
        daira_name_ascii: "Ain Kihel",
        wilaya_code: 46,
        wilaya_name: "عين تيموشنت",
        wilaya_name_ascii: "Aïn Témouchent"
    },
    {
        commune_name: "عين الكيحل",
        commune_name_ascii: "Ain Kihal",
        daira_name: "عين الكيحل",
        daira_name_ascii: "Ain Kihel",
        wilaya_code: 46,
        wilaya_name: "عين تيموشنت",
        wilaya_name_ascii: "Aïn Témouchent"
    },
    {
        commune_name: "عين الطلبة",
        commune_name_ascii: "Ain Tolba",
        daira_name: "عين الكيحل",
        daira_name_ascii: "Ain Kihel",
        wilaya_code: 46,
        wilaya_name: "عين تيموشنت",
        wilaya_name_ascii: "Aïn Témouchent"
    },
    {
        commune_name: "عقب الليل",
        commune_name_ascii: "Aoubellil",
        daira_name: "عين الكيحل",
        daira_name_ascii: "Ain Kihel",
        wilaya_code: 46,
        wilaya_name: "عين تيموشنت",
        wilaya_name_ascii: "Aïn Témouchent"
    },
    {
        commune_name: "بني صاف",
        commune_name_ascii: "Beni Saf",
        daira_name: "بني صاف",
        daira_name_ascii: "Beni Saf",
        wilaya_code: 46,
        wilaya_name: "عين تيموشنت",
        wilaya_name_ascii: "Aïn Témouchent"
    },
    {
        commune_name: "الحساسنة",
        commune_name_ascii: "Hassasna",
        daira_name: "حمام بوحجر",
        daira_name_ascii: "Hammam Bou Hadjar",
        wilaya_code: 46,
        wilaya_name: "عين تيموشنت",
        wilaya_name_ascii: "Aïn Témouchent"
    },
    {
        commune_name: "الأمير عبد القادر",
        commune_name_ascii: "Emir Abdelkader",
        daira_name: "بني صاف",
        daira_name_ascii: "Beni Saf",
        wilaya_code: 46,
        wilaya_name: "عين تيموشنت",
        wilaya_name_ascii: "Aïn Témouchent"
    },
    {
        commune_name: "سيدي صافي",
        commune_name_ascii: "Sidi Safi",
        daira_name: "بني صاف",
        daira_name_ascii: "Beni Saf",
        wilaya_code: 46,
        wilaya_name: "عين تيموشنت",
        wilaya_name_ascii: "Aïn Témouchent"
    },
    {
        commune_name: "ولهاصة الغرابة",
        commune_name_ascii: "Oulhaca El Gheraba",
        daira_name: "ولهاصة الغرابة",
        daira_name_ascii: "Oulhassa Gheraba",
        wilaya_code: 46,
        wilaya_name: "عين تيموشنت",
        wilaya_name_ascii: "Aïn Témouchent"
    },
    {
        commune_name: "سيدي ورياش",
        commune_name_ascii: "Sidi Ouriache",
        daira_name: "ولهاصة الغرابة",
        daira_name_ascii: "Oulhassa Gheraba",
        wilaya_code: 46,
        wilaya_name: "عين تيموشنت",
        wilaya_name_ascii: "Aïn Témouchent"
    },
    {
        commune_name: "عين الأربعاء",
        commune_name_ascii: "Ain El Arbaa",
        daira_name: "عين الأربعاء",
        daira_name_ascii: "Ain Larbaa",
        wilaya_code: 46,
        wilaya_name: "عين تيموشنت",
        wilaya_name_ascii: "Aïn Témouchent"
    },
    {
        commune_name: "المساعيد",
        commune_name_ascii: "El Messaid",
        daira_name: "العامرية",
        daira_name_ascii: "El Amria",
        wilaya_code: 46,
        wilaya_name: "عين تيموشنت",
        wilaya_name_ascii: "Aïn Témouchent"
    },
    {
        commune_name: "وادي برقش",
        commune_name_ascii: "Oued Berkeche",
        daira_name: "حمام بوحجر",
        daira_name_ascii: "Hammam Bou Hadjar",
        wilaya_code: 46,
        wilaya_name: "عين تيموشنت",
        wilaya_name_ascii: "Aïn Témouchent"
    },
    {
        commune_name: "سيدي بن عدة",
        commune_name_ascii: "Sidi Ben Adda",
        daira_name: "عين تموشنت",
        daira_name_ascii: "Ain Temouchent",
        wilaya_code: 46,
        wilaya_name: "عين تيموشنت",
        wilaya_name_ascii: "Aïn Témouchent"
    },
    {
        commune_name: "عين تموشنت",
        commune_name_ascii: "Ain Temouchent",
        daira_name: "عين تموشنت",
        daira_name_ascii: "Ain Temouchent",
        wilaya_code: 46,
        wilaya_name: "عين تيموشنت",
        wilaya_name_ascii: "Aïn Témouchent"
    },
    {
        commune_name: "بوزجار",
        commune_name_ascii: "Bouzedjar",
        daira_name: "العامرية",
        daira_name_ascii: "El Amria",
        wilaya_code: 46,
        wilaya_name: "عين تيموشنت",
        wilaya_name_ascii: "Aïn Témouchent"
    },
    {
        commune_name: "حمام بوحجر",
        commune_name_ascii: "Hammam Bou Hadjar",
        daira_name: "حمام بوحجر",
        daira_name_ascii: "Hammam Bou Hadjar",
        wilaya_code: 46,
        wilaya_name: "عين تيموشنت",
        wilaya_name_ascii: "Aïn Témouchent"
    },
    {
        commune_name: "ضاية بن ضحوة",
        commune_name_ascii: "Dhayet Bendhahoua",
        daira_name: "ضاية بن ضحوة",
        daira_name_ascii: "Dhayet Ben Dhahoua",
        wilaya_code: 47,
        wilaya_name: "غرداية",
        wilaya_name_ascii: "Ghardaïa"
    },
    {
        commune_name: "المنصورة",
        commune_name_ascii: "Mansoura",
        daira_name: "المنصورة",
        daira_name_ascii: "Mansourah",
        wilaya_code: 47,
        wilaya_name: "غرداية",
        wilaya_name_ascii: "Ghardaïa"
    },
    {
        commune_name: "العطف",
        commune_name_ascii: "El Atteuf",
        daira_name: "بونورة",
        daira_name_ascii: "Bounoura",
        wilaya_code: 47,
        wilaya_name: "غرداية",
        wilaya_name_ascii: "Ghardaïa"
    },
    {
        commune_name: "بونورة",
        commune_name_ascii: "Bounoura",
        daira_name: "بونورة",
        daira_name_ascii: "Bounoura",
        wilaya_code: 47,
        wilaya_name: "غرداية",
        wilaya_name_ascii: "Ghardaïa"
    },
    {
        commune_name: "زلفانة",
        commune_name_ascii: "Zelfana",
        daira_name: "زلفانة",
        daira_name_ascii: "Zelfana",
        wilaya_code: 47,
        wilaya_name: "غرداية",
        wilaya_name_ascii: "Ghardaïa"
    },
    {
        commune_name: "القرارة",
        commune_name_ascii: "El Guerrara",
        daira_name: "القرارة",
        daira_name_ascii: "El Guerrara",
        wilaya_code: 47,
        wilaya_name: "غرداية",
        wilaya_name_ascii: "Ghardaïa"
    },
    {
        commune_name: "سبسب",
        commune_name_ascii: "Sebseb",
        daira_name: "متليلي",
        daira_name_ascii: "Metlili",
        wilaya_code: 47,
        wilaya_name: "غرداية",
        wilaya_name_ascii: "Ghardaïa"
    },
    {
        commune_name: "متليلي",
        commune_name_ascii: "Metlili",
        daira_name: "متليلي",
        daira_name_ascii: "Metlili",
        wilaya_code: 47,
        wilaya_name: "غرداية",
        wilaya_name_ascii: "Ghardaïa"
    },
    {
        commune_name: "بريان",
        commune_name_ascii: "Berriane",
        daira_name: "بريان",
        daira_name_ascii: "Berriane",
        wilaya_code: 47,
        wilaya_name: "غرداية",
        wilaya_name_ascii: "Ghardaïa"
    },
    {
        commune_name: "غرداية",
        commune_name_ascii: "Ghardaia",
        daira_name: "غرداية",
        daira_name_ascii: "Ghardaia",
        wilaya_code: 47,
        wilaya_name: "غرداية",
        wilaya_name_ascii: "Ghardaïa"
    },
    {
        commune_name: "القطار",
        commune_name_ascii: "El-Guettar",
        daira_name: "مازونة",
        daira_name_ascii: "Mazouna",
        wilaya_code: 48,
        wilaya_name: "غليزان",
        wilaya_name_ascii: "Relizane"
    },
    {
        commune_name: "أولاد يعيش",
        commune_name_ascii: "Ouled Aiche",
        daira_name: "عمي موسى",
        daira_name_ascii: "Ammi Moussa",
        wilaya_code: 48,
        wilaya_name: "غليزان",
        wilaya_name_ascii: "Relizane"
    },
    {
        commune_name: "بني درقن",
        commune_name_ascii: "Beni Dergoun",
        daira_name: "زمورة",
        daira_name_ascii: "Zemmoura",
        wilaya_code: 48,
        wilaya_name: "غليزان",
        wilaya_name_ascii: "Relizane"
    },
    {
        commune_name: "دار بن عبد الله",
        commune_name_ascii: "Dar Ben Abdelah",
        daira_name: "زمورة",
        daira_name_ascii: "Zemmoura",
        wilaya_code: 48,
        wilaya_name: "غليزان",
        wilaya_name_ascii: "Relizane"
    },
    {
        commune_name: "زمورة",
        commune_name_ascii: "Zemmoura",
        daira_name: "زمورة",
        daira_name_ascii: "Zemmoura",
        wilaya_code: 48,
        wilaya_name: "غليزان",
        wilaya_name_ascii: "Relizane"
    },
    {
        commune_name: "جديوية",
        commune_name_ascii: "Djidiouia",
        daira_name: "جديوية",
        daira_name_ascii: "Djidiouia",
        wilaya_code: 48,
        wilaya_name: "غليزان",
        wilaya_name_ascii: "Relizane"
    },
    {
        commune_name: "حمري",
        commune_name_ascii: "Hamri",
        daira_name: "جديوية",
        daira_name_ascii: "Djidiouia",
        wilaya_code: 48,
        wilaya_name: "غليزان",
        wilaya_name_ascii: "Relizane"
    },
    {
        commune_name: "بلعسل بوزقزة",
        commune_name_ascii: "Belaassel Bouzagza",
        daira_name: "المطمر",
        daira_name_ascii: "El Matmar",
        wilaya_code: 48,
        wilaya_name: "غليزان",
        wilaya_name_ascii: "Relizane"
    },
    {
        commune_name: "المطمر",
        commune_name_ascii: "El-Matmar",
        daira_name: "المطمر",
        daira_name_ascii: "El Matmar",
        wilaya_code: 48,
        wilaya_name: "غليزان",
        wilaya_name_ascii: "Relizane"
    },
    {
        commune_name: "سيدي  خطاب",
        commune_name_ascii: "Sidi Khettab",
        daira_name: "المطمر",
        daira_name_ascii: "El Matmar",
        wilaya_code: 48,
        wilaya_name: "غليزان",
        wilaya_name_ascii: "Relizane"
    },
    {
        commune_name: "سيدي امحمد بن عودة",
        commune_name_ascii: "Sidi M'hamed Benaouda",
        daira_name: "المطمر",
        daira_name_ascii: "El Matmar",
        wilaya_code: 48,
        wilaya_name: "غليزان",
        wilaya_name_ascii: "Relizane"
    },
    {
        commune_name: "عين طارق",
        commune_name_ascii: "Ain-Tarek",
        daira_name: "عين طارق",
        daira_name_ascii: "Ain Tarek",
        wilaya_code: 48,
        wilaya_name: "غليزان",
        wilaya_name_ascii: "Relizane"
    },
    {
        commune_name: "حد الشكالة",
        commune_name_ascii: "Had Echkalla",
        daira_name: "عين طارق",
        daira_name_ascii: "Ain Tarek",
        wilaya_code: 48,
        wilaya_name: "غليزان",
        wilaya_name_ascii: "Relizane"
    },
    {
        commune_name: "الولجة",
        commune_name_ascii: "El Ouldja",
        daira_name: "عمي موسى",
        daira_name_ascii: "Ammi Moussa",
        wilaya_code: 48,
        wilaya_name: "غليزان",
        wilaya_name_ascii: "Relizane"
    },
    {
        commune_name: "مازونة",
        commune_name_ascii: "Mazouna",
        daira_name: "مازونة",
        daira_name_ascii: "Mazouna",
        wilaya_code: 48,
        wilaya_name: "غليزان",
        wilaya_name_ascii: "Relizane"
    },
    {
        commune_name: "عين الرحمة",
        commune_name_ascii: "Ain Rahma",
        daira_name: "يلل",
        daira_name_ascii: "Yellel",
        wilaya_code: 48,
        wilaya_name: "غليزان",
        wilaya_name_ascii: "Relizane"
    },
    {
        commune_name: "القلعة",
        commune_name_ascii: "Kalaa",
        daira_name: "يلل",
        daira_name_ascii: "Yellel",
        wilaya_code: 48,
        wilaya_name: "غليزان",
        wilaya_name_ascii: "Relizane"
    },
    {
        commune_name: "سيدي سعادة",
        commune_name_ascii: "Sidi Saada",
        daira_name: "يلل",
        daira_name_ascii: "Yellel",
        wilaya_code: 48,
        wilaya_name: "غليزان",
        wilaya_name_ascii: "Relizane"
    },
    {
        commune_name: "يلل",
        commune_name_ascii: "Yellel",
        daira_name: "يلل",
        daira_name_ascii: "Yellel",
        wilaya_code: 48,
        wilaya_name: "غليزان",
        wilaya_name_ascii: "Relizane"
    },
    {
        commune_name: "سوق الحد",
        commune_name_ascii: "Souk El Had",
        daira_name: "الرمكة",
        daira_name_ascii: "Ramka",
        wilaya_code: 48,
        wilaya_name: "غليزان",
        wilaya_name_ascii: "Relizane"
    },
    {
        commune_name: "منداس",
        commune_name_ascii: "Mendes",
        daira_name: "منداس",
        daira_name_ascii: "Mendes",
        wilaya_code: 48,
        wilaya_name: "غليزان",
        wilaya_name_ascii: "Relizane"
    },
    {
        commune_name: "وادي السلام",
        commune_name_ascii: "Oued Essalem",
        daira_name: "منداس",
        daira_name_ascii: "Mendes",
        wilaya_code: 48,
        wilaya_name: "غليزان",
        wilaya_name_ascii: "Relizane"
    },
    {
        commune_name: "سيدي لزرق",
        commune_name_ascii: "Sidi Lazreg",
        daira_name: "منداس",
        daira_name_ascii: "Mendes",
        wilaya_code: 48,
        wilaya_name: "غليزان",
        wilaya_name_ascii: "Relizane"
    },
    {
        commune_name: "عمي موسى",
        commune_name_ascii: "Ammi Moussa",
        daira_name: "عمي موسى",
        daira_name_ascii: "Ammi Moussa",
        wilaya_code: 48,
        wilaya_name: "غليزان",
        wilaya_name_ascii: "Relizane"
    },
    {
        commune_name: "واريزان",
        commune_name_ascii: "Ouarizane",
        daira_name: "وادي رهيو",
        daira_name_ascii: "Oued Rhiou",
        wilaya_code: 48,
        wilaya_name: "غليزان",
        wilaya_name_ascii: "Relizane"
    },
    {
        commune_name: "مرجة سيدي عابد",
        commune_name_ascii: "Merdja Sidi Abed",
        daira_name: "وادي رهيو",
        daira_name_ascii: "Oued Rhiou",
        wilaya_code: 48,
        wilaya_name: "غليزان",
        wilaya_name_ascii: "Relizane"
    },
    {
        commune_name: "أولاد سيدي الميهوب",
        commune_name_ascii: "Ouled Sidi Mihoub",
        daira_name: "جديوية",
        daira_name_ascii: "Djidiouia",
        wilaya_code: 48,
        wilaya_name: "غليزان",
        wilaya_name_ascii: "Relizane"
    },
    {
        commune_name: "بن داود",
        commune_name_ascii: "Bendaoud",
        daira_name: "غليزان",
        daira_name_ascii: "Relizane",
        wilaya_code: 48,
        wilaya_name: "غليزان",
        wilaya_name_ascii: "Relizane"
    },
    {
        commune_name: "وادي رهيو",
        commune_name_ascii: "Oued-Rhiou",
        daira_name: "وادي رهيو",
        daira_name_ascii: "Oued Rhiou",
        wilaya_code: 48,
        wilaya_name: "غليزان",
        wilaya_name_ascii: "Relizane"
    },
    {
        commune_name: "الحاسي",
        commune_name_ascii: "El Hassi",
        daira_name: "عمي موسى",
        daira_name_ascii: "Ammi Moussa",
        wilaya_code: 48,
        wilaya_name: "غليزان",
        wilaya_name_ascii: "Relizane"
    },
    {
        commune_name: "سيدي أمحمد بن علي",
        commune_name_ascii: "Sidi M'hamed Benali",
        daira_name: "سيدي أمحمد بن علي",
        daira_name_ascii: "Sidi M'hamed Ben Ali",
        wilaya_code: 48,
        wilaya_name: "غليزان",
        wilaya_name_ascii: "Relizane"
    },
    {
        commune_name: "مديونة",
        commune_name_ascii: "Mediouna",
        daira_name: "سيدي أمحمد بن علي",
        daira_name_ascii: "Sidi M'hamed Ben Ali",
        wilaya_code: 48,
        wilaya_name: "غليزان",
        wilaya_name_ascii: "Relizane"
    },
    {
        commune_name: "بني زنطيس",
        commune_name_ascii: "Beni Zentis",
        daira_name: "سيدي أمحمد بن علي",
        daira_name_ascii: "Sidi M'hamed Ben Ali",
        wilaya_code: 48,
        wilaya_name: "غليزان",
        wilaya_name_ascii: "Relizane"
    },
    {
        commune_name: "وادي الجمعة",
        commune_name_ascii: "Oued El Djemaa",
        daira_name: "الحمادنة",
        daira_name_ascii: "El H'madna",
        wilaya_code: 48,
        wilaya_name: "غليزان",
        wilaya_name_ascii: "Relizane"
    },
    {
        commune_name: "لحلاف",
        commune_name_ascii: "Lahlef",
        daira_name: "وادي رهيو",
        daira_name_ascii: "Oued Rhiou",
        wilaya_code: 48,
        wilaya_name: "غليزان",
        wilaya_name_ascii: "Relizane"
    },
    {
        commune_name: "غليزان",
        commune_name_ascii: "Relizane",
        daira_name: "غليزان",
        daira_name_ascii: "Relizane",
        wilaya_code: 48,
        wilaya_name: "غليزان",
        wilaya_name_ascii: "Relizane"
    },
    {
        commune_name: "الحمادنة",
        commune_name_ascii: "El H'madna",
        daira_name: "الحمادنة",
        daira_name_ascii: "El H'madna",
        wilaya_code: 48,
        wilaya_name: "غليزان",
        wilaya_name_ascii: "Relizane"
    },
    {
        commune_name: "الرمكة",
        commune_name_ascii: "Ramka",
        daira_name: "الرمكة",
        daira_name_ascii: "Ramka",
        wilaya_code: 48,
        wilaya_name: "غليزان",
        wilaya_name_ascii: "Relizane"
    },
    {
        commune_name: "تنركوك",
        commune_name_ascii: "Tinerkouk",
        daira_name: "تنركوك",
        daira_name_ascii: "Tinerkouk",
        wilaya_code: 49,
        wilaya_name: "تيميمون",
        wilaya_name_ascii: "Timimoun"
    },
    {
        commune_name: "تيميمون",
        commune_name_ascii: "Timimoun",
        daira_name: "تيميمون",
        daira_name_ascii: "Timimoun",
        wilaya_code: 49,
        wilaya_name: "تيميمون",
        wilaya_name_ascii: "Timimoun"
    },
    {
        commune_name: "أولاد السعيد",
        commune_name_ascii: "Ouled Said",
        daira_name: "تيميمون",
        daira_name_ascii: "Timimoun",
        wilaya_code: 49,
        wilaya_name: "تيميمون",
        wilaya_name_ascii: "Timimoun"
    },
    {
        commune_name: "المطارفة",
        commune_name_ascii: "Metarfa",
        daira_name: "أوقروت",
        daira_name_ascii: "Aougrout",
        wilaya_code: 49,
        wilaya_name: "تيميمون",
        wilaya_name_ascii: "Timimoun"
    },
    {
        commune_name: "طالمين",
        commune_name_ascii: "Talmine",
        daira_name: "شروين",
        daira_name_ascii: "Charouine",
        wilaya_code: 49,
        wilaya_name: "تيميمون",
        wilaya_name_ascii: "Timimoun"
    },
    {
        commune_name: "أولاد عيسى",
        commune_name_ascii: "Ouled Aissa",
        daira_name: "شروين",
        daira_name_ascii: "Charouine",
        wilaya_code: 49,
        wilaya_name: "تيميمون",
        wilaya_name_ascii: "Timimoun"
    },
    {
        commune_name: "شروين",
        commune_name_ascii: "Charouine",
        daira_name: "شروين",
        daira_name_ascii: "Charouine",
        wilaya_code: 49,
        wilaya_name: "تيميمون",
        wilaya_name_ascii: "Timimoun"
    },
    {
        commune_name: "أوقروت",
        commune_name_ascii: "Aougrout",
        daira_name: "أوقروت",
        daira_name_ascii: "Aougrout",
        wilaya_code: 49,
        wilaya_name: "تيميمون",
        wilaya_name_ascii: "Timimoun"
    },
    {
        commune_name: "دلدول",
        commune_name_ascii: "Deldoul",
        daira_name: "أوقروت",
        daira_name_ascii: "Aougrout",
        wilaya_code: 49,
        wilaya_name: "تيميمون",
        wilaya_name_ascii: "Timimoun"
    },
    {
        commune_name: "قصر قدور",
        commune_name_ascii: "Ksar Kaddour",
        daira_name: "تنركوك",
        daira_name_ascii: "Tinerkouk",
        wilaya_code: 49,
        wilaya_name: "تيميمون",
        wilaya_name_ascii: "Timimoun"
    },
    {
        commune_name: "تيمياوين",
        commune_name_ascii: "Timiaouine",
        daira_name: "برج باجي مختار",
        daira_name_ascii: "Bordj Badji Mokhtar",
        wilaya_code: 50,
        wilaya_name: "برج باجي مختار",
        wilaya_name_ascii: "Bordj Badji Mokhtar"
    },
    {
        commune_name: "برج باجي مختار",
        commune_name_ascii: "Bordj Badji Mokhtar",
        daira_name: "برج باجي مختار",
        daira_name_ascii: "Bordj Badji Mokhtar",
        wilaya_code: 50,
        wilaya_name: "برج باجي مختار",
        wilaya_name_ascii: "Bordj Badji Mokhtar"
    },
    {
        commune_name: "رأس الميعاد",
        commune_name_ascii: "Ras El Miad",
        daira_name: "سيدي  خالد",
        daira_name_ascii: "Sidi Khaled",
        wilaya_code: 51,
        wilaya_name: "أولاد جلال",
        wilaya_name_ascii: "Ouled Djellal"
    },
    {
        commune_name: "بسباس",
        commune_name_ascii: "Besbes",
        daira_name: "سيدي  خالد",
        daira_name_ascii: "Sidi Khaled",
        wilaya_code: 51,
        wilaya_name: "أولاد جلال",
        wilaya_name_ascii: "Ouled Djellal"
    },
    {
        commune_name: "سيدي  خالد",
        commune_name_ascii: "Sidi Khaled",
        daira_name: "سيدي  خالد",
        daira_name_ascii: "Sidi Khaled",
        wilaya_code: 51,
        wilaya_name: "أولاد جلال",
        wilaya_name_ascii: "Ouled Djellal"
    },
    {
        commune_name: "الدوسن",
        commune_name_ascii: "Doucen",
        daira_name: "أولاد جلال",
        daira_name_ascii: "Ouled Djellal",
        wilaya_code: 51,
        wilaya_name: "أولاد جلال",
        wilaya_name_ascii: "Ouled Djellal"
    },
    {
        commune_name: "الشعيبة",
        commune_name_ascii: "Chaiba",
        daira_name: "أولاد جلال",
        daira_name_ascii: "Ouled Djellal",
        wilaya_code: 51,
        wilaya_name: "أولاد جلال",
        wilaya_name_ascii: "Ouled Djellal"
    },
    {
        commune_name: "أولاد جلال",
        commune_name_ascii: "Ouled Djellal",
        daira_name: "أولاد جلال",
        daira_name_ascii: "Ouled Djellal",
        wilaya_code: 51,
        wilaya_name: "أولاد جلال",
        wilaya_name_ascii: "Ouled Djellal"
    },
    {
        commune_name: "بني عباس",
        commune_name_ascii: "Beni-Abbes",
        daira_name: "بني عباس",
        daira_name_ascii: "Beni Abbes",
        wilaya_code: 52,
        wilaya_name: "بني عباس",
        wilaya_name_ascii: "Béni Abbès"
    },
    {
        commune_name: "تامترت",
        commune_name_ascii: "Tamtert",
        daira_name: "بني عباس",
        daira_name_ascii: "Beni Abbes",
        wilaya_code: 52,
        wilaya_name: "بني عباس",
        wilaya_name_ascii: "Béni Abbès"
    },
    {
        commune_name: "إقلي",
        commune_name_ascii: "Igli",
        daira_name: "إقلي",
        daira_name_ascii: "Igli",
        wilaya_code: 52,
        wilaya_name: "بني عباس",
        wilaya_name_ascii: "Béni Abbès"
    },
    {
        commune_name: "الواتة",
        commune_name_ascii: "El Ouata",
        daira_name: "الواتة",
        daira_name_ascii: "El Ouata",
        wilaya_code: 52,
        wilaya_name: "بني عباس",
        wilaya_name_ascii: "Béni Abbès"
    },
    {
        commune_name: "أولاد خضير",
        commune_name_ascii: "Ouled-Khodeir",
        daira_name: "أولاد خضير",
        daira_name_ascii: "Ouled Khodeir",
        wilaya_code: 52,
        wilaya_name: "بني عباس",
        wilaya_name_ascii: "Béni Abbès"
    },
    {
        commune_name: "كرزاز",
        commune_name_ascii: "Kerzaz",
        daira_name: "كرزاز",
        daira_name_ascii: "Kerzaz",
        wilaya_code: 52,
        wilaya_name: "بني عباس",
        wilaya_name_ascii: "Béni Abbès"
    },
    {
        commune_name: "تيمودي",
        commune_name_ascii: "Timoudi",
        daira_name: "كرزاز",
        daira_name_ascii: "Kerzaz",
        wilaya_code: 52,
        wilaya_name: "بني عباس",
        wilaya_name_ascii: "Béni Abbès"
    },
    {
        commune_name: "القصابي",
        commune_name_ascii: "Ksabi",
        daira_name: "أولاد خضير",
        daira_name_ascii: "Ouled Khodeir",
        wilaya_code: 52,
        wilaya_name: "بني عباس",
        wilaya_name_ascii: "Béni Abbès"
    },
    {
        commune_name: "بن يخلف",
        commune_name_ascii: "Beni-Ikhlef",
        daira_name: "كرزاز",
        daira_name_ascii: "Kerzaz",
        wilaya_code: 52,
        wilaya_name: "بني عباس",
        wilaya_name_ascii: "Béni Abbès"
    },
    {
        commune_name: "إينغر",
        commune_name_ascii: "Inghar",
        daira_name: "إينغر",
        daira_name_ascii: "In Ghar",
        wilaya_code: 53,
        wilaya_name: "عين صالح",
        wilaya_name_ascii: "In Salah"
    },
    {
        commune_name: "عين صالح",
        commune_name_ascii: "Ain Salah",
        daira_name: "عين صالح",
        daira_name_ascii: "In Salah",
        wilaya_code: 53,
        wilaya_name: "عين صالح",
        wilaya_name_ascii: "In Salah"
    },
    {
        commune_name: "فقارة الزوى",
        commune_name_ascii: "Foggaret Ezzoua",
        daira_name: "عين صالح",
        daira_name_ascii: "In Salah",
        wilaya_code: 53,
        wilaya_name: "عين صالح",
        wilaya_name_ascii: "In Salah"
    },
    {
        commune_name: "تين زواتين",
        commune_name_ascii: "Tin Zouatine",
        daira_name: "تين زواتين",
        daira_name_ascii: "Tin Zouatine",
        wilaya_code: 54,
        wilaya_name: "عين قزام",
        wilaya_name_ascii: "In Guezzam"
    },
    {
        commune_name: "عين قزام",
        commune_name_ascii: "Ain Guezzam",
        daira_name: "عين قزام",
        daira_name_ascii: "In Guezzam",
        wilaya_code: 54,
        wilaya_name: "عين قزام",
        wilaya_name_ascii: "In Guezzam"
    },
    {
        commune_name: "تماسين",
        commune_name_ascii: "Temacine",
        daira_name: "تماسين",
        daira_name_ascii: "Temacine",
        wilaya_code: 55,
        wilaya_name: "تقرت",
        wilaya_name_ascii: "Touggourt"
    },
    {
        commune_name: "سيدي سليمان",
        commune_name_ascii: "Sidi Slimane",
        daira_name: "المقارين",
        daira_name_ascii: "Megarine",
        wilaya_code: 55,
        wilaya_name: "تقرت",
        wilaya_name_ascii: "Touggourt"
    },
    {
        commune_name: "المقارين",
        commune_name_ascii: "Megarine",
        daira_name: "المقارين",
        daira_name_ascii: "Megarine",
        wilaya_code: 55,
        wilaya_name: "تقرت",
        wilaya_name_ascii: "Touggourt"
    },
    {
        commune_name: "النزلة",
        commune_name_ascii: "Nezla",
        daira_name: "تقرت",
        daira_name_ascii: "Touggourt",
        wilaya_code: 55,
        wilaya_name: "تقرت",
        wilaya_name_ascii: "Touggourt"
    },
    {
        commune_name: "بلدة اعمر",
        commune_name_ascii: "Blidet Amor",
        daira_name: "تماسين",
        daira_name_ascii: "Temacine",
        wilaya_code: 55,
        wilaya_name: "تقرت",
        wilaya_name_ascii: "Touggourt"
    },
    {
        commune_name: "تبسبست",
        commune_name_ascii: "Tebesbest",
        daira_name: "تقرت",
        daira_name_ascii: "Touggourt",
        wilaya_code: 55,
        wilaya_name: "تقرت",
        wilaya_name_ascii: "Touggourt"
    },
    {
        commune_name: "تقرت",
        commune_name_ascii: "Touggourt",
        daira_name: "تقرت",
        daira_name_ascii: "Touggourt",
        wilaya_code: 55,
        wilaya_name: "تقرت",
        wilaya_name_ascii: "Touggourt"
    },
    {
        commune_name: "الطيبات",
        commune_name_ascii: "Taibet",
        daira_name: "الطيبات",
        daira_name_ascii: "Taibet",
        wilaya_code: 55,
        wilaya_name: "تقرت",
        wilaya_name_ascii: "Touggourt"
    },
    {
        commune_name: "العالية",
        commune_name_ascii: "El Alia",
        daira_name: "الحجيرة",
        daira_name_ascii: "El-Hadjira",
        wilaya_code: 55,
        wilaya_name: "تقرت",
        wilaya_name_ascii: "Touggourt"
    },
    {
        commune_name: "الحجيرة",
        commune_name_ascii: "El-Hadjira",
        daira_name: "الحجيرة",
        daira_name_ascii: "El-Hadjira",
        wilaya_code: 55,
        wilaya_name: "تقرت",
        wilaya_name_ascii: "Touggourt"
    },
    {
        commune_name: "بن ناصر",
        commune_name_ascii: "Benaceur",
        daira_name: "الطيبات",
        daira_name_ascii: "Taibet",
        wilaya_code: 55,
        wilaya_name: "تقرت",
        wilaya_name_ascii: "Touggourt"
    },
    {
        commune_name: "المنقر",
        commune_name_ascii: "M'naguer",
        daira_name: "الطيبات",
        daira_name_ascii: "Taibet",
        wilaya_code: 55,
        wilaya_name: "تقرت",
        wilaya_name_ascii: "Touggourt"
    },
    {
        commune_name: "الزاوية العابدية",
        commune_name_ascii: "Zaouia El Abidia",
        daira_name: "تقرت",
        daira_name_ascii: "Touggourt",
        wilaya_code: 55,
        wilaya_name: "تقرت",
        wilaya_name_ascii: "Touggourt"
    },
    {
        commune_name: "جانت",
        commune_name_ascii: "Djanet",
        daira_name: "جانت",
        daira_name_ascii: "Djanet",
        wilaya_code: 56,
        wilaya_name: "جانت",
        wilaya_name_ascii: "Djanet"
    },
    {
        commune_name: "برج الحواس",
        commune_name_ascii: "Bordj El Haouass",
        daira_name: "جانت",
        daira_name_ascii: "Djanet",
        wilaya_code: 56,
        wilaya_name: "جانت",
        wilaya_name_ascii: "Djanet"
    },
    {
        commune_name: "أم الطيور",
        commune_name_ascii: "Oum Touyour",
        daira_name: "المغير",
        daira_name_ascii: "El Meghaier",
        wilaya_code: 57,
        wilaya_name: "المغير",
        wilaya_name_ascii: "El Meghaier"
    },
    {
        commune_name: "سيدي عمران",
        commune_name_ascii: "Sidi Amrane",
        daira_name: "جامعة",
        daira_name_ascii: "Djamaa",
        wilaya_code: 57,
        wilaya_name: "المغير",
        wilaya_name_ascii: "El Meghaier"
    },
    {
        commune_name: "المرارة",
        commune_name_ascii: "M'rara",
        daira_name: "جامعة",
        daira_name_ascii: "Djamaa",
        wilaya_code: 57,
        wilaya_name: "المغير",
        wilaya_name_ascii: "El Meghaier"
    },
    {
        commune_name: "جامعة",
        commune_name_ascii: "Djamaa",
        daira_name: "جامعة",
        daira_name_ascii: "Djamaa",
        wilaya_code: 57,
        wilaya_name: "المغير",
        wilaya_name_ascii: "El Meghaier"
    },
    {
        commune_name: "تندلة",
        commune_name_ascii: "Tenedla",
        daira_name: "جامعة",
        daira_name_ascii: "Djamaa",
        wilaya_code: 57,
        wilaya_name: "المغير",
        wilaya_name_ascii: "El Meghaier"
    },
    {
        commune_name: "المغير",
        commune_name_ascii: "El-M'ghaier",
        daira_name: "المغير",
        daira_name_ascii: "El Meghaier",
        wilaya_code: 57,
        wilaya_name: "المغير",
        wilaya_name_ascii: "El Meghaier"
    },
    {
        commune_name: "سطيل",
        commune_name_ascii: "Still",
        daira_name: "المغير",
        daira_name_ascii: "El Meghaier",
        wilaya_code: 57,
        wilaya_name: "المغير",
        wilaya_name_ascii: "El Meghaier"
    },
    {
        commune_name: "سيدي خليل",
        commune_name_ascii: "Sidi Khelil",
        daira_name: "المغير",
        daira_name_ascii: "El Meghaier",
        wilaya_code: 57,
        wilaya_name: "المغير",
        wilaya_name_ascii: "El Meghaier"
    },
    {
        commune_name: "المنيعة",
        commune_name_ascii: "El Meniaa",
        daira_name: "المنيعة",
        daira_name_ascii: "El Menia",
        wilaya_code: 58,
        wilaya_name: "المنيعة",
        wilaya_name_ascii: "El Menia"
    },
    {
        commune_name: "حاسي القارة",
        commune_name_ascii: "Hassi Gara",
        daira_name: "المنيعة",
        daira_name_ascii: "El Menia",
        wilaya_code: 58,
        wilaya_name: "المنيعة",
        wilaya_name_ascii: "El Menia"
    },
    {
        commune_name: "حاسي الفحل",
        commune_name_ascii: "Hassi Fehal",
        daira_name: "المنصورة",
        daira_name_ascii: "Mansourah",
        wilaya_code: 58,
        wilaya_name: "المنيعة",
        wilaya_name_ascii: "El Menia"
    },
];
